export const dummyData_allBulk = [
  {
    key: 1,
    sr_no: 1,
    first_name: "Vatsal",
    middle_name: "",
    last_name: "Panthri",
    mobile_number: "7208345988",
    email: "vatsal.panthri@gmail.com",
    registration_number: "Cand:1021662",
    employee_code: "6339215",
    joining_date: "21-04-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  {
    key: 2,
    sr_no: 2,
    first_name: "Krishna",
    middle_name: "",
    last_name: "Tiwari",
    mobile_number: "9535089498",
    email: "krishna.tiwari@gmail.com",
    registration_number: "Cand:1083909",
    employee_code: "6339216",
    joining_date: "21-04-2026",
    employee_type: "Contract",
    status: "Valid",
  },
  {
    key: 3,
    sr_no: 3,
    first_name: "Sudhanshu",
    middle_name: "Kumar",
    last_name: "",
    mobile_number: "9310283583",
    email: "sudhanshu504@gmail.com",
    registration_number: "Cand:1070919",
    employee_code: "6339262",
    joining_date: "21-04-2026",
    employee_type: "Intern",
    status: "Valid",
  },
  {
    key: 4,
    sr_no: 4,
    first_name: "Raunak",
    middle_name: "",
    last_name: "Chaubey",
    mobile_number: "8810812983",
    email: "chaubeyraunak88@gmail.com",
    registration_number: "Cand:1058957",
    employee_code: "6335737",
    joining_date: "20-04-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  // --- DUPLICATE PAIR 1: same mobile_number as key 6 ---
  {
    key: 5,
    sr_no: 5,
    first_name: "Aman",
    middle_name: "",
    last_name: "Sharma",
    mobile_number: "9123456780",
    email: "aman.sharma@gmail.com",
    registration_number: "Cand:1098765",
    employee_code: "6339901",
    joining_date: "18-04-2026",
    employee_type: "Contract",
    status: "Duplicate",
  },
  {
    key: 6,
    sr_no: 6,
    first_name: "Priya",
    middle_name: "",
    last_name: "Verma",
    mobile_number: "9123456780", // same as key 5
    email: "priya.verma@gmail.com",
    registration_number: "Cand:1102456",
    employee_code: "6340011",
    joining_date: "19-04-2026",
    employee_type: "Full Time",
    status: "Duplicate",
  },
  {
    key: 7,
    sr_no: 7,
    first_name: "Rohit",
    middle_name: "",
    last_name: "Gupta",
    mobile_number: "9876501234",
    email: "rohit.gupta@gmail.com",
    registration_number: "Cand:1045678",
    employee_code: "6340102",
    joining_date: "17-04-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  // --- INVALID: mobile missing ---
  {
    key: 8,
    sr_no: 8,
    first_name: "Sneha",
    middle_name: "Rani",
    last_name: "Mishra",
    mobile_number: "",
    email: "sneha.mishra@gmail.com",
    registration_number: "Cand:1067890",
    employee_code: "6340203",
    joining_date: "16-04-2026",
    employee_type: "Intern",
    status: "Invalid",
  },
  {
    key: 9,
    sr_no: 9,
    first_name: "Arjun",
    middle_name: "",
    last_name: "Singh",
    mobile_number: "9988776655",
    email: "arjun.singh@gmail.com",
    registration_number: "Cand:1034567",
    employee_code: "6340304",
    joining_date: "15-04-2026",
    employee_type: "Contract",
    status: "Valid",
  },
  // --- DUPLICATE PAIR 2: same email as key 12 ---
  {
    key: 10,
    sr_no: 10,
    first_name: "Meera",
    middle_name: "",
    last_name: "Nair",
    mobile_number: "8877665544",
    email: "shared.email@gmail.com",
    registration_number: "Cand:1023456",
    employee_code: "6340405",
    joining_date: "14-04-2026",
    employee_type: "Full Time",
    status: "Duplicate",
  },
  {
    key: 11,
    sr_no: 11,
    first_name: "Vikram",
    middle_name: "",
    last_name: "Yadav",
    mobile_number: "7766554433",
    email: "vikram.yadav@gmail.com",
    registration_number: "Cand:1089012",
    employee_code: "6340506",
    joining_date: "13-04-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  {
    key: 12,
    sr_no: 12,
    first_name: "Pooja",
    middle_name: "Devi",
    last_name: "Joshi",
    mobile_number: "9345678901",
    email: "shared.email@gmail.com", // same as key 10
    registration_number: "Cand:1078901",
    employee_code: "6340607",
    joining_date: "12-04-2026",
    employee_type: "Contract",
    status: "Duplicate",
  },
  {
    key: 13,
    sr_no: 13,
    first_name: "Rahul",
    middle_name: "",
    last_name: "Mehta",
    mobile_number: "9654321098",
    email: "rahul.mehta@gmail.com",
    registration_number: "Cand:1056789",
    employee_code: "6340708",
    joining_date: "11-04-2026",
    employee_type: "Intern",
    status: "Valid",
  },
  // --- INVALID: mobile missing ---
  {
    key: 14,
    sr_no: 14,
    first_name: "Ananya",
    middle_name: "",
    last_name: "Patel",
    mobile_number: "",
    email: "ananya.patel@gmail.com",
    registration_number: "Cand:1045670",
    employee_code: "6340809",
    joining_date: "10-04-2026",
    employee_type: "Full Time",
    status: "Invalid",
  },
  {
    key: 15,
    sr_no: 15,
    first_name: "Nikhil",
    middle_name: "",
    last_name: "Bose",
    mobile_number: "7432109876",
    email: "nikhil.bose@gmail.com",
    registration_number: "Cand:1034561",
    employee_code: "6340910",
    joining_date: "09-04-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  // --- INVALID: mobile missing ---
  {
    key: 16,
    sr_no: 16,
    first_name: "Divya",
    middle_name: "",
    last_name: "Iyer",
    mobile_number: "",
    email: "divya.iyer@gmail.com",
    registration_number: "Cand:1023452",
    employee_code: "6341011",
    joining_date: "08-04-2026",
    employee_type: "Contract",
    status: "Invalid",
  },
  {
    key: 17,
    sr_no: 17,
    first_name: "Saurabh",
    middle_name: "Kumar",
    last_name: "Pandey",
    mobile_number: "9321098765",
    email: "saurabh.pandey@gmail.com",
    registration_number: "Cand:1089023",
    employee_code: "6341112",
    joining_date: "07-04-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  // --- DUPLICATE PAIR 3: same mobile_number as key 20 ---
  {
    key: 18,
    sr_no: 18,
    first_name: "Kavya",
    middle_name: "",
    last_name: "Reddy",
    mobile_number: "8011223344",
    email: "kavya.reddy@gmail.com",
    registration_number: "Cand:1078912",
    employee_code: "6341213",
    joining_date: "06-04-2026",
    employee_type: "Intern",
    status: "Duplicate",
  },
  {
    key: 19,
    sr_no: 19,
    first_name: "Manish",
    middle_name: "",
    last_name: "Dubey",
    mobile_number: "7109876543",
    email: "manish.dubey@gmail.com",
    registration_number: "Cand:1056790",
    employee_code: "6341314",
    joining_date: "05-04-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  {
    key: 20,
    sr_no: 20,
    first_name: "Riya",
    middle_name: "",
    last_name: "Shah",
    mobile_number: "8011223344", // same as key 18
    email: "riya.shah@gmail.com",
    registration_number: "Cand:1045681",
    employee_code: "6341415",
    joining_date: "04-04-2026",
    employee_type: "Contract",
    status: "Duplicate",
  },
  {
    key: 21,
    sr_no: 21,
    first_name: "Abhishek",
    middle_name: "",
    last_name: "Jain",
    mobile_number: "9098765432",
    email: "abhishek.jain@gmail.com",
    registration_number: "Cand:1034572",
    employee_code: "6341516",
    joining_date: "03-04-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  // --- INVALID: mobile missing ---
  {
    key: 22,
    sr_no: 22,
    first_name: "Shreya",
    middle_name: "",
    last_name: "Kapoor",
    mobile_number: "",
    email: "shreya.kapoor@gmail.com",
    registration_number: "Cand:1023463",
    employee_code: "6341617",
    joining_date: "02-04-2026",
    employee_type: "Full Time",
    status: "Invalid",
  },
  {
    key: 23,
    sr_no: 23,
    first_name: "Gaurav",
    middle_name: "Raj",
    last_name: "Shukla",
    mobile_number: "7876543210",
    email: "gaurav.shukla@gmail.com",
    registration_number: "Cand:1089034",
    employee_code: "6341718",
    joining_date: "01-04-2026",
    employee_type: "Intern",
    status: "Valid",
  },
  // --- INVALID: mobile missing ---
  {
    key: 24,
    sr_no: 24,
    first_name: "Tanvi",
    middle_name: "",
    last_name: "Malhotra",
    mobile_number: "",
    email: "tanvi.malhotra@gmail.com",
    registration_number: "Cand:1078923",
    employee_code: "6341819",
    joining_date: "31-03-2026",
    employee_type: "Full Time",
    status: "Invalid",
  },
  {
    key: 25,
    sr_no: 25,
    first_name: "Harsh",
    middle_name: "",
    last_name: "Agarwal",
    mobile_number: "9765432109",
    email: "harsh.agarwal@gmail.com",
    registration_number: "Cand:1056801",
    employee_code: "6341920",
    joining_date: "30-03-2026",
    employee_type: "Contract",
    status: "Valid",
  },
  // --- DUPLICATE PAIR 4: same email as key 28 ---
  {
    key: 26,
    sr_no: 26,
    first_name: "Nisha",
    middle_name: "",
    last_name: "Pillai",
    mobile_number: "8654321098",
    email: "nisha@gmail.com",
    registration_number: "Cand:1045692",
    employee_code: "6342021",
    joining_date: "29-03-2026",
    employee_type: "Full Time",
    status: "Duplicate",
  },
  {
    key: 27,
    sr_no: 27,
    first_name: "Deepak",
    middle_name: "",
    last_name: "Chauhan",
    mobile_number: "7543210987",
    email: "deepak.chauhan@gmail.com",
    registration_number: "Cand:1034583",
    employee_code: "6342122",
    joining_date: "28-03-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  {
    key: 28,
    sr_no: 28,
    first_name: "Prachi",
    middle_name: "",
    last_name: "Srivastava",
    mobile_number: "9234567890",
    email: "nisha@gmail.com", // same as key 26
    registration_number: "Cand:1023474",
    employee_code: "6342223",
    joining_date: "27-03-2026",
    employee_type: "Contract",
    status: "Duplicate",
  },
  {
    key: 29,
    sr_no: 29,
    first_name: "Yash",
    middle_name: "",
    last_name: "Bhatt",
    mobile_number: "9432109876",
    email: "yash.bhatt@gmail.com",
    registration_number: "Cand:1089045",
    employee_code: "6342324",
    joining_date: "26-03-2026",
    employee_type: "Intern",
    status: "Valid",
  },
  {
    key: 30,
    sr_no: 30,
    first_name: "Simran",
    middle_name: "",
    last_name: "Kaur",
    mobile_number: "8321098765",
    email: "simran.kaur@gmail.com",
    registration_number: "Cand:1078934",
    employee_code: "6342425",
    joining_date: "25-03-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  // --- DUPLICATE PAIR 5: same mobile_number as key 34 ---
  {
    key: 31,
    sr_no: 31,
    first_name: "Kartik",
    middle_name: "",
    last_name: "Rastogi",
    mobile_number: "9900112233",
    email: "kartik.rastogi@gmail.com",
    registration_number: "Cand:1056812",
    employee_code: "6342526",
    joining_date: "24-03-2026",
    employee_type: "Full Time",
    status: "Duplicate",
  },
  // --- INVALID: mobile missing ---
  {
    key: 32,
    sr_no: 32,
    first_name: "Bhavna",
    middle_name: "",
    last_name: "Saxena",
    mobile_number: "",
    email: "bhavna.saxena@gmail.com",
    registration_number: "Cand:1045703",
    employee_code: "6342627",
    joining_date: "23-03-2026",
    employee_type: "Contract",
    status: "Invalid",
  },
  {
    key: 33,
    sr_no: 33,
    first_name: "Rajat",
    middle_name: "Mohan",
    last_name: "Kulkarni",
    mobile_number: "7109875432",
    email: "rajat.kulkarni@gmail.com",
    registration_number: "Cand:1034594",
    employee_code: "6342728",
    joining_date: "22-03-2026",
    employee_type: "Intern",
    status: "Valid",
  },
  {
    key: 34,
    sr_no: 34,
    first_name: "Ishita",
    middle_name: "",
    last_name: "Banerjee",
    mobile_number: "9900112233", // same as key 31
    email: "ishita.banerjee@gmail.com",
    registration_number: "Cand:1023485",
    employee_code: "6342829",
    joining_date: "21-03-2026",
    employee_type: "Full Time",
    status: "Duplicate",
  },
  {
    key: 35,
    sr_no: 35,
    first_name: "Aditya",
    middle_name: "",
    last_name: "Thakur",
    mobile_number: "9887766554",
    email: "aditya.thakur@gmail.com",
    registration_number: "Cand:1089056",
    employee_code: "6342930",
    joining_date: "20-03-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  // --- INVALID: mobile missing ---
  {
    key: 36,
    sr_no: 36,
    first_name: "Neha",
    middle_name: "",
    last_name: "Goswami",
    mobile_number: "",
    email: "neha.goswami@gmail.com",
    registration_number: "Cand:1078945",
    employee_code: "6343031",
    joining_date: "19-03-2026",
    employee_type: "Contract",
    status: "Invalid",
  },
  {
    key: 37,
    sr_no: 37,
    first_name: "Siddharth",
    middle_name: "",
    last_name: "Menon",
    mobile_number: "7776655443",
    email: "siddharth.menon@gmail.com",
    registration_number: "Cand:1056823",
    employee_code: "6343132",
    joining_date: "18-03-2026",
    employee_type: "Full Time",
    status: "Valid",
  },
  {
    key: 38,
    sr_no: 38,
    first_name: "Pallavi",
    middle_name: "Lata",
    last_name: "Desai",
    mobile_number: "8665544332",
    email: "pallavi.desai@gmail.com",
    registration_number: "Cand:1045714",
    employee_code: "6343233",
    joining_date: "17-03-2026",
    employee_type: "Intern",
    status: "Valid",
  },
  // --- INVALID: mobile missing ---
  {
    key: 39,
    sr_no: 39,
    first_name: "Karan",
    middle_name: "",
    last_name: "Walia",
    mobile_number: "",
    email: "karan.walia@gmail.com",
    registration_number: "Cand:1034605",
    employee_code: "6343334",
    joining_date: "16-03-2026",
    employee_type: "Full Time",
    status: "Invalid",
  },
  {
    key: 40,
    sr_no: 40,
    first_name: "Sonali",
    middle_name: "",
    last_name: "Trivedi",
    mobile_number: "8321198765",
    email: "sonali.trivedi@gmail.com",
    registration_number: "Cand:1023496",
    employee_code: "6343435",
    joining_date: "15-03-2026",
    employee_type: "Contract",
    status: "Valid",
  },
];

// --------------------------------------------------
export const dummyData_totalInvited = [
  {
    key: "1",
    sno: 1,
    applicantName: "Ravi Kumar",
    caseId: "10234",
    caseSpoc: "Anita Sharma",
    employeeId: "50231",
    emailId: "ravi.kumar@example.com",
    daysElapsed: "12 Days",
    phone: "9876543210",
    invitationDate: "2024-05-01",
    status: "Pending",
    inviteExpiryDate: "2024-05-15",
  },
  {
    key: "2",
    sno: 2,
    applicantName: "Priya Nair",
    caseId: "10235",
    caseSpoc: "Suresh Iyer",
    employeeId: "50232",
    emailId: "priya.nair@example.com",
    daysElapsed: "5 Days",
    phone: "9123456780",
    invitationDate: "2024-05-10",
    status: "Accepted",
    inviteExpiryDate: "2024-05-24",
  },
  {
    key: "3",
    sno: 3,
    applicantName: "Mohammed Ali",
    caseId: "10236",
    caseSpoc: "Anita Sharma",
    employeeId: "50233",
    emailId: "mohammed.ali@example.com",
    daysElapsed: "20 Days",
    phone: "",
    invitationDate: "2024-04-28",
    status: "Expired",
    inviteExpiryDate: "2024-05-12",
  },
  {
    key: "4",
    sno: 4,
    applicantName: "Sneha Reddy",
    caseId: "10237",
    caseSpoc: "Vikram Singh",
    employeeId: "50234",
    emailId: "sneha.reddy@example.com",
    daysElapsed: "2 Days",
    phone: "9988776655",
    invitationDate: "2024-05-18",
    status: "In Progress",
    inviteExpiryDate: "2024-06-01",
  },
  {
    key: "5",
    sno: 5,
    applicantName: "Arjun Mehta",
    caseId: "10238",
    caseSpoc: "Suresh Iyer",
    employeeId: "50235",
    emailId: "arjun.mehta@example.com",
    daysElapsed: "8 Days",
    phone: "9012345678",
    invitationDate: "2024-05-12",
    status: "Completed",
    inviteExpiryDate: "2024-05-26",
  },
  {
    key: "6",
    sno: 6,
    applicantName: "Kavya Iyer",
    caseId: "10239",
    caseSpoc: "Vikram Singh",
    employeeId: "50236",
    emailId: "kavya.iyer@example.com",
    daysElapsed: "15 Days",
    phone: "9765432109",
    invitationDate: "2024-05-05",
    status: "Pending",
    inviteExpiryDate: "2024-05-19",
  },
  {
    key: "7",
    sno: 7,
    applicantName: "Rahul Verma",
    caseId: "10240",
    caseSpoc: "Anita Sharma",
    employeeId: "50237",
    emailId: "rahul.verma@example.com",
    daysElapsed: "1 Day",
    phone: "9345678901",
    invitationDate: "2024-05-20",
    status: "In Progress",
    inviteExpiryDate: "2024-06-03",
  },
  {
    key: "8",
    sno: 8,
    applicantName: "Divya Patel",
    caseId: "10241",
    caseSpoc: "Suresh Iyer",
    employeeId: "50238",
    emailId: "divya.patel@example.com",
    daysElapsed: "30 Days",
    phone: "",
    invitationDate: "2024-04-18",
    status: "Expired",
    inviteExpiryDate: "2024-05-02",
  },
  {
    key: "9",
    sno: 9,
    applicantName: "Karan Malhotra",
    caseId: "10242",
    caseSpoc: "Vikram Singh",
    employeeId: "50239",
    emailId: "karan.malhotra@example.com",
    daysElapsed: "6 Days",
    phone: "9556677889",
    invitationDate: "2024-05-14",
    status: "Accepted",
    inviteExpiryDate: "2024-05-28",
  },
  {
    key: "10",
    sno: 10,
    applicantName: "Neha Gupta",
    caseId: "10243",
    caseSpoc: "Anita Sharma",
    employeeId: "50240",
    emailId: "neha.gupta@example.com",
    daysElapsed: "10 Days",
    phone: "9223344556",
    invitationDate: "2024-05-08",
    status: "Completed",
    inviteExpiryDate: "2024-05-22",
  },
];

export const dummyData_pending = [
  {
    sno: 1,
    applicantName: "Aarav Sharma",
    caseId: 360001,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6401001,
    emailId: "aarav.sharma@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876546001",
    invitationDate: "08-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "20-06-2026",
    expireIn: "10 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 2,
    applicantName: "Priya Verma",
    caseId: 360002,
    caseSpoc: "Rahul Verma",
    employeeId: 6401002,
    emailId: "priya.verma@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876546002",
    invitationDate: "09-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "25-06-2026",
    expireIn: "15 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 3,
    applicantName: "Rohit Mehta",
    caseId: 360003,
    caseSpoc: "Neha Gupta",
    employeeId: 6401003,
    emailId: "rohit.mehta@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876546003",
    invitationDate: "07-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "18-06-2026",
    expireIn: "8 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 4,
    applicantName: "Ananya Kapoor",
    caseId: 360004,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6401004,
    emailId: "ananya.k@gmail.com",
    daysElapsed: "4 Days",
    phone: "+91 9876546004",
    invitationDate: "06-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "22-06-2026",
    expireIn: "12 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 5,
    applicantName: "Vikas Jain",
    caseId: 360005,
    caseSpoc: "Rahul Verma",
    employeeId: 6401005,
    emailId: "vikas.jain@gmail.com",
    daysElapsed: "5 Days",
    phone: "+91 9876546005",
    invitationDate: "05-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "17-06-2026",
    expireIn: "7 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 6,
    applicantName: "Sneha Nair",
    caseId: 360006,
    caseSpoc: "Neha Gupta",
    employeeId: 6401006,
    emailId: "sneha.nair@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876546006",
    invitationDate: "08-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "24-06-2026",
    expireIn: "14 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 7,
    applicantName: "Karan Arora",
    caseId: 360007,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6401007,
    emailId: "karan.arora@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876546007",
    invitationDate: "09-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "16-06-2026",
    expireIn: "6 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 8,
    applicantName: "Divya Sharma",
    caseId: 360008,
    caseSpoc: "Rahul Verma",
    employeeId: 6401008,
    emailId: "divya.sharma@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876546008",
    invitationDate: "07-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "28-06-2026",
    expireIn: "18 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 9,
    applicantName: "Manish Kumar",
    caseId: 360009,
    caseSpoc: "Neha Gupta",
    employeeId: 6401009,
    emailId: "manish.kumar@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876546009",
    invitationDate: "08-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "19-06-2026",
    expireIn: "9 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 10,
    applicantName: "Pooja Bansal",
    caseId: 360010,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6401010,
    emailId: "pooja.bansal@gmail.com",
    daysElapsed: "4 Days",
    phone: "+91 9876546010",
    invitationDate: "06-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "30-06-2026",
    expireIn: "20 Days",
    action: "Modify Invite",
    viewLog: true,
  },

  {
    sno: 11,
    applicantName: "Rahul Saxena",
    caseId: 360011,
    caseSpoc: "Rahul Verma",
    employeeId: 6401011,
    emailId: "rahul.saxena@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876546011",
    invitationDate: "09-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "21-06-2026",
    expireIn: "11 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 12,
    applicantName: "Nidhi Malhotra",
    caseId: 360012,
    caseSpoc: "Neha Gupta",
    employeeId: 6401012,
    emailId: "nidhi.m@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876546012",
    invitationDate: "08-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "23-06-2026",
    expireIn: "13 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 13,
    applicantName: "Akash Reddy",
    caseId: 360013,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6401013,
    emailId: "akash.reddy@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876546013",
    invitationDate: "07-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "26-06-2026",
    expireIn: "16 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 14,
    applicantName: "Ishita Rao",
    caseId: 360014,
    caseSpoc: "Rahul Verma",
    employeeId: 6401014,
    emailId: "ishita.rao@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876546014",
    invitationDate: "08-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "15-06-2026",
    expireIn: "5 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 15,
    applicantName: "Harshit Gupta",
    caseId: 360015,
    caseSpoc: "Neha Gupta",
    employeeId: 6401015,
    emailId: "harshit.g@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876546015",
    invitationDate: "09-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "27-06-2026",
    expireIn: "17 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 16,
    applicantName: "Ritika Arora",
    caseId: 360016,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6401016,
    emailId: "ritika.arora@gmail.com",
    daysElapsed: "4 Days",
    phone: "+91 9876546016",
    invitationDate: "06-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "29-06-2026",
    expireIn: "19 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 17,
    applicantName: "Mohit Chawla",
    caseId: 360017,
    caseSpoc: "Rahul Verma",
    employeeId: 6401017,
    emailId: "mohit.c@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876546017",
    invitationDate: "08-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "20-06-2026",
    expireIn: "10 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 18,
    applicantName: "Sakshi Verma",
    caseId: 360018,
    caseSpoc: "Neha Gupta",
    employeeId: 6401018,
    emailId: "sakshi.verma@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876546018",
    invitationDate: "07-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "24-06-2026",
    expireIn: "14 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 19,
    applicantName: "Kunal Bedi",
    caseId: 360019,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6401019,
    emailId: "kunal.bedi@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876546019",
    invitationDate: "09-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "18-06-2026",
    expireIn: "8 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 20,
    applicantName: "Megha Kapoor",
    caseId: 360020,
    caseSpoc: "Rahul Verma",
    employeeId: 6401020,
    emailId: "megha.k@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876546020",
    invitationDate: "08-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "22-06-2026",
    expireIn: "12 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 21,
    applicantName: "Arjun Tiwari",
    caseId: 360021,
    caseSpoc: "Neha Gupta",
    employeeId: 6401021,
    emailId: "arjun.t@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876546021",
    invitationDate: "07-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "25-06-2026",
    expireIn: "15 Days",
    action: "Modify Invite",
    viewLog: true,
  },
  {
    sno: 22,
    applicantName: "Neha Suri",
    caseId: 360022,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6401022,
    emailId: "neha.suri@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876546022",
    invitationDate: "08-06-2026",
    status: "Pending Login",
    inviteExpiryDate: "17-06-2026",
    expireIn: "7 Days",
    action: "Modify Invite",
    viewLog: true,
  },
];

export const dummyData_loggedIn = [
  {
    key: "1",
    sno: 1,
    applicantName: "Ravi Kumar",
    caseId: "10234",
    caseSpoc: "Anita Sharma",
    employeeId: "50231",
    emailId: "ravi.kumar@example.com",
    daysElapsed: "12 Days",
    phone: "9876543210",
    invitationDate: "2024-05-01",
    status: "Logged In",
    inviteExpiryDate: "2024-05-15",
  },
  {
    key: "2",
    sno: 2,
    applicantName: "Priya Nair",
    caseId: "10235",
    caseSpoc: "Suresh Iyer",
    employeeId: "50232",
    emailId: "priya.nair@example.com",
    daysElapsed: "5 Days",
    phone: "9123456780",
    invitationDate: "2024-05-10",
    status: "Logged In",
    inviteExpiryDate: "2024-05-24",
  },
  {
    key: "3",
    sno: 3,
    applicantName: "Mohammed Ali",
    caseId: "10236",
    caseSpoc: "Anita Sharma",
    employeeId: "50233",
    emailId: "mohammed.ali@example.com",
    daysElapsed: "20 Days",
    phone: "",
    invitationDate: "2024-04-28",
    status: "Logged In",
    inviteExpiryDate: "2024-05-12",
  },
  {
    key: "4",
    sno: 4,
    applicantName: "Sneha Reddy",
    caseId: "10237",
    caseSpoc: "Vikram Singh",
    employeeId: "50234",
    emailId: "sneha.reddy@example.com",
    daysElapsed: "2 Days",
    phone: "9988776655",
    invitationDate: "2024-05-18",
    status: "Logged In",
    inviteExpiryDate: "2024-06-01",
  },
  {
    key: "5",
    sno: 5,
    applicantName: "Arjun Mehta",
    caseId: "10238",
    caseSpoc: "Suresh Iyer",
    employeeId: "50235",
    emailId: "arjun.mehta@example.com",
    daysElapsed: "8 Days",
    phone: "9012345678",
    invitationDate: "2024-05-12",
    status: "Logged In",
    inviteExpiryDate: "2024-05-26",
  },
  {
    key: "6",
    sno: 6,
    applicantName: "Kavya Iyer",
    caseId: "10239",
    caseSpoc: "Vikram Singh",
    employeeId: "50236",
    emailId: "kavya.iyer@example.com",
    daysElapsed: "15 Days",
    phone: "9765432109",
    invitationDate: "2024-05-05",
    status: "Logged In",
    inviteExpiryDate: "2024-05-19",
  },
  {
    key: "7",
    sno: 7,
    applicantName: "Rahul Verma",
    caseId: "10240",
    caseSpoc: "Anita Sharma",
    employeeId: "50237",
    emailId: "rahul.verma@example.com",
    daysElapsed: "1 Day",
    phone: "9345678901",
    invitationDate: "2024-05-20",
    status: "Logged In",
    inviteExpiryDate: "2024-06-03",
  },
  {
    key: "8",
    sno: 8,
    applicantName: "Divya Patel",
    caseId: "10241",
    caseSpoc: "Suresh Iyer",
    employeeId: "50238",
    emailId: "divya.patel@example.com",
    daysElapsed: "30 Days",
    phone: "",
    invitationDate: "2024-04-18",
    status: "Logged In",
    inviteExpiryDate: "2024-05-02",
  },
  {
    key: "9",
    sno: 9,
    applicantName: "Karan Malhotra",
    caseId: "10242",
    caseSpoc: "Vikram Singh",
    employeeId: "50239",
    emailId: "karan.malhotra@example.com",
    daysElapsed: "6 Days",
    phone: "9556677889",
    invitationDate: "2024-05-14",
    status: "Logged In",
    inviteExpiryDate: "2024-05-28",
  },
  {
    key: "10",
    sno: 10,
    applicantName: "Neha Gupta",
    caseId: "10243",
    caseSpoc: "Anita Sharma",
    employeeId: "50240",
    emailId: "neha.gupta@example.com",
    daysElapsed: "10 Days",
    phone: "9223344556",
    invitationDate: "2024-05-08",
    status: "Logged In",
    inviteExpiryDate: "2024-05-22",
  },
];

export const dummyData_inProgress =  [
  {
    key: "1",
    sno: 1,
    applicantName: "Ravi Kumar",
    caseId: "10234",
    caseSpoc: "Anita Sharma",
    employeeId: "50231",
    emailId: "ravi.kumar@example.com",
    daysElapsed: "12 Days",
    phone: "9876543210",
    invitationDate: "2024-05-01",
    status: "In Progress",
    inviteExpiryDate: "2024-05-15",
  },
  {
    key: "2",
    sno: 2,
    applicantName: "Priya Nair",
    caseId: "10235",
    caseSpoc: "Suresh Iyer",
    employeeId: "50232",
    emailId: "priya.nair@example.com",
    daysElapsed: "5 Days",
    phone: "9123456780",
    invitationDate: "2024-05-10",
    status: "In Progress",
    inviteExpiryDate: "2024-05-24",
  },
  {
    key: "3",
    sno: 3,
    applicantName: "Mohammed Ali",
    caseId: "10236",
    caseSpoc: "Anita Sharma",
    employeeId: "50233",
    emailId: "mohammed.ali@example.com",
    daysElapsed: "20 Days",
    phone: "",
    invitationDate: "2024-04-28",
    status: "In Progress",
    inviteExpiryDate: "2024-05-12",
  },
  {
    key: "4",
    sno: 4,
    applicantName: "Sneha Reddy",
    caseId: "10237",
    caseSpoc: "Vikram Singh",
    employeeId: "50234",
    emailId: "sneha.reddy@example.com",
    daysElapsed: "2 Days",
    phone: "9988776655",
    invitationDate: "2024-05-18",
    status: "In Progress",
    inviteExpiryDate: "2024-06-01",
  },
  {
    key: "5",
    sno: 5,
    applicantName: "Arjun Mehta",
    caseId: "10238",
    caseSpoc: "Suresh Iyer",
    employeeId: "50235",
    emailId: "arjun.mehta@example.com",
    daysElapsed: "8 Days",
    phone: "9012345678",
    invitationDate: "2024-05-12",
    status: "In Progress",
    inviteExpiryDate: "2024-05-26",
  },
  {
    key: "6",
    sno: 6,
    applicantName: "Kavya Iyer",
    caseId: "10239",
    caseSpoc: "Vikram Singh",
    employeeId: "50236",
    emailId: "kavya.iyer@example.com",
    daysElapsed: "15 Days",
    phone: "9765432109",
    invitationDate: "2024-05-05",
    status: "In Progress",
    inviteExpiryDate: "2024-05-19",
  },
  {
    key: "7",
    sno: 7,
    applicantName: "Rahul Verma",
    caseId: "10240",
    caseSpoc: "Anita Sharma",
    employeeId: "50237",
    emailId: "rahul.verma@example.com",
    daysElapsed: "1 Day",
    phone: "9345678901",
    invitationDate: "2024-05-20",
    status: "In Progress",
    inviteExpiryDate: "2024-06-03",
  },
  {
    key: "8",
    sno: 8,
    applicantName: "Divya Patel",
    caseId: "10241",
    caseSpoc: "Suresh Iyer",
    employeeId: "50238",
    emailId: "divya.patel@example.com",
    daysElapsed: "30 Days",
    phone: "",
    invitationDate: "2024-04-18",
    status: "In Progress",
    inviteExpiryDate: "2024-05-02",
  },
  {
    key: "9",
    sno: 9,
    applicantName: "Karan Malhotra",
    caseId: "10242",
    caseSpoc: "Vikram Singh",
    employeeId: "50239",
    emailId: "karan.malhotra@example.com",
    daysElapsed: "6 Days",
    phone: "9556677889",
    invitationDate: "2024-05-14",
    status: "In Progress",
    inviteExpiryDate: "2024-05-28",
  },
  {
    key: "10",
    sno: 10,
    applicantName: "Neha Gupta",
    caseId: "10243",
    caseSpoc: "Anita Sharma",
    employeeId: "50240",
    emailId: "neha.gupta@example.com",
    daysElapsed: "10 Days",
    phone: "9223344556",
    invitationDate: "2024-05-08",
    status: "In Progress",
    inviteExpiryDate: "2024-05-22",
  },
];

export const dummyData_invited = [
  {
    sno: 1,
    applicantName: "Rahul Sharma",
    caseId: 350101,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325001,
    emailId: "rahul.sharma@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876545001",
    invitationDate: "12-05-2026",
    status: "Logged In",
    inviteExpiryDate: "27-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "16 Days",
  },
  {
    sno: 2,
    applicantName: "Pooja Nair",
    caseId: 350102,
    caseSpoc: "Ankit Verma",
    employeeId: 6325002,
    emailId: "pooja.nair@gmail.com",
    daysElapsed: "22 Days",
    phone: "+91 9876545002",
    invitationDate: "23-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "08-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 3,
    applicantName: "Arjun Mehta",
    caseId: 350103,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325003,
    emailId: "arjun.mehta@gmail.com",
    daysElapsed: "5 Days",
    phone: "+91 9876545003",
    invitationDate: "10-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "25-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "14 Days",
  },
  {
    sno: 4,
    applicantName: "Sneha Pillai",
    caseId: 350104,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325004,
    emailId: "sneha.pillai@gmail.com",
    daysElapsed: "14 Days",
    phone: "+91 9876545004",
    invitationDate: "01-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "16-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 5,
    applicantName: "Karan Bose",
    caseId: 350105,
    caseSpoc: "Ankit Verma",
    employeeId: 6325005,
    emailId: "karan.bose@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876545005",
    invitationDate: "13-05-2026",
    status: "Logged In",
    inviteExpiryDate: "28-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "17 Days",
  },
  {
    sno: 6,
    applicantName: "Divya Iyer",
    caseId: 350106,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325006,
    emailId: "divya.iyer@gmail.com",
    daysElapsed: "30 Days",
    phone: "+91 9876545006",
    invitationDate: "15-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "30-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 7,
    applicantName: "Vikram Yadav",
    caseId: 350107,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325007,
    emailId: "vikram.yadav@gmail.com",
    daysElapsed: "7 Days",
    phone: "+91 9876545007",
    invitationDate: "08-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "23-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "12 Days",
  },
  {
    sno: 8,
    applicantName: "Meena Desai",
    caseId: 350108,
    caseSpoc: "Ankit Verma",
    employeeId: 6325008,
    emailId: "meena.desai@gmail.com",
    daysElapsed: "9 Days",
    phone: "+91 9876545008",
    invitationDate: "06-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "21-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 9,
    applicantName: "Rohit Kulkarni",
    caseId: 350109,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325009,
    emailId: "rohit.kulkarni@gmail.com",
    daysElapsed: "4 Days",
    phone: "+91 9876545009",
    invitationDate: "11-05-2026",
    status: "Logged In",
    inviteExpiryDate: "26-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "15 Days",
  },
  {
    sno: 10,
    applicantName: "Ananya Reddy",
    caseId: 350110,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325010,
    emailId: "ananya.reddy@gmail.com",
    daysElapsed: "25 Days",
    phone: "+91 9876545010",
    invitationDate: "20-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "05-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 11,
    applicantName: "Suresh Pandey",
    caseId: 350111,
    caseSpoc: "Ankit Verma",
    employeeId: 6325011,
    emailId: "suresh.pandey@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876545011",
    invitationDate: "14-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "29-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "18 Days",
  },
  {
    sno: 12,
    applicantName: "Kavita Chauhan",
    caseId: 350112,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325012,
    emailId: "kavita.chauhan@gmail.com",
    daysElapsed: "6 Days",
    phone: "+91 9876545012",
    invitationDate: "09-05-2026",
    status: "Logged In",
    inviteExpiryDate: "24-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "13 Days",
  },
  {
    sno: 13,
    applicantName: "Nitin Saxena",
    caseId: 350113,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325013,
    emailId: "nitin.saxena@gmail.com",
    daysElapsed: "12 Days",
    phone: "+91 9876545013",
    invitationDate: "03-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "18-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 14,
    applicantName: "Priyanka Jain",
    caseId: 350114,
    caseSpoc: "Ankit Verma",
    employeeId: 6325014,
    emailId: "priyanka.jain@gmail.com",
    daysElapsed: "33 Days",
    phone: "+91 9876545014",
    invitationDate: "12-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "27-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 15,
    applicantName: "Deepak Tiwari",
    caseId: 350115,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325015,
    emailId: "deepak.tiwari@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876545015",
    invitationDate: "12-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "27-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "16 Days",
  },
  {
    sno: 16,
    applicantName: "Ritu Gupta",
    caseId: 350116,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325016,
    emailId: "ritu.gupta@gmail.com",
    daysElapsed: "8 Days",
    phone: "+91 9876545016",
    invitationDate: "07-05-2026",
    status: "Logged In",
    inviteExpiryDate: "22-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "11 Days",
  },
  {
    sno: 17,
    applicantName: "Manish Agarwal",
    caseId: 350117,
    caseSpoc: "Ankit Verma",
    employeeId: 6325017,
    emailId: "manish.agarwal@gmail.com",
    daysElapsed: "16 Days",
    phone: "+91 9876545017",
    invitationDate: "29-04-2026",
    status: "Form Approval",
    inviteExpiryDate: "14-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 18,
    applicantName: "Sonal Bhatt",
    caseId: 350118,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325018,
    emailId: "sonal.bhatt@gmail.com",
    daysElapsed: "28 Days",
    phone: "+91 9876545018",
    invitationDate: "17-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "02-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 19,
    applicantName: "Aakash Malhotra",
    caseId: 350119,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325019,
    emailId: "aakash.malhotra@gmail.com",
    daysElapsed: "5 Days",
    phone: "+91 9876545019",
    invitationDate: "10-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "25-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "14 Days",
  },
  {
    sno: 20,
    applicantName: "Tanuja Singh",
    caseId: 350120,
    caseSpoc: "Ankit Verma",
    employeeId: 6325020,
    emailId: "tanuja.singh@gmail.com",
    daysElapsed: "10 Days",
    phone: "+91 9876545020",
    invitationDate: "05-05-2026",
    status: "Logged In",
    inviteExpiryDate: "20-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "9 Days",
  },
  {
    sno: 21,
    applicantName: "Gaurav Walia",
    caseId: 350121,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325021,
    emailId: "gaurav.walia@gmail.com",
    daysElapsed: "19 Days",
    phone: "+91 9876545021",
    invitationDate: "26-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "11-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 22,
    applicantName: "Pallavi Menon",
    caseId: 350122,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325022,
    emailId: "pallavi.menon@gmail.com",
    daysElapsed: "11 Days",
    phone: "+91 9876545022",
    invitationDate: "04-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "19-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 23,
    applicantName: "Aditya Thakur",
    caseId: 350123,
    caseSpoc: "Ankit Verma",
    employeeId: 6325023,
    emailId: "aditya.thakur@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876545023",
    invitationDate: "13-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "28-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "17 Days",
  },
  {
    sno: 24,
    applicantName: "Neha Kapoor",
    caseId: 350124,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325024,
    emailId: "neha.kapoor@gmail.com",
    daysElapsed: "38 Days",
    phone: "+91 9876545024",
    invitationDate: "07-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "22-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 25,
    applicantName: "Siddharth Rao",
    caseId: 350125,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325025,
    emailId: "siddharth.rao@gmail.com",
    daysElapsed: "6 Days",
    phone: "+91 9876545025",
    invitationDate: "09-05-2026",
    status: "Logged In",
    inviteExpiryDate: "24-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "13 Days",
  },
  {
    sno: 26,
    applicantName: "Ishita Banerjee",
    caseId: 350126,
    caseSpoc: "Ankit Verma",
    employeeId: 6325026,
    emailId: "ishita.banerjee@gmail.com",
    daysElapsed: "13 Days",
    phone: "+91 9876545026",
    invitationDate: "02-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "17-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 27,
    applicantName: "Harish Dubey",
    caseId: 350127,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325027,
    emailId: "harish.dubey@gmail.com",
    daysElapsed: "9 Days",
    phone: "+91 9876545027",
    invitationDate: "06-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "21-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "10 Days",
  },
  {
    sno: 28,
    applicantName: "Simran Kaur",
    caseId: 350128,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325028,
    emailId: "simran.kaur@gmail.com",
    daysElapsed: "21 Days",
    phone: "+91 9876545028",
    invitationDate: "24-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "09-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 29,
    applicantName: "Rajesh Kumar",
    caseId: 350129,
    caseSpoc: "Ankit Verma",
    employeeId: 6325029,
    emailId: "rajesh.kumar@gmail.com",
    daysElapsed: "4 Days",
    phone: "+91 9876545029",
    invitationDate: "11-05-2026",
    status: "Logged In",
    inviteExpiryDate: "26-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "15 Days",
  },
  {
    sno: 30,
    applicantName: "Shruti Mishra",
    caseId: 350130,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325030,
    emailId: "shruti.mishra@gmail.com",
    daysElapsed: "7 Days",
    phone: "+91 9876545030",
    invitationDate: "08-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "23-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "12 Days",
  },
  {
    sno: 31,
    applicantName: "Yash Rastogi",
    caseId: 350131,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325031,
    emailId: "yash.rastogi@gmail.com",
    daysElapsed: "17 Days",
    phone: "+91 9876545031",
    invitationDate: "28-04-2026",
    status: "Form Approval",
    inviteExpiryDate: "13-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 32,
    applicantName: "Ankita Trivedi",
    caseId: 350132,
    caseSpoc: "Ankit Verma",
    employeeId: 6325032,
    emailId: "ankita.trivedi@gmail.com",
    daysElapsed: "35 Days",
    phone: "+91 9876545032",
    invitationDate: "10-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "25-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 33,
    applicantName: "Piyush Goswami",
    caseId: 350133,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325033,
    emailId: "piyush.goswami@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876545033",
    invitationDate: "14-05-2026",
    status: "Logged In",
    inviteExpiryDate: "30-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "19 Days",
  },
  {
    sno: 34,
    applicantName: "Roshni Verma",
    caseId: 350134,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325034,
    emailId: "roshni.verma@gmail.com",
    daysElapsed: "11 Days",
    phone: "+91 9876545034",
    invitationDate: "04-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "19-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "8 Days",
  },
  {
    sno: 35,
    applicantName: "Tarun Joshi",
    caseId: 350135,
    caseSpoc: "Ankit Verma",
    employeeId: 6325035,
    emailId: "tarun.joshi@gmail.com",
    daysElapsed: "26 Days",
    phone: "+91 9876545035",
    invitationDate: "19-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "04-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 36,
    applicantName: "Nidhi Srivastava",
    caseId: 350136,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325036,
    emailId: "nidhi.srivastava@gmail.com",
    daysElapsed: "8 Days",
    phone: "+91 9876545036",
    invitationDate: "07-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "22-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 37,
    applicantName: "Abhijit Patil",
    caseId: 350137,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325037,
    emailId: "abhijit.patil@gmail.com",
    daysElapsed: "5 Days",
    phone: "+91 9876545037",
    invitationDate: "10-05-2026",
    status: "Logged In",
    inviteExpiryDate: "25-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "14 Days",
  },
  {
    sno: 38,
    applicantName: "Komal Shukla",
    caseId: 350138,
    caseSpoc: "Ankit Verma",
    employeeId: 6325038,
    emailId: "komal.shukla@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876545038",
    invitationDate: "12-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "27-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "16 Days",
  },
  {
    sno: 39,
    applicantName: "Vikas Bhatia",
    caseId: 350139,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325039,
    emailId: "vikas.bhatia@gmail.com",
    daysElapsed: "40 Days",
    phone: "+91 9876545039",
    invitationDate: "05-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "20-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 40,
    applicantName: "Payal Dubey",
    caseId: 350140,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325040,
    emailId: "payal.dubey@gmail.com",
    daysElapsed: "10 Days",
    phone: "+91 9876545040",
    invitationDate: "05-05-2026",
    status: "Logged In",
    inviteExpiryDate: "20-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "9 Days",
  },
  {
    sno: 41,
    applicantName: "Sachin Nair",
    caseId: 350141,
    caseSpoc: "Ankit Verma",
    employeeId: 6325041,
    emailId: "sachin.nair@gmail.com",
    daysElapsed: "18 Days",
    phone: "+91 9876545041",
    invitationDate: "27-04-2026",
    status: "Form Approval",
    inviteExpiryDate: "12-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 42,
    applicantName: "Bhavna Saxena",
    caseId: 350142,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325042,
    emailId: "bhavna.saxena@gmail.com",
    daysElapsed: "12 Days",
    phone: "+91 9876545042",
    invitationDate: "03-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "18-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "7 Days",
  },
  {
    sno: 43,
    applicantName: "Ramesh Pillai",
    caseId: 350143,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325043,
    emailId: "ramesh.pillai@gmail.com",
    daysElapsed: "29 Days",
    phone: "+91 9876545043",
    invitationDate: "16-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "01-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 44,
    applicantName: "Jyoti Chauhan",
    caseId: 350144,
    caseSpoc: "Ankit Verma",
    employeeId: 6325044,
    emailId: "jyoti.chauhan@gmail.com",
    daysElapsed: "6 Days",
    phone: "+91 9876545044",
    invitationDate: "09-05-2026",
    status: "Logged In",
    inviteExpiryDate: "24-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "13 Days",
  },
  {
    sno: 45,
    applicantName: "Akash Pandey",
    caseId: 350145,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325045,
    emailId: "akash.pandey@gmail.com",
    daysElapsed: "15 Days",
    phone: "+91 9876545045",
    invitationDate: "30-04-2026",
    status: "Form Approval",
    inviteExpiryDate: "15-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 46,
    applicantName: "Reena Malhotra",
    caseId: 350146,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325046,
    emailId: "reena.malhotra@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876545046",
    invitationDate: "13-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "28-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "17 Days",
  },
  {
    sno: 47,
    applicantName: "Devendra Rao",
    caseId: 350147,
    caseSpoc: "Ankit Verma",
    employeeId: 6325047,
    emailId: "devendra.rao@gmail.com",
    daysElapsed: "23 Days",
    phone: "+91 9876545047",
    invitationDate: "22-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "07-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 48,
    applicantName: "Sunita Jain",
    caseId: 350148,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325048,
    emailId: "sunita.jain@gmail.com",
    daysElapsed: "8 Days",
    phone: "+91 9876545048",
    invitationDate: "07-05-2026",
    status: "Logged In",
    inviteExpiryDate: "22-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "11 Days",
  },
  {
    sno: 49,
    applicantName: "Manoj Tiwari",
    caseId: 350149,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325049,
    emailId: "manoj.tiwari@gmail.com",
    daysElapsed: "20 Days",
    phone: "+91 9876545049",
    invitationDate: "25-04-2026",
    status: "Form Approval",
    inviteExpiryDate: "10-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 50,
    applicantName: "Usha Kulkarni",
    caseId: 350150,
    caseSpoc: "Ankit Verma",
    employeeId: 6325050,
    emailId: "usha.kulkarni@gmail.com",
    daysElapsed: "4 Days",
    phone: "+91 9876545050",
    invitationDate: "11-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "26-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "15 Days",
  },
  {
    sno: 51,
    applicantName: "Girish Desai",
    caseId: 350151,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325051,
    emailId: "girish.desai@gmail.com",
    daysElapsed: "32 Days",
    phone: "+91 9876545051",
    invitationDate: "13-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "28-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 52,
    applicantName: "Varsha Mehta",
    caseId: 350152,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325052,
    emailId: "varsha.mehta@gmail.com",
    daysElapsed: "7 Days",
    phone: "+91 9876545052",
    invitationDate: "08-05-2026",
    status: "Logged In",
    inviteExpiryDate: "23-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "12 Days",
  },
  {
    sno: 53,
    applicantName: "Naresh Sharma",
    caseId: 350153,
    caseSpoc: "Ankit Verma",
    employeeId: 6325053,
    emailId: "naresh.sharma@gmail.com",
    daysElapsed: "9 Days",
    phone: "+91 9876545053",
    invitationDate: "06-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "21-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "10 Days",
  },
  {
    sno: 54,
    applicantName: "Lata Iyer",
    caseId: 350154,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325054,
    emailId: "lata.iyer@gmail.com",
    daysElapsed: "11 Days",
    phone: "+91 9876545054",
    invitationDate: "04-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "19-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 55,
    applicantName: "Prakash Yadav",
    caseId: 350155,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325055,
    emailId: "prakash.yadav@gmail.com",
    daysElapsed: "27 Days",
    phone: "+91 9876545055",
    invitationDate: "18-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "03-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 56,
    applicantName: "Hema Reddy",
    caseId: 350156,
    caseSpoc: "Ankit Verma",
    employeeId: 6325056,
    emailId: "hema.reddy@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876545056",
    invitationDate: "14-05-2026",
    status: "Logged In",
    inviteExpiryDate: "30-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "19 Days",
  },
  {
    sno: 57,
    applicantName: "Sunil Bose",
    caseId: 350157,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325057,
    emailId: "sunil.bose@gmail.com",
    daysElapsed: "5 Days",
    phone: "+91 9876545057",
    invitationDate: "10-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "25-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "14 Days",
  },
  {
    sno: 58,
    applicantName: "Anita Pandey",
    caseId: 350158,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325058,
    emailId: "anita.pandey@gmail.com",
    daysElapsed: "6 Days",
    phone: "+91 9876545058",
    invitationDate: "09-05-2026",
    status: "Logged In",
    inviteExpiryDate: "24-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "13 Days",
  },
  {
    sno: 59,
    applicantName: "Kishore Gupta",
    caseId: 350159,
    caseSpoc: "Ankit Verma",
    employeeId: 6325059,
    emailId: "kishore.gupta@gmail.com",
    daysElapsed: "16 Days",
    phone: "+91 9876545059",
    invitationDate: "29-04-2026",
    status: "Form Approval",
    inviteExpiryDate: "14-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 60,
    applicantName: "Suman Walia",
    caseId: 350160,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325060,
    emailId: "suman.walia@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876545060",
    invitationDate: "12-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "27-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "16 Days",
  },
  {
    sno: 61,
    applicantName: "Dinesh Banerjee",
    caseId: 350161,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325061,
    emailId: "dinesh.banerjee@gmail.com",
    daysElapsed: "24 Days",
    phone: "+91 9876545061",
    invitationDate: "21-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "06-05-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 62,
    applicantName: "Kamla Singh",
    caseId: 350162,
    caseSpoc: "Ankit Verma",
    employeeId: 6325062,
    emailId: "kamla.singh@gmail.com",
    daysElapsed: "4 Days",
    phone: "+91 9876545062",
    invitationDate: "11-05-2026",
    status: "Logged In",
    inviteExpiryDate: "26-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "15 Days",
  },
  {
    sno: 63,
    applicantName: "Vijay Mishra",
    caseId: 350163,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325063,
    emailId: "vijay.mishra@gmail.com",
    daysElapsed: "12 Days",
    phone: "+91 9876545063",
    invitationDate: "03-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "18-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "7 Days",
  },
  {
    sno: 64,
    applicantName: "Sudha Thakur",
    caseId: 350164,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325064,
    emailId: "sudha.thakur@gmail.com",
    daysElapsed: "8 Days",
    phone: "+91 9876545064",
    invitationDate: "07-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "22-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 65,
    applicantName: "Arun Kapoor",
    caseId: 350165,
    caseSpoc: "Ankit Verma",
    employeeId: 6325065,
    emailId: "arun.kapoor@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876545065",
    invitationDate: "13-05-2026",
    status: "Logged In",
    inviteExpiryDate: "28-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "17 Days",
  },
  {
    sno: 66,
    applicantName: "Pushpa Trivedi",
    caseId: 350166,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325066,
    emailId: "pushpa.trivedi@gmail.com",
    daysElapsed: "36 Days",
    phone: "+91 9876545066",
    invitationDate: "09-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "24-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 67,
    applicantName: "Mohan Rastogi",
    caseId: 350167,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325067,
    emailId: "mohan.rastogi@gmail.com",
    daysElapsed: "10 Days",
    phone: "+91 9876545067",
    invitationDate: "05-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "20-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "9 Days",
  },
  {
    sno: 68,
    applicantName: "Geeta Nair",
    caseId: 350168,
    caseSpoc: "Ankit Verma",
    employeeId: 6325068,
    emailId: "geeta.nair@gmail.com",
    daysElapsed: "5 Days",
    phone: "+91 9876545068",
    invitationDate: "10-05-2026",
    status: "Logged In",
    inviteExpiryDate: "25-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "14 Days",
  },
  {
    sno: 69,
    applicantName: "Santosh Verma",
    caseId: 350169,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325069,
    emailId: "santosh.verma@gmail.com",
    daysElapsed: "19 Days",
    phone: "+91 9876545069",
    invitationDate: "26-04-2026",
    status: "Form Approval",
    inviteExpiryDate: "11-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 70,
    applicantName: "Rekha Joshi",
    caseId: 350170,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325070,
    emailId: "rekha.joshi@gmail.com",
    daysElapsed: "7 Days",
    phone: "+91 9876545070",
    invitationDate: "08-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "23-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "12 Days",
  },
  {
    sno: 71,
    applicantName: "Harendra Singh",
    caseId: 350171,
    caseSpoc: "Ankit Verma",
    employeeId: 6325071,
    emailId: "harendra.singh@gmail.com",
    daysElapsed: "9 Days",
    phone: "+91 9876545071",
    invitationDate: "06-05-2026",
    status: "Logged In",
    inviteExpiryDate: "21-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "10 Days",
  },
  {
    sno: 72,
    applicantName: "Nirmala Dubey",
    caseId: 350172,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325072,
    emailId: "nirmala.dubey@gmail.com",
    daysElapsed: "31 Days",
    phone: "+91 9876545072",
    invitationDate: "14-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "29-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 73,
    applicantName: "Prem Kulkarni",
    caseId: 350173,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325073,
    emailId: "prem.kulkarni@gmail.com",
    daysElapsed: "3 Days",
    phone: "+91 9876545073",
    invitationDate: "12-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "27-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "16 Days",
  },
  {
    sno: 74,
    applicantName: "Shobha Saxena",
    caseId: 350174,
    caseSpoc: "Ankit Verma",
    employeeId: 6325074,
    emailId: "shobha.saxena@gmail.com",
    daysElapsed: "6 Days",
    phone: "+91 9876545074",
    invitationDate: "09-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "24-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 75,
    applicantName: "Lalit Sharma",
    caseId: 350175,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325075,
    emailId: "lalit.sharma@gmail.com",
    daysElapsed: "1 Day",
    phone: "+91 9876545075",
    invitationDate: "14-05-2026",
    status: "Logged In",
    inviteExpiryDate: "29-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "18 Days",
  },
  {
    sno: 76,
    applicantName: "Madhuri Patil",
    caseId: 350176,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325076,
    emailId: "madhuri.patil@gmail.com",
    daysElapsed: "34 Days",
    phone: "+91 9876545076",
    invitationDate: "11-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "26-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 77,
    applicantName: "Vinod Chauhan",
    caseId: 350177,
    caseSpoc: "Ankit Verma",
    employeeId: 6325077,
    emailId: "vinod.chauhan@gmail.com",
    daysElapsed: "4 Days",
    phone: "+91 9876545077",
    invitationDate: "11-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "26-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "15 Days",
  },
  {
    sno: 78,
    applicantName: "Sunanda Rao",
    caseId: 350178,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325078,
    emailId: "sunanda.rao@gmail.com",
    daysElapsed: "11 Days",
    phone: "+91 9876545078",
    invitationDate: "04-05-2026",
    status: "Form Approval",
    inviteExpiryDate: "19-05-2026",
    action: "Review Form",
    viewLog: true,
    expireIn: "N/A",
  },
  {
    sno: 79,
    applicantName: "Chetan Malhotra",
    caseId: 350179,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325079,
    emailId: "chetan.malhotra@gmail.com",
    daysElapsed: "8 Days",
    phone: "+91 9876545079",
    invitationDate: "07-05-2026",
    status: "Logged In",
    inviteExpiryDate: "22-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "11 Days",
  },
  {
    sno: 80,
    applicantName: "Savita Tiwari",
    caseId: 350180,
    caseSpoc: "Ankit Verma",
    employeeId: 6325080,
    emailId: "savita.tiwari@gmail.com",
    daysElapsed: "2 Days",
    phone: "+91 9876545080",
    invitationDate: "13-05-2026",
    status: "Pending Login",
    inviteExpiryDate: "28-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "17 Days",
  },
  {
    sno: 81,
    applicantName: "Ramakant Gupta",
    caseId: 350181,
    caseSpoc: "Ritika Joshi",
    employeeId: 6325081,
    emailId: "ramakant.gupta@gmail.com",
    daysElapsed: "37 Days",
    phone: "+91 9876545081",
    invitationDate: "08-04-2026",
    status: "Login Expired",
    inviteExpiryDate: "23-04-2026",
    action: "Resend Invite",
    viewLog: true,
    expireIn: "Expired",
  },
  {
    sno: 82,
    applicantName: "Meenakshi Agarwal",
    caseId: 350182,
    caseSpoc: "Shreyesth Kohli",
    employeeId: 6325082,
    emailId: "meenakshi.agarwal@gmail.com",
    daysElapsed: "5 Days",
    phone: "+91 9876545082",
    invitationDate: "10-05-2026",
    status: "Logged In",
    inviteExpiryDate: "25-05-2026",
    action: "Modify Invite",
    viewLog: true,
    expireIn: "14 Days",
  },
];

// ------------------------------------
export const dummyData_submitted = [
  {
    key: "1",
    sno: 1,
    applicant_name: "Ranjana Jena",
    case_id: "357238",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054000",
    case_received_date: "22-04-2026",
    submission_date: "22-04-2026",
    submitted_by: "Self",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "2",
    sno: 2,
    applicant_name: "Mohit Agarwal",
    case_id: "357239",
    case_spoc: "Priya Nair",
    employee_id: "CAND-1054001",
    case_received_date: "23-04-2026",
    submission_date: "23-04-2026",
    submitted_by: "HR",
    documents_status: "Incomplete",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "3",
    sno: 3,
    applicant_name: "Sneha Kulkarni",
    case_id: "357240",
    case_spoc: "Rahul Joshi",
    employee_id: "CAND-1054002",
    case_received_date: "24-04-2026",
    submission_date: "24-04-2026",
    submitted_by: "Agency",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "4",
    sno: 4,
    applicant_name: "Arjun Mehta",
    case_id: "357241",
    case_spoc: "Shreyesh Kohli",
    employee_id: "CAND-1054003",
    case_received_date: "25-04-2026",
    submission_date: "25-04-2026",
    submitted_by: "Self",
    documents_status: "Pending",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "5",
    sno: 5,
    applicant_name: "Divya Sharma",
    case_id: "357242",
    case_spoc: "Anita Verma",
    employee_id: "CAND-1054004",
    case_received_date: "26-04-2026",
    submission_date: "26-04-2026",
    submitted_by: "HR",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "6",
    sno: 6,
    applicant_name: "Karan Bose",
    case_id: "357243",
    case_spoc: "Karan Mehta",
    employee_id: "CAND-1054005",
    case_received_date: "27-04-2026",
    submission_date: "27-04-2026",
    submitted_by: "Agency",
    documents_status: "Incomplete",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "7",
    sno: 7,
    applicant_name: "Pooja Reddy",
    case_id: "357244",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054006",
    case_received_date: "28-04-2026",
    submission_date: "28-04-2026",
    submitted_by: "Self",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "8",
    sno: 8,
    applicant_name: "Amit Sinha",
    case_id: "357245",
    case_spoc: "Priya Nair",
    employee_id: "CAND-1054007",
    case_received_date: "29-04-2026",
    submission_date: "29-04-2026",
    submitted_by: "HR",
    documents_status: "Pending",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "9",
    sno: 9,
    applicant_name: "Meera Pillai",
    case_id: "357246",
    case_spoc: "Rahul Joshi",
    employee_id: "CAND-1054008",
    case_received_date: "30-04-2026",
    submission_date: "30-04-2026",
    submitted_by: "Agency",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "10",
    sno: 10,
    applicant_name: "Suresh Iyer",
    case_id: "357247",
    case_spoc: "Shreyesh Kohli",
    employee_id: "CAND-1054009",
    case_received_date: "01-05-2026",
    submission_date: "01-05-2026",
    submitted_by: "Self",
    documents_status: "Incomplete",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "11",
    sno: 11,
    applicant_name: "Kavitha Nair",
    case_id: "357248",
    case_spoc: "Anita Verma",
    employee_id: "CAND-1054010",
    case_received_date: "02-05-2026",
    submission_date: "02-05-2026",
    submitted_by: "HR",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "12",
    sno: 12,
    applicant_name: "Nikhil Pandey",
    case_id: "357249",
    case_spoc: "Karan Mehta",
    employee_id: "CAND-1054011",
    case_received_date: "03-05-2026",
    submission_date: "03-05-2026",
    submitted_by: "Agency",
    documents_status: "Pending",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "13",
    sno: 13,
    applicant_name: "Ritu Verma",
    case_id: "357250",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054012",
    case_received_date: "04-05-2026",
    submission_date: "04-05-2026",
    submitted_by: "Self",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "14",
    sno: 14,
    applicant_name: "Gaurav Tiwari",
    case_id: "357251",
    case_spoc: "Priya Nair",
    employee_id: "CAND-1054013",
    case_received_date: "05-05-2026",
    submission_date: "05-05-2026",
    submitted_by: "HR",
    documents_status: "Incomplete",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "15",
    sno: 15,
    applicant_name: "Swati Desai",
    case_id: "357252",
    case_spoc: "Rahul Joshi",
    employee_id: "CAND-1054014",
    case_received_date: "06-05-2026",
    submission_date: "06-05-2026",
    submitted_by: "Agency",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "16",
    sno: 16,
    applicant_name: "Harish Gupta",
    case_id: "357253",
    case_spoc: "Shreyesh Kohli",
    employee_id: "CAND-1054015",
    case_received_date: "07-05-2026",
    submission_date: "07-05-2026",
    submitted_by: "Self",
    documents_status: "Pending",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "17",
    sno: 17,
    applicant_name: "Deepika Joshi",
    case_id: "357254",
    case_spoc: "Anita Verma",
    employee_id: "CAND-1054016",
    case_received_date: "08-05-2026",
    submission_date: "08-05-2026",
    submitted_by: "HR",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
  {
    key: "18",
    sno: 18,
    applicant_name: "Vikram Saxena",
    case_id: "357255",
    case_spoc: "Karan Mehta",
    employee_id: "CAND-1054017",
    case_received_date: "09-05-2026",
    submission_date: "09-05-2026",
    submitted_by: "Agency",
    documents_status: "Incomplete",
    initiation_status: "Pending",
    actions: "",
  },
  {
    key: "19",
    sno: 19,
    applicant_name: "Nalini Krishnan",
    case_id: "357256",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054018",
    case_received_date: "10-05-2026",
    submission_date: "10-05-2026",
    submitted_by: "Self",
    documents_status: "Complete",
    initiation_status: "Initiated",
    actions: "",
  },
];

// ------------------------------------
export const dummyData_WorkInProgress = [
  {
    key: "1",
    sno: 1,
    applicant_name: "Ranjana Jena",
    case_id: "357238",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054000",
    case_received_date: "22-04-2026",
    sla_start_date: "23-04-2026",
    due_date: "08-05-2026",
    total_checks: 6,
    work_in_progress: 6,
    completed: 0,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "2",
    sno: 2,
    applicant_name: "Priya Sharma",
    case_id: "357239",
    case_spoc: "Rahul Verma",
    employee_id: "CAND-1054001",
    case_received_date: "24-04-2026",
    sla_start_date: "25-04-2026",
    due_date: "10-05-2026",
    total_checks: 8,
    work_in_progress: 5,
    completed: 3,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "3",
    sno: 3,
    applicant_name: "Ankit Mehta",
    case_id: "357240",
    case_spoc: "Shreyesth Kohli",
    employee_id: "CAND-1054002",
    case_received_date: "25-04-2026",
    sla_start_date: "26-04-2026",
    due_date: "11-05-2026",
    total_checks: 7,
    work_in_progress: 4,
    completed: 2,
    stop: 1,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "4",
    sno: 4,
    applicant_name: "Sneha Kapoor",
    case_id: "357241",
    case_spoc: "Neha Gupta",
    employee_id: "CAND-1054003",
    case_received_date: "26-04-2026",
    sla_start_date: "27-04-2026",
    due_date: "12-05-2026",
    total_checks: 6,
    work_in_progress: 3,
    completed: 3,
    stop: 0,
    insuff_expire: "1",
    actions: "",
  },
  {
    key: "5",
    sno: 5,
    applicant_name: "Rohit Nair",
    case_id: "357242",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054004",
    case_received_date: "27-04-2026",
    sla_start_date: "28-04-2026",
    due_date: "13-05-2026",
    total_checks: 9,
    work_in_progress: 6,
    completed: 2,
    stop: 1,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "6",
    sno: 6,
    applicant_name: "Aditi Verma",
    case_id: "357243",
    case_spoc: "Rahul Verma",
    employee_id: "CAND-1054005",
    case_received_date: "28-04-2026",
    sla_start_date: "29-04-2026",
    due_date: "14-05-2026",
    total_checks: 5,
    work_in_progress: 2,
    completed: 3,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "7",
    sno: 7,
    applicant_name: "Vikas Arora",
    case_id: "357244",
    case_spoc: "Shreyesth Kohli",
    employee_id: "CAND-1054006",
    case_received_date: "29-04-2026",
    sla_start_date: "30-04-2026",
    due_date: "15-05-2026",
    total_checks: 10,
    work_in_progress: 7,
    completed: 2,
    stop: 1,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "8",
    sno: 8,
    applicant_name: "Divya Singh",
    case_id: "357245",
    case_spoc: "Neha Gupta",
    employee_id: "CAND-1054007",
    case_received_date: "30-04-2026",
    sla_start_date: "01-05-2026",
    due_date: "16-05-2026",
    total_checks: 8,
    work_in_progress: 5,
    completed: 3,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "9",
    sno: 9,
    applicant_name: "Harsh Jain",
    case_id: "357246",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054008",
    case_received_date: "01-05-2026",
    sla_start_date: "02-05-2026",
    due_date: "17-05-2026",
    total_checks: 7,
    work_in_progress: 4,
    completed: 2,
    stop: 1,
    insuff_expire: "2",
    actions: "",
  },
  {
    key: "10",
    sno: 10,
    applicant_name: "Ishita Rao",
    case_id: "357247",
    case_spoc: "Rahul Verma",
    employee_id: "CAND-1054009",
    case_received_date: "02-05-2026",
    sla_start_date: "03-05-2026",
    due_date: "18-05-2026",
    total_checks: 6,
    work_in_progress: 2,
    completed: 4,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "11",
    sno: 11,
    applicant_name: "Kunal Bansal",
    case_id: "357248",
    case_spoc: "Shreyesth Kohli",
    employee_id: "CAND-1054010",
    case_received_date: "03-05-2026",
    sla_start_date: "04-05-2026",
    due_date: "19-05-2026",
    total_checks: 8,
    work_in_progress: 5,
    completed: 3,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "12",
    sno: 12,
    applicant_name: "Pallavi Gupta",
    case_id: "357249",
    case_spoc: "Neha Gupta",
    employee_id: "CAND-1054011",
    case_received_date: "04-05-2026",
    sla_start_date: "05-05-2026",
    due_date: "20-05-2026",
    total_checks: 9,
    work_in_progress: 7,
    completed: 1,
    stop: 1,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "13",
    sno: 13,
    applicant_name: "Aman Kulkarni",
    case_id: "357250",
    case_spoc: "Rahul Verma",
    employee_id: "CAND-1054012",
    case_received_date: "05-05-2026",
    sla_start_date: "06-05-2026",
    due_date: "21-05-2026",
    total_checks: 5,
    work_in_progress: 2,
    completed: 3,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "14",
    sno: 14,
    applicant_name: "Neha Thomas",
    case_id: "357251",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054013",
    case_received_date: "06-05-2026",
    sla_start_date: "07-05-2026",
    due_date: "22-05-2026",
    total_checks: 6,
    work_in_progress: 4,
    completed: 2,
    stop: 0,
    insuff_expire: "1",
    actions: "",
  },
  {
    key: "15",
    sno: 15,
    applicant_name: "Siddharth Menon",
    case_id: "357252",
    case_spoc: "Shreyesth Kohli",
    employee_id: "CAND-1054014",
    case_received_date: "07-05-2026",
    sla_start_date: "08-05-2026",
    due_date: "23-05-2026",
    total_checks: 8,
    work_in_progress: 6,
    completed: 2,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "16",
    sno: 16,
    applicant_name: "Ritika Arora",
    case_id: "357253",
    case_spoc: "Rahul Verma",
    employee_id: "CAND-1054015",
    case_received_date: "08-05-2026",
    sla_start_date: "09-05-2026",
    due_date: "24-05-2026",
    total_checks: 7,
    work_in_progress: 3,
    completed: 4,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "17",
    sno: 17,
    applicant_name: "Mohit Sharma",
    case_id: "357254",
    case_spoc: "Neha Gupta",
    employee_id: "CAND-1054016",
    case_received_date: "09-05-2026",
    sla_start_date: "10-05-2026",
    due_date: "25-05-2026",
    total_checks: 9,
    work_in_progress: 5,
    completed: 3,
    stop: 1,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "18",
    sno: 18,
    applicant_name: "Ananya Roy",
    case_id: "357255",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054017",
    case_received_date: "10-05-2026",
    sla_start_date: "11-05-2026",
    due_date: "26-05-2026",
    total_checks: 6,
    work_in_progress: 4,
    completed: 2,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "19",
    sno: 19,
    applicant_name: "Arjun Mehta",
    case_id: "357256",
    case_spoc: "Rahul Verma",
    employee_id: "CAND-1054018",
    case_received_date: "11-05-2026",
    sla_start_date: "12-05-2026",
    due_date: "27-05-2026",
    total_checks: 10,
    work_in_progress: 8,
    completed: 2,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "20",
    sno: 20,
    applicant_name: "Snehal Patil",
    case_id: "357257",
    case_spoc: "Shreyesth Kohli",
    employee_id: "CAND-1054019",
    case_received_date: "12-05-2026",
    sla_start_date: "13-05-2026",
    due_date: "28-05-2026",
    total_checks: 7,
    work_in_progress: 4,
    completed: 3,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "21",
    sno: 21,
    applicant_name: "Bhavna Kapoor",
    case_id: "357258",
    case_spoc: "Neha Gupta",
    employee_id: "CAND-1054020",
    case_received_date: "13-05-2026",
    sla_start_date: "14-05-2026",
    due_date: "29-05-2026",
    total_checks: 8,
    work_in_progress: 5,
    completed: 2,
    stop: 1,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "22",
    sno: 22,
    applicant_name: "Karan Sethi",
    case_id: "357259",
    case_spoc: "Rahul Verma",
    employee_id: "CAND-1054021",
    case_received_date: "14-05-2026",
    sla_start_date: "15-05-2026",
    due_date: "30-05-2026",
    total_checks: 6,
    work_in_progress: 2,
    completed: 4,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
  {
    key: "23",
    sno: 23,
    applicant_name: "Tanya Malhotra",
    case_id: "357260",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054022",
    case_received_date: "15-05-2026",
    sla_start_date: "16-05-2026",
    due_date: "31-05-2026",
    total_checks: 9,
    work_in_progress: 6,
    completed: 2,
    stop: 1,
    insuff_expire: "2",
    actions: "",
  },
  {
    key: "24",
    sno: 24,
    applicant_name: "Varun Chawla",
    case_id: "357261",
    case_spoc: "Shreyesth Kohli",
    employee_id: "CAND-1054023",
    case_received_date: "16-05-2026",
    sla_start_date: "17-05-2026",
    due_date: "01-06-2026",
    total_checks: 8,
    work_in_progress: 5,
    completed: 3,
    stop: 0,
    insuff_expire: "–",
    actions: "",
  },
];

// ------------------------------------
export const dummyData_revisedDate = [
  {
    key: "1",
    sno: 1,
    applicantName: "Prajwal Yadav",
    caseId: "365746",
    caseSpoc: "Govinda Bika",
    checkName: "Employment",
    keyValue: "NS MATRIX SERVICES PRIVATE LIMITED",
    reasonForDelay:
      "HR delay in response due to slow response from employer (High TAT Employer)",
    slaEndDate: "13-05-2026",
    overdueDays: 1,
    expectedDateOfClosure: "16-05-2026",
  },
  {
    key: "2",
    sno: 2,
    applicantName: "Meenakshi",
    caseId: "365720",
    caseSpoc: "Govinda Bika",
    checkName: "Employment",
    keyValue: "Globiva",
    reasonForDelay:
      "HR delay in response due to slow response from employer (High TAT Employer)",
    slaEndDate: "11-05-2026",
    overdueDays: 2,
    expectedDateOfClosure: "17-05-2026",
  },
  {
    key: "3",
    sno: 3,
    applicantName: "Shoaib Rasheed",
    caseId: "349218",
    caseSpoc: "Govinda Bika",
    checkName: "Education",
    keyValue: "Ananda College Jharkhand Academic Council",
    reasonForDelay:
      "Delay due to Older Records of the Student with their Colleges/Universities",
    slaEndDate: "06-05-2026",
    overdueDays: 5,
    expectedDateOfClosure: "15-05-2026",
  },
  {
    key: "4",
    sno: 4,
    applicantName: "Shoaib Rasheed",
    caseId: "349216",
    caseSpoc: "Govinda Bika",
    checkName: "Employment",
    keyValue: "TASKUS INDIA PRIVATE LIMITED",
    reasonForDelay:
      "HR delay in response due to slow response from employer (High TAT Employer)",
    slaEndDate: "06-05-2026",
    overdueDays: 8,
    expectedDateOfClosure: "12-05-2026",
  },
];

// ------------------------------------
export const dummyData_Insufficiency = [
  {
    key: 1,
    sno: 1,
    applicant_name: "Pratyusa Giri",
    case_id: "325219",
    case_spoc: "Shreyesh Kohli",
    key_value: "Sage University Sage University",
    check_name: "Education-1",
    email_id: "pratyusa@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-08",
    days_elapsed: 25,
  },
  {
    key: 2,
    sno: 2,
    applicant_name: "Vandit",
    case_id: "325223",
    case_spoc: "Shreyesh Kohli",
    key_value: "Pragati Vidya Peeth, Gwalior Central Board of Secondary",
    check_name: "Education-1",
    email_id: "vandit@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-08",
    days_elapsed: 25,
  },
  {
    key: 3,
    sno: 3,
    applicant_name: "Rohit Sharma",
    case_id: "325231",
    case_spoc: "Ankit Verma",
    key_value: "Delhi University, North Campus",
    check_name: "Education-2",
    email_id: "rohit.sharma@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-10",
    days_elapsed: 23,
  },
  {
    key: 4,
    sno: 4,
    applicant_name: "Sneha Pillai",
    case_id: "325240",
    case_spoc: "Ritika Joshi",
    key_value: "Amity University Noida",
    check_name: "Employment-1",
    email_id: "sneha.pillai@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-11",
    days_elapsed: 22,
  },
  {
    key: 5,
    sno: 5,
    applicant_name: "Karan Mehta",
    case_id: "325255",
    case_spoc: "Shreyesh Kohli",
    key_value: "ICSE Board Mumbai Secondary School",
    check_name: "Education-3",
    email_id: "karan.mehta@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-12",
    days_elapsed: 21,
  },
  {
    key: 6,
    sno: 6,
    applicant_name: "Divya Iyer",
    case_id: "325263",
    case_spoc: "Ankit Verma",
    key_value: "Infosys Ltd, Bangalore",
    check_name: "Employment-2",
    email_id: "divya.iyer@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-13",
    days_elapsed: 20,
  },
  {
    key: 7,
    sno: 7,
    applicant_name: "Vikram Yadav",
    case_id: "325278",
    case_spoc: "Ritika Joshi",
    key_value: "Symbiosis International University Pune",
    check_name: "Education-1",
    email_id: "vikram.yadav@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-14",
    days_elapsed: 19,
  },
  {
    key: 8,
    sno: 8,
    applicant_name: "Meena Desai",
    case_id: "325284",
    case_spoc: "Shreyesh Kohli",
    key_value: "TCS Mumbai Employment Record",
    check_name: "Employment-1",
    email_id: "meena.desai@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-14",
    days_elapsed: 19,
  },
  {
    key: 9,
    sno: 9,
    applicant_name: "Arjun Singh",
    case_id: "325299",
    case_spoc: "Ankit Verma",
    key_value: "Manipal Academy of Higher Education",
    check_name: "Education-2",
    email_id: "arjun.singh@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-15",
    days_elapsed: 18,
  },
  {
    key: 10,
    sno: 10,
    applicant_name: "Pooja Chauhan",
    case_id: "325307",
    case_spoc: "Ritika Joshi",
    key_value: "Wipro Technologies Hyderabad",
    check_name: "Employment-3",
    email_id: "pooja.chauhan@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-15",
    days_elapsed: 18,
  },
  {
    key: 11,
    sno: 11,
    applicant_name: "Rahul Saxena",
    case_id: "325314",
    case_spoc: "Shreyesh Kohli",
    key_value: "CBSE Board New Delhi Higher Secondary",
    check_name: "Education-3",
    email_id: "rahul.saxena@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-16",
    days_elapsed: 17,
  },
  {
    key: 12,
    sno: 12,
    applicant_name: "Ananya Reddy",
    case_id: "325322",
    case_spoc: "Ankit Verma",
    key_value: "Osmania University Hyderabad",
    check_name: "Education-1",
    email_id: "ananya.reddy@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-16",
    days_elapsed: 17,
  },
  {
    key: 13,
    sno: 13,
    applicant_name: "Suresh Pandey",
    case_id: "325338",
    case_spoc: "Ritika Joshi",
    key_value: "HCL Technologies Noida Employment Record",
    check_name: "Employment-2",
    email_id: "suresh.pandey@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-17",
    days_elapsed: 16,
  },
  {
    key: 14,
    sno: 14,
    applicant_name: "Kavita Joshi",
    case_id: "325345",
    case_spoc: "Shreyesh Kohli",
    key_value: "BITS Pilani Rajasthan Campus",
    check_name: "Education-2",
    email_id: "kavita.joshi@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-17",
    days_elapsed: 16,
  },
  {
    key: 15,
    sno: 15,
    applicant_name: "Nitin Agarwal",
    case_id: "325359",
    case_spoc: "Ankit Verma",
    key_value: "Accenture India Bangalore",
    check_name: "Employment-1",
    email_id: "nitin.agarwal@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-18",
    days_elapsed: 15,
  },
  {
    key: 16,
    sno: 16,
    applicant_name: "Priyanka Tiwari",
    case_id: "325366",
    case_spoc: "Ritika Joshi",
    key_value: "VIT University Vellore Tamil Nadu",
    check_name: "Education-3",
    email_id: "priyanka.tiwari@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-18",
    days_elapsed: 15,
  },
  {
    key: 17,
    sno: 17,
    applicant_name: "Deepak Malhotra",
    case_id: "325374",
    case_spoc: "Shreyesh Kohli",
    key_value: "Cognizant Technology Solutions Chennai",
    check_name: "Employment-3",
    email_id: "deepak.malhotra@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-19",
    days_elapsed: 14,
  },
  {
    key: 18,
    sno: 18,
    applicant_name: "Ritu Gupta",
    case_id: "325381",
    case_spoc: "Ankit Verma",
    key_value: "Jawaharlal Nehru University New Delhi",
    check_name: "Education-1",
    email_id: "ritu.gupta@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-19",
    days_elapsed: 14,
  },
  {
    key: 19,
    sno: 19,
    applicant_name: "Manish Bose",
    case_id: "325395",
    case_spoc: "Ritika Joshi",
    key_value: "Tech Mahindra Pune Employment Record",
    check_name: "Employment-2",
    email_id: "manish.bose@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-20",
    days_elapsed: 13,
  },
  {
    key: 20,
    sno: 20,
    applicant_name: "Sonal Verma",
    case_id: "325402",
    case_spoc: "Shreyesh Kohli",
    key_value: "Calcutta University West Bengal",
    check_name: "Education-2",
    email_id: "sonal.verma@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-20",
    days_elapsed: 13,
  },
  {
    key: 21,
    sno: 21,
    applicant_name: "Aakash Kulkarni",
    case_id: "325418",
    case_spoc: "Ankit Verma",
    key_value: "Mphasis Limited Bangalore Employment",
    check_name: "Employment-1",
    email_id: "aakash.kulkarni@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-21",
    days_elapsed: 12,
  },
  {
    key: 22,
    sno: 22,
    applicant_name: "Tanuja Pillai",
    case_id: "325425",
    case_spoc: "Ritika Joshi",
    key_value: "Anna University Chennai Tamil Nadu",
    check_name: "Education-3",
    email_id: "tanuja.pillai@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-21",
    days_elapsed: 12,
  },
  {
    key: 23,
    sno: 23,
    applicant_name: "Gaurav Dubey",
    case_id: "325439",
    case_spoc: "Shreyesh Kohli",
    key_value: "IBM India Private Limited Gurgaon",
    check_name: "Employment-3",
    email_id: "gaurav.dubey@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-22",
    days_elapsed: 11,
  },
  {
    key: 24,
    sno: 24,
    applicant_name: "Pallavi Nair",
    case_id: "325446",
    case_spoc: "Ankit Verma",
    key_value: "Pune University Maharashtra",
    check_name: "Education-1",
    email_id: "pallavi.nair@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-22",
    days_elapsed: 11,
  },
  {
    key: 25,
    sno: 25,
    applicant_name: "Aditya Thakur",
    case_id: "325461",
    case_spoc: "Ritika Joshi",
    key_value: "Oracle India Pvt Ltd Hyderabad",
    check_name: "Employment-2",
    email_id: "aditya.thakur@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-23",
    days_elapsed: 10,
  },
  {
    key: 26,
    sno: 26,
    applicant_name: "Neha Kapoor",
    case_id: "325478",
    case_spoc: "Shreyesh Kohli",
    key_value: "Rajasthan University Jaipur",
    check_name: "Education-2",
    email_id: "neha.kapoor@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-23",
    days_elapsed: 10,
  },
  {
    key: 27,
    sno: 27,
    applicant_name: "Siddharth Rao",
    case_id: "325485",
    case_spoc: "Ankit Verma",
    key_value: "Capgemini India Bangalore Employment",
    check_name: "Employment-1",
    email_id: "siddharth.rao@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-24",
    days_elapsed: 9,
  },
  {
    key: 28,
    sno: 28,
    applicant_name: "Ishita Banerjee",
    case_id: "325492",
    case_spoc: "Ritika Joshi",
    key_value: "Jadavpur University Kolkata West Bengal",
    check_name: "Education-3",
    email_id: "ishita.banerjee@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-24",
    days_elapsed: 9,
  },
  {
    key: 29,
    sno: 29,
    applicant_name: "Harish Walia",
    case_id: "325506",
    case_spoc: "Shreyesh Kohli",
    key_value: "SAP Labs India Bangalore Employment",
    check_name: "Employment-3",
    email_id: "harish.walia@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-25",
    days_elapsed: 8,
  },
  {
    key: 30,
    sno: 30,
    applicant_name: "Simran Mishra",
    case_id: "325513",
    case_spoc: "Ankit Verma",
    key_value: "Bangalore University Karnataka",
    check_name: "Education-1",
    email_id: "simran.mishra@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-25",
    days_elapsed: 8,
  },
  {
    key: 31,
    sno: 31,
    applicant_name: "Rajesh Trivedi",
    case_id: "325527",
    case_spoc: "Ritika Joshi",
    key_value: "Zensar Technologies Pune Employment",
    check_name: "Employment-2",
    email_id: "rajesh.trivedi@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-26",
    days_elapsed: 7,
  },
  {
    key: 32,
    sno: 32,
    applicant_name: "Shruti Rastogi",
    case_id: "325534",
    case_spoc: "Shreyesh Kohli",
    key_value: "Lucknow University Uttar Pradesh",
    check_name: "Education-2",
    email_id: "shruti.rastogi@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-27",
    days_elapsed: 6,
  },
  {
    key: 33,
    sno: 33,
    applicant_name: "Yash Patil",
    case_id: "325548",
    case_spoc: "Ankit Verma",
    key_value: "L&T Infotech Mumbai Employment Record",
    check_name: "Employment-1",
    email_id: "yash.patil@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-04-28",
    days_elapsed: 5,
  },
  {
    key: 34,
    sno: 34,
    applicant_name: "Ankita Shukla",
    case_id: "325555",
    case_spoc: "Ritika Joshi",
    key_value: "Madras University Chennai Tamil Nadu",
    check_name: "Education-3",
    email_id: "ankita.shukla@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-04-29",
    days_elapsed: 4,
  },
];

// ------------------------------------
export const dummyData_hrApproval = [];

// ------------------------------------
export const dummyData_ExtraCost = [
  {
    key: 1,
    sno: 1,
    applicant_name: "Jai Bhatia",
    sbu_name: "AIRBNB",
    case_id: "357258",
    check_name: "International Education",
    key_value: "Bachelor Of Science Game Development",
    amount: "USD 20.0",
    approval_status: "Pending",
    created_at: "2026-05-01",
    case_spoc: "Shubham Pal",
    email_id: "jai@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 2,
    sno: 2,
    applicant_name: "Priya Sharma",
    sbu_name: "GOOGLE",
    case_id: "357259",
    check_name: "International Employment",
    key_value: "Software Engineer L4",
    amount: "USD 35.0",
    approval_status: "Approved",
    created_at: "2026-05-01",
    case_spoc: "Ritika Joshi",
    email_id: "priya.sharma@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 3,
    sno: 3,
    applicant_name: "Rohit Mehta",
    sbu_name: "AMAZON",
    case_id: "357260",
    check_name: "International Education",
    key_value: "Master Of Business Administration",
    amount: "USD 25.0",
    approval_status: "Pending",
    created_at: "2026-05-02",
    case_spoc: "Ankit Verma",
    email_id: "rohit.mehta@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 4,
    sno: 4,
    applicant_name: "Sneha Iyer",
    sbu_name: "MICROSOFT",
    case_id: "357261",
    check_name: "International Criminal Record",
    key_value: "Criminal Background Check USA",
    amount: "USD 40.0",
    approval_status: "Approved",
    created_at: "2026-05-02",
    case_spoc: "Shubham Pal",
    email_id: "sneha.iyer@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 5,
    sno: 5,
    applicant_name: "Karan Nair",
    sbu_name: "UBER",
    case_id: "357262",
    check_name: "International Employment",
    key_value: "Product Manager Senior",
    amount: "USD 30.0",
    approval_status: "Rejected",
    created_at: "2026-05-02",
    case_spoc: "Ritika Joshi",
    email_id: "karan.nair@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Failed",
  },
  {
    key: 6,
    sno: 6,
    applicant_name: "Divya Pillai",
    sbu_name: "AIRBNB",
    case_id: "357263",
    check_name: "International Education",
    key_value: "Bachelor Of Engineering Computer Science",
    amount: "USD 20.0",
    approval_status: "Pending",
    created_at: "2026-05-03",
    case_spoc: "Ankit Verma",
    email_id: "divya.pillai@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 7,
    sno: 7,
    applicant_name: "Vikram Rao",
    sbu_name: "GOOGLE",
    case_id: "357264",
    check_name: "International Address",
    key_value: "Address Verification UK",
    amount: "USD 15.0",
    approval_status: "Approved",
    created_at: "2026-05-03",
    case_spoc: "Shubham Pal",
    email_id: "vikram.rao@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 8,
    sno: 8,
    applicant_name: "Meena Desai",
    sbu_name: "AMAZON",
    case_id: "357265",
    check_name: "International Employment",
    key_value: "Data Scientist Principal",
    amount: "USD 35.0",
    approval_status: "Pending",
    created_at: "2026-05-03",
    case_spoc: "Ritika Joshi",
    email_id: "meena.desai@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 9,
    sno: 9,
    applicant_name: "Arjun Singh",
    sbu_name: "MICROSOFT",
    case_id: "357266",
    check_name: "International Education",
    key_value: "Master Of Science Data Analytics",
    amount: "USD 25.0",
    approval_status: "Approved",
    created_at: "2026-05-04",
    case_spoc: "Ankit Verma",
    email_id: "arjun.singh@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 10,
    sno: 10,
    applicant_name: "Pooja Chauhan",
    sbu_name: "UBER",
    case_id: "357267",
    check_name: "International Criminal Record",
    key_value: "Criminal Background Check Canada",
    amount: "USD 45.0",
    approval_status: "Rejected",
    created_at: "2026-05-04",
    case_spoc: "Shubham Pal",
    email_id: "pooja.chauhan@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Failed",
  },
  {
    key: 11,
    sno: 11,
    applicant_name: "Rahul Saxena",
    sbu_name: "AIRBNB",
    case_id: "357268",
    check_name: "International Employment",
    key_value: "DevOps Engineer Senior",
    amount: "USD 30.0",
    approval_status: "Pending",
    created_at: "2026-05-04",
    case_spoc: "Ritika Joshi",
    email_id: "rahul.saxena@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 12,
    sno: 12,
    applicant_name: "Ananya Reddy",
    sbu_name: "GOOGLE",
    case_id: "357269",
    check_name: "International Education",
    key_value: "Doctor Of Philosophy Computer Science",
    amount: "USD 20.0",
    approval_status: "Approved",
    created_at: "2026-05-05",
    case_spoc: "Ankit Verma",
    email_id: "ananya.reddy@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 13,
    sno: 13,
    applicant_name: "Suresh Pandey",
    sbu_name: "AMAZON",
    case_id: "357270",
    check_name: "International Address",
    key_value: "Address Verification Australia",
    amount: "USD 15.0",
    approval_status: "Pending",
    created_at: "2026-05-05",
    case_spoc: "Shubham Pal",
    email_id: "suresh.pandey@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 14,
    sno: 14,
    applicant_name: "Kavita Joshi",
    sbu_name: "MICROSOFT",
    case_id: "357271",
    check_name: "International Employment",
    key_value: "Cloud Architect Lead",
    amount: "USD 35.0",
    approval_status: "Approved",
    created_at: "2026-05-05",
    case_spoc: "Ritika Joshi",
    email_id: "kavita.joshi@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 15,
    sno: 15,
    applicant_name: "Nitin Agarwal",
    sbu_name: "UBER",
    case_id: "357272",
    check_name: "International Education",
    key_value: "Bachelor Of Technology Mechanical",
    amount: "USD 20.0",
    approval_status: "Rejected",
    created_at: "2026-05-06",
    case_spoc: "Ankit Verma",
    email_id: "nitin.agarwal@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Failed",
  },
  {
    key: 16,
    sno: 16,
    applicant_name: "Priyanka Tiwari",
    sbu_name: "AIRBNB",
    case_id: "357273",
    check_name: "International Criminal Record",
    key_value: "Criminal Background Check Germany",
    amount: "USD 50.0",
    approval_status: "Pending",
    created_at: "2026-05-06",
    case_spoc: "Shubham Pal",
    email_id: "priyanka.tiwari@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 17,
    sno: 17,
    applicant_name: "Deepak Malhotra",
    sbu_name: "GOOGLE",
    case_id: "357274",
    check_name: "International Employment",
    key_value: "Full Stack Developer Senior",
    amount: "USD 30.0",
    approval_status: "Approved",
    created_at: "2026-05-06",
    case_spoc: "Ritika Joshi",
    email_id: "deepak.malhotra@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 18,
    sno: 18,
    applicant_name: "Ritu Gupta",
    sbu_name: "AMAZON",
    case_id: "357275",
    check_name: "International Education",
    key_value: "Master Of Technology Electronics",
    amount: "USD 25.0",
    approval_status: "Pending",
    created_at: "2026-05-07",
    case_spoc: "Ankit Verma",
    email_id: "ritu.gupta@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 19,
    sno: 19,
    applicant_name: "Manish Bose",
    sbu_name: "MICROSOFT",
    case_id: "357276",
    check_name: "International Address",
    key_value: "Address Verification Singapore",
    amount: "USD 15.0",
    approval_status: "Approved",
    created_at: "2026-05-07",
    case_spoc: "Shubham Pal",
    email_id: "manish.bose@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 20,
    sno: 20,
    applicant_name: "Sonal Verma",
    sbu_name: "UBER",
    case_id: "357277",
    check_name: "International Employment",
    key_value: "Machine Learning Engineer",
    amount: "USD 35.0",
    approval_status: "Rejected",
    created_at: "2026-05-07",
    case_spoc: "Ritika Joshi",
    email_id: "sonal.verma@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Failed",
  },
  {
    key: 21,
    sno: 21,
    applicant_name: "Aakash Kulkarni",
    sbu_name: "AIRBNB",
    case_id: "357278",
    check_name: "International Education",
    key_value: "Bachelor Of Commerce Accounting",
    amount: "USD 20.0",
    approval_status: "Pending",
    created_at: "2026-05-08",
    case_spoc: "Ankit Verma",
    email_id: "aakash.kulkarni@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 22,
    sno: 22,
    applicant_name: "Tanuja Pillai",
    sbu_name: "GOOGLE",
    case_id: "357279",
    check_name: "International Criminal Record",
    key_value: "Criminal Background Check UAE",
    amount: "USD 45.0",
    approval_status: "Approved",
    created_at: "2026-05-08",
    case_spoc: "Shubham Pal",
    email_id: "tanuja.pillai@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 23,
    sno: 23,
    applicant_name: "Gaurav Dubey",
    sbu_name: "AMAZON",
    case_id: "357280",
    check_name: "International Employment",
    key_value: "Business Analyst Manager",
    amount: "USD 30.0",
    approval_status: "Pending",
    created_at: "2026-05-08",
    case_spoc: "Ritika Joshi",
    email_id: "gaurav.dubey@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 24,
    sno: 24,
    applicant_name: "Pallavi Nair",
    sbu_name: "MICROSOFT",
    case_id: "357281",
    check_name: "International Education",
    key_value: "Master Of Science Artificial Intelligence",
    amount: "USD 25.0",
    approval_status: "Approved",
    created_at: "2026-05-09",
    case_spoc: "Ankit Verma",
    email_id: "pallavi.nair@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 25,
    sno: 25,
    applicant_name: "Aditya Thakur",
    sbu_name: "UBER",
    case_id: "357282",
    check_name: "International Address",
    key_value: "Address Verification Japan",
    amount: "USD 15.0",
    approval_status: "Pending",
    created_at: "2026-05-09",
    case_spoc: "Shubham Pal",
    email_id: "aditya.thakur@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 26,
    sno: 26,
    applicant_name: "Neha Kapoor",
    sbu_name: "AIRBNB",
    case_id: "357283",
    check_name: "International Employment",
    key_value: "HR Manager Director",
    amount: "USD 35.0",
    approval_status: "Rejected",
    created_at: "2026-05-09",
    case_spoc: "Ritika Joshi",
    email_id: "neha.kapoor@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Failed",
  },
  {
    key: 27,
    sno: 27,
    applicant_name: "Siddharth Rao",
    sbu_name: "GOOGLE",
    case_id: "357284",
    check_name: "International Education",
    key_value: "Bachelor Of Arts Economics",
    amount: "USD 20.0",
    approval_status: "Approved",
    created_at: "2026-05-10",
    case_spoc: "Ankit Verma",
    email_id: "siddharth.rao@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 28,
    sno: 28,
    applicant_name: "Ishita Banerjee",
    sbu_name: "AMAZON",
    case_id: "357285",
    check_name: "International Criminal Record",
    key_value: "Criminal Background Check France",
    amount: "USD 50.0",
    approval_status: "Pending",
    created_at: "2026-05-10",
    case_spoc: "Shubham Pal",
    email_id: "ishita.banerjee@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 29,
    sno: 29,
    applicant_name: "Harish Walia",
    sbu_name: "MICROSOFT",
    case_id: "357286",
    check_name: "International Employment",
    key_value: "Finance Manager VP",
    amount: "USD 30.0",
    approval_status: "Approved",
    created_at: "2026-05-10",
    case_spoc: "Ritika Joshi",
    email_id: "harish.walia@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 30,
    sno: 30,
    applicant_name: "Simran Mishra",
    sbu_name: "UBER",
    case_id: "357287",
    check_name: "International Education",
    key_value: "Master Of Science Cyber Security",
    amount: "USD 25.0",
    approval_status: "Pending",
    created_at: "2026-05-11",
    case_spoc: "Ankit Verma",
    email_id: "simran.mishra@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 31,
    sno: 31,
    applicant_name: "Rajesh Trivedi",
    sbu_name: "AIRBNB",
    case_id: "357288",
    check_name: "International Address",
    key_value: "Address Verification New Zealand",
    amount: "USD 15.0",
    approval_status: "Approved",
    created_at: "2026-05-11",
    case_spoc: "Shubham Pal",
    email_id: "rajesh.trivedi@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 32,
    sno: 32,
    applicant_name: "Shruti Rastogi",
    sbu_name: "GOOGLE",
    case_id: "357289",
    check_name: "International Employment",
    key_value: "Operations Manager Lead",
    amount: "USD 35.0",
    approval_status: "Rejected",
    created_at: "2026-05-11",
    case_spoc: "Ritika Joshi",
    email_id: "shruti.rastogi@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Failed",
  },
  {
    key: 33,
    sno: 33,
    applicant_name: "Yash Patil",
    sbu_name: "AMAZON",
    case_id: "357290",
    check_name: "International Education",
    key_value: "Bachelor Of Science Information Technology",
    amount: "USD 20.0",
    approval_status: "Pending",
    created_at: "2026-05-12",
    case_spoc: "Ankit Verma",
    email_id: "yash.patil@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 34,
    sno: 34,
    applicant_name: "Ankita Shukla",
    sbu_name: "MICROSOFT",
    case_id: "357291",
    check_name: "International Criminal Record",
    key_value: "Criminal Background Check Netherlands",
    amount: "USD 45.0",
    approval_status: "Approved",
    created_at: "2026-05-12",
    case_spoc: "Shubham Pal",
    email_id: "ankita.shukla@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 35,
    sno: 35,
    applicant_name: "Piyush Goswami",
    sbu_name: "UBER",
    case_id: "357292",
    check_name: "International Employment",
    key_value: "Supply Chain Manager Director",
    amount: "USD 30.0",
    approval_status: "Pending",
    created_at: "2026-05-12",
    case_spoc: "Ritika Joshi",
    email_id: "piyush.goswami@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 36,
    sno: 36,
    applicant_name: "Roshni Verma",
    sbu_name: "AIRBNB",
    case_id: "357293",
    check_name: "International Education",
    key_value: "Master Of Engineering Civil",
    amount: "USD 25.0",
    approval_status: "Approved",
    created_at: "2026-05-13",
    case_spoc: "Ankit Verma",
    email_id: "roshni.verma@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 37,
    sno: 37,
    applicant_name: "Tarun Joshi",
    sbu_name: "GOOGLE",
    case_id: "357294",
    check_name: "International Address",
    key_value: "Address Verification South Korea",
    amount: "USD 15.0",
    approval_status: "Pending",
    created_at: "2026-05-13",
    case_spoc: "Shubham Pal",
    email_id: "tarun.joshi@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 38,
    sno: 38,
    applicant_name: "Nidhi Srivastava",
    sbu_name: "AMAZON",
    case_id: "357295",
    check_name: "International Employment",
    key_value: "Sales Director Regional",
    amount: "USD 35.0",
    approval_status: "Rejected",
    created_at: "2026-05-13",
    case_spoc: "Ritika Joshi",
    email_id: "nidhi.srivastava@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Failed",
  },
  {
    key: 39,
    sno: 39,
    applicant_name: "Abhijit Patil",
    sbu_name: "MICROSOFT",
    case_id: "357296",
    check_name: "International Education",
    key_value: "Bachelor Of Science Biotechnology",
    amount: "USD 20.0",
    approval_status: "Pending",
    created_at: "2026-05-14",
    case_spoc: "Ankit Verma",
    email_id: "abhijit.patil@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 40,
    sno: 40,
    applicant_name: "Komal Shukla",
    sbu_name: "UBER",
    case_id: "357297",
    check_name: "International Criminal Record",
    key_value: "Criminal Background Check Sweden",
    amount: "USD 50.0",
    approval_status: "Approved",
    created_at: "2026-05-14",
    case_spoc: "Shubham Pal",
    email_id: "komal.shukla@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 41,
    sno: 41,
    applicant_name: "Vikas Bhatia",
    sbu_name: "AIRBNB",
    case_id: "357298",
    check_name: "International Employment",
    key_value: "Marketing Manager VP",
    amount: "USD 30.0",
    approval_status: "Pending",
    created_at: "2026-05-14",
    case_spoc: "Ritika Joshi",
    email_id: "vikas.bhatia@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  {
    key: 42,
    sno: 42,
    applicant_name: "Payal Dubey",
    sbu_name: "GOOGLE",
    case_id: "357299",
    check_name: "International Education",
    key_value: "Master Of Science Robotics",
    amount: "USD 25.0",
    approval_status: "Approved",
    created_at: "2026-05-15",
    case_spoc: "Ankit Verma",
    email_id: "payal.dubey@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Paid",
  },
  {
    key: 43,
    sno: 43,
    applicant_name: "Sachin Nair",
    sbu_name: "AMAZON",
    case_id: "357300",
    check_name: "International Address",
    key_value: "Address Verification Switzerland",
    amount: "USD 15.0",
    approval_status: "Pending",
    created_at: "2026-05-15",
    case_spoc: "Shubham Pal",
    email_id: "sachin.nair@gmail.com",
    payment_link: "Payment URL",
    payment_status: "Pending",
  },
  // {
  //   key: 44,
  //   sno: 44,
  //   applicant_name: "Bhavna Saxena",
  //   sbu_name: "MICROSOFT",
  //   case_id: "357301",
  //   check_name: "International Employment",
  //   key_value: "Legal Counsel Senior Associate",
  //   amount: "USD 35.0",
  //   approval_status: "Rejected",
  //   created_at: "2026-05-15",
  //   case_spoc: "Ritika Joshi",
  //   email_id: "bhavna.saxena@gmail.com",
  //   payment_link: "Payment URL",
  //   payment_status: "Failed",
  // },
  // {
  //   key: 45,
  //   sno: 45,
  //   applicant_name: "Ramesh Pillai",
  //   sbu_name: "UBER",
  //   case_id: "357302",
  //   check_name: "International Education",
  //   key_value: "Bachelor Of Science Physics",
  //   amount: "USD 20.0",
  //   approval_status: "Approved",
  //   created_at: "2026-05-16",
  //   case_spoc: "Ankit Verma",
  //   email_id: "ramesh.pillai@gmail.com",
  //   payment_link: "Payment URL",
  //   payment_status: "Paid",
  // },
];

// ------------------------------------
export const dummyData_expiredInsufficiency = [
  {
    key: 1,
    sno: 1,
    applicant_name: "Pratyusa Giri",
    case_id: "325219",
    case_spoc: "Shreyesh Kohli",
    key_value: "Sage University Sage University",
    check_name: "Education-1",
    email_id: "pratyusa@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-01-05",
    days_elapsed: 45,
    status: "Expired",
  },
  {
    key: 2,
    sno: 2,
    applicant_name: "Rohit Sharma",
    case_id: "325220",
    case_spoc: "Anita Verma",
    key_value: "Delhi University Delhi University",
    check_name: "Education-2",
    email_id: "rohit.sharma@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-01-10",
    days_elapsed: 40,
    status: "Expired",
  },
  {
    key: 3,
    sno: 3,
    applicant_name: "Sneha Patil",
    case_id: "325221",
    case_spoc: "Karan Mehta",
    key_value: "Mumbai University Mumbai University",
    check_name: "Employment-1",
    email_id: "sneha.patil@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-01-12",
    days_elapsed: 38,
    status: "Expired",
  },
  {
    key: 4,
    sno: 4,
    applicant_name: "Amit Tiwari",
    case_id: "325222",
    case_spoc: "Pooja Singh",
    key_value: "IIT Bombay IIT Bombay",
    check_name: "Address-1",
    email_id: "amit.tiwari@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-01-15",
    days_elapsed: 35,
    status: "Expired",
  },
  {
    key: 5,
    sno: 5,
    applicant_name: "Priya Nair",
    case_id: "325223",
    case_spoc: "Rahul Joshi",
    key_value: "Pune University Pune University",
    check_name: "Identity-1",
    email_id: "priya.nair@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-01-18",
    days_elapsed: 32,
    status: "Expired",
  },
  {
    key: 6,
    sno: 6,
    applicant_name: "Vikram Bose",
    case_id: "325224",
    case_spoc: "Shreyesh Kohli",
    key_value: "Jadavpur University Jadavpur University",
    check_name: "Education-3",
    email_id: "vikram.bose@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-01-20",
    days_elapsed: 30,
    status: "Expired",
  },
  {
    key: 7,
    sno: 7,
    applicant_name: "Meera Iyer",
    case_id: "325225",
    case_spoc: "Anita Verma",
    key_value: "Anna University Anna University",
    check_name: "Employment-2",
    email_id: "meera.iyer@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-01-22",
    days_elapsed: 28,
    status: "Expired",
  },
  {
    key: 8,
    sno: 8,
    applicant_name: "Suresh Kumar",
    case_id: "325226",
    case_spoc: "Karan Mehta",
    key_value: "Osmania University Osmania University",
    check_name: "Reference-1",
    email_id: "suresh.kumar@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-01-25",
    days_elapsed: 25,
    status: "Expired",
  },
  {
    key: 9,
    sno: 9,
    applicant_name: "Divya Menon",
    case_id: "325227",
    case_spoc: "Pooja Singh",
    key_value: "Kerala University Kerala University",
    check_name: "Address-2",
    email_id: "divya.menon@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-01-28",
    days_elapsed: 22,
    status: "Expired",
  },
  {
    key: 10,
    sno: 10,
    applicant_name: "Arjun Reddy",
    case_id: "325228",
    case_spoc: "Rahul Joshi",
    key_value: "Andhra University Andhra University",
    check_name: "Education-1",
    email_id: "arjun.reddy@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-02-01",
    days_elapsed: 20,
    status: "Expired",
  },
  {
    key: 11,
    sno: 11,
    applicant_name: "Kavitha Rao",
    case_id: "325229",
    case_spoc: "Shreyesh Kohli",
    key_value: "Bangalore University Bangalore University",
    check_name: "Employment-3",
    email_id: "kavitha.rao@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-02-04",
    days_elapsed: 18,
    status: "Expired",
  },
  {
    key: 12,
    sno: 12,
    applicant_name: "Nikhil Desai",
    case_id: "325230",
    case_spoc: "Anita Verma",
    key_value: "Gujarat University Gujarat University",
    check_name: "Identity-2",
    email_id: "nikhil.desai@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-02-06",
    days_elapsed: 16,
    status: "Expired",
  },
  {
    key: 13,
    sno: 13,
    applicant_name: "Ritu Agarwal",
    case_id: "325231",
    case_spoc: "Karan Mehta",
    key_value: "Rajasthan University Rajasthan University",
    check_name: "Reference-2",
    email_id: "ritu.agarwal@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-02-09",
    days_elapsed: 13,
    status: "Expired",
  },
  {
    key: 14,
    sno: 14,
    applicant_name: "Sanjay Patel",
    case_id: "325232",
    case_spoc: "Pooja Singh",
    key_value: "Baroda University Baroda University",
    check_name: "Education-2",
    email_id: "sanjay.patel@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-02-11",
    days_elapsed: 11,
    status: "Expired",
  },
  {
    key: 15,
    sno: 15,
    applicant_name: "Ananya Das",
    case_id: "325233",
    case_spoc: "Rahul Joshi",
    key_value: "Calcutta University Calcutta University",
    check_name: "Address-1",
    email_id: "ananya.das@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-02-14",
    days_elapsed: 8,
    status: "Expired",
  },
  {
    key: 16,
    sno: 16,
    applicant_name: "Manoj Gupta",
    case_id: "325234",
    case_spoc: "Shreyesh Kohli",
    key_value: "Lucknow University Lucknow University",
    check_name: "Employment-1",
    email_id: "manoj.gupta@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-02-16",
    days_elapsed: 6,
    status: "Expired",
  },
  {
    key: 17,
    sno: 17,
    applicant_name: "Pooja Bhatt",
    case_id: "325235",
    case_spoc: "Anita Verma",
    key_value: "Himachal Pradesh University HP University",
    check_name: "Identity-1",
    email_id: "pooja.bhatt@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-02-18",
    days_elapsed: 4,
    status: "Expired",
  },
  {
    key: 18,
    sno: 18,
    applicant_name: "Tarun Saxena",
    case_id: "325236",
    case_spoc: "Karan Mehta",
    key_value: "Agra University Agra University",
    check_name: "Reference-1",
    email_id: "tarun.saxena@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-02-20",
    days_elapsed: 50,
    status: "Expired",
  },
  {
    key: 19,
    sno: 19,
    applicant_name: "Swati Jain",
    case_id: "325237",
    case_spoc: "Pooja Singh",
    key_value: "Indore University Indore University",
    check_name: "Education-3",
    email_id: "swati.jain@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-02-22",
    days_elapsed: 48,
    status: "Expired",
  },
  {
    key: 20,
    sno: 20,
    applicant_name: "Harish Nambiar",
    case_id: "325238",
    case_spoc: "Rahul Joshi",
    key_value: "Cochin University Cochin University",
    check_name: "Employment-2",
    email_id: "harish.nambiar@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-02-25",
    days_elapsed: 44,
    status: "Expired",
  },
  {
    key: 21,
    sno: 21,
    applicant_name: "Deepika Srivastava",
    case_id: "325239",
    case_spoc: "Shreyesh Kohli",
    key_value: "BHU Banaras Hindu University",
    check_name: "Address-2",
    email_id: "deepika.srivastava@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-02-27",
    days_elapsed: 42,
    status: "Expired",
  },
  {
    key: 22,
    sno: 22,
    applicant_name: "Gaurav Mishra",
    case_id: "325240",
    case_spoc: "Anita Verma",
    key_value: "Allahabad University Allahabad University",
    check_name: "Education-1",
    email_id: "gaurav.mishra@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-03-01",
    days_elapsed: 39,
    status: "Expired",
  },
  {
    key: 23,
    sno: 23,
    applicant_name: "Radhika Pillai",
    case_id: "325241",
    case_spoc: "Karan Mehta",
    key_value: "Manipal University Manipal University",
    check_name: "Identity-2",
    email_id: "radhika.pillai@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-03-04",
    days_elapsed: 36,
    status: "Expired",
  },
  {
    key: 24,
    sno: 24,
    applicant_name: "Aakash Chopra",
    case_id: "325242",
    case_spoc: "Pooja Singh",
    key_value: "Symbiosis University Symbiosis University",
    check_name: "Employment-3",
    email_id: "aakash.chopra@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-03-07",
    days_elapsed: 33,
    status: "Expired",
  },
  {
    key: 25,
    sno: 25,
    applicant_name: "Nalini Krishnan",
    case_id: "325243",
    case_spoc: "Rahul Joshi",
    key_value: "Madurai University Madurai University",
    check_name: "Reference-2",
    email_id: "nalini.krishnan@gmail.com",
    insufficiency_type: "L2 Insufficiency Raised",
    raise_date: "2026-03-10",
    days_elapsed: 30,
    status: "Expired",
  },
  {
    key: 26,
    sno: 26,
    applicant_name: "Vivek Pandey",
    case_id: "325244",
    case_spoc: "Shreyesh Kohli",
    key_value: "Guwahati University Guwahati University",
    check_name: "Address-1",
    email_id: "vivek.pandey@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-03-13",
    days_elapsed: 27,
    status: "Expired",
  },
  {
    key: 27,
    sno: 27,
    applicant_name: "Ishaan Tripathi",
    case_id: "325245",
    case_spoc: "Anita Verma",
    key_value: "Amity University Amity University",
    check_name: "Education-2",
    email_id: "ishaan.tripathi@gmail.com",
    insufficiency_type: "L1 Insufficiency Raised",
    raise_date: "2026-03-16",
    days_elapsed: 24,
    status: "Expired",
  },
];

// ------------------------------------
export const dummyData_finalReport = [
  {
    sno: 1,
    applicantName: "Deepali Singh",
    caseId: "374500",
    emailId: "deepali.singh@gmail.com",
    slaDueDate: "15 May 2026",
    completionDate: "16 May 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 3,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "Not Started",
    processingTime: "0h 45m",
    viewLog: true,
  },
  {
    sno: 2,
    applicantName: "Priya Kapoor",
    caseId: "374501",
    emailId: "priya.kapoor@gmail.com",
    slaDueDate: "17 May 2026",
    completionDate: "18 May 2026",
    downloadReport: true,
    colour: "Red",
    totalChecks: 4,
    completed: 2,
    stopChecks: 1,
    insuffExpire: 1,
    hiringStatus: "On Hold",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "1h 10m",
    viewLog: true,
  },
  {
    sno: 3,
    applicantName: "Arjun Sharma",
    caseId: "374502",
    emailId: "arjun.sharma@gmail.com",
    slaDueDate: "18 May 2026",
    completionDate: "19 May 2026",
    downloadReport: false,
    colour: "Green",
    totalChecks: 5,
    completed: 5,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "2h 30m",
    viewLog: true,
  },
  {
    sno: 4,
    applicantName: "Rohit Mehra",
    caseId: "412300",
    emailId: "rohit.mehra@gmail.com",
    slaDueDate: "29 May 2026",
    completionDate: "16 May 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 5,
    completed: 5,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "3h 20m",
    viewLog: true,
  },
  {
    sno: 5,
    applicantName: "Neha Joshi",
    caseId: "412301",
    emailId: "neha.joshi@gmail.com",
    slaDueDate: "20 May 2026",
    completionDate: "21 May 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 4,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "1h 55m",
    viewLog: true,
  },
  {
    sno: 6,
    applicantName: "Vikram Nair",
    caseId: "412302",
    emailId: "vikram.nair@gmail.com",
    slaDueDate: "22 May 2026",
    completionDate: "23 May 2026",
    downloadReport: false,
    colour: "Red",
    totalChecks: 6,
    completed: 3,
    stopChecks: 2,
    insuffExpire: 1,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "4h 05m",
    viewLog: true,
  },
  {
    sno: 7,
    applicantName: "Sneha Patil",
    caseId: "412303",
    emailId: "sneha.patil@gmail.com",
    slaDueDate: "24 May 2026",
    completionDate: "25 May 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 3,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "2h 15m",
    viewLog: true,
  },
  {
    sno: 8,
    applicantName: "Karan Gupta",
    caseId: "412304",
    emailId: "karan.gupta@gmail.com",
    slaDueDate: "25 May 2026",
    completionDate: "26 May 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 5,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "3h 00m",
    viewLog: false,
  },
  {
    sno: 9,
    applicantName: "Meera Iyer",
    caseId: "412305",
    emailId: "meera.iyer@gmail.com",
    slaDueDate: "26 May 2026",
    completionDate: "27 May 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 4,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "1h 40m",
    viewLog: true,
  },
  {
    sno: 10,
    applicantName: "Rahul Verma",
    caseId: "412306",
    emailId: "rahul.verma@gmail.com",
    slaDueDate: "28 May 2026",
    completionDate: "29 May 2026",
    downloadReport: false,
    colour: "Red",
    totalChecks: 5,
    completed: 2,
    stopChecks: 2,
    insuffExpire: 1,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "5h 10m",
    viewLog: true,
  },
  {
    sno: 11,
    applicantName: "Ananya Bose",
    caseId: "412307",
    emailId: "ananya.bose@gmail.com",
    slaDueDate: "30 May 2026",
    completionDate: "31 May 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 3,
    completed: 2,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "0h 55m",
    viewLog: true,
  },
  {
    sno: 12,
    applicantName: "Suresh Pillai",
    caseId: "412308",
    emailId: "suresh.pillai@gmail.com",
    slaDueDate: "01 Jun 2026",
    completionDate: "02 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 6,
    completed: 6,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "4h 25m",
    viewLog: true,
  },
  {
    sno: 13,
    applicantName: "Divya Menon",
    caseId: "412309",
    emailId: "divya.menon@gmail.com",
    slaDueDate: "03 Jun 2026",
    completionDate: "04 Jun 2026",
    downloadReport: false,
    colour: "Orange",
    totalChecks: 4,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "On Hold",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "2h 50m",
    viewLog: true,
  },
  {
    sno: 14,
    applicantName: "Aditya Rao",
    caseId: "412310",
    emailId: "aditya.rao@gmail.com",
    slaDueDate: "05 Jun 2026",
    completionDate: "06 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 3,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "1h 20m",
    viewLog: false,
  },
  {
    sno: 15,
    applicantName: "Pooja Desai",
    caseId: "412311",
    emailId: "pooja.desai@gmail.com",
    slaDueDate: "07 Jun 2026",
    completionDate: "08 Jun 2026",
    downloadReport: true,
    colour: "Red",
    totalChecks: 5,
    completed: 1,
    stopChecks: 3,
    insuffExpire: 1,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "6h 00m",
    viewLog: true,
  },
  {
    sno: 16,
    applicantName: "Nikhil Saxena",
    caseId: "412312",
    emailId: "nikhil.saxena@gmail.com",
    slaDueDate: "09 Jun 2026",
    completionDate: "10 Jun 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 4,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "Not Started",
    processingTime: "0h 30m",
    viewLog: true,
  },
  {
    sno: 17,
    applicantName: "Kavitha Reddy",
    caseId: "412313",
    emailId: "kavitha.reddy@gmail.com",
    slaDueDate: "10 Jun 2026",
    completionDate: "11 Jun 2026",
    downloadReport: false,
    colour: "Green",
    totalChecks: 5,
    completed: 5,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "3h 45m",
    viewLog: true,
  },
  {
    sno: 18,
    applicantName: "Manish Tiwari",
    caseId: "412314",
    emailId: "manish.tiwari@gmail.com",
    slaDueDate: "11 Jun 2026",
    completionDate: "12 Jun 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 3,
    completed: 2,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "1h 35m",
    viewLog: true,
  },
  {
    sno: 19,
    applicantName: "Swati Kulkarni",
    caseId: "412315",
    emailId: "swati.kulkarni@gmail.com",
    slaDueDate: "12 Jun 2026",
    completionDate: "13 Jun 2026",
    downloadReport: true,
    colour: "Red",
    totalChecks: 6,
    completed: 4,
    stopChecks: 2,
    insuffExpire: 0,
    hiringStatus: "On Hold",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "5h 30m",
    viewLog: false,
  },
  {
    sno: 20,
    applicantName: "Rajesh Kumar",
    caseId: "412316",
    emailId: "rajesh.kumar@gmail.com",
    slaDueDate: "13 Jun 2026",
    completionDate: "14 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 4,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "2h 00m",
    viewLog: true,
  },
  {
    sno: 21,
    applicantName: "Tanvi Bhatt",
    caseId: "412317",
    emailId: "tanvi.bhatt@gmail.com",
    slaDueDate: "14 Jun 2026",
    completionDate: "15 Jun 2026",
    downloadReport: false,
    colour: "Orange",
    totalChecks: 5,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 2,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "2h 20m",
    viewLog: true,
  },
  {
    sno: 22,
    applicantName: "Siddharth Nayak",
    caseId: "412318",
    emailId: "siddharth.nayak@gmail.com",
    slaDueDate: "15 Jun 2026",
    completionDate: "16 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 3,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "1h 00m",
    viewLog: true,
  },
  {
    sno: 23,
    applicantName: "Isha Malhotra",
    caseId: "412319",
    emailId: "isha.malhotra@gmail.com",
    slaDueDate: "16 Jun 2026",
    completionDate: "17 Jun 2026",
    downloadReport: true,
    colour: "Red",
    totalChecks: 4,
    completed: 2,
    stopChecks: 1,
    insuffExpire: 1,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "4h 45m",
    viewLog: true,
  },
  {
    sno: 24,
    applicantName: "Gaurav Mishra",
    caseId: "412320",
    emailId: "gaurav.mishra@gmail.com",
    slaDueDate: "17 Jun 2026",
    completionDate: "18 Jun 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 5,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "3h 15m",
    viewLog: false,
  },
  {
    sno: 25,
    applicantName: "Ritu Agarwal",
    caseId: "412321",
    emailId: "ritu.agarwal@gmail.com",
    slaDueDate: "18 Jun 2026",
    completionDate: "19 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 6,
    completed: 6,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "5h 00m",
    viewLog: true,
  },
  {
    sno: 26,
    applicantName: "Amit Pandey",
    caseId: "412322",
    emailId: "amit.pandey@gmail.com",
    slaDueDate: "19 Jun 2026",
    completionDate: "20 Jun 2026",
    downloadReport: false,
    colour: "Orange",
    totalChecks: 3,
    completed: 1,
    stopChecks: 0,
    insuffExpire: 2,
    hiringStatus: "On Hold",
    reportAction: "Select Action",
    status: "Not Started",
    processingTime: "0h 20m",
    viewLog: true,
  },
  {
    sno: 27,
    applicantName: "Nandita Choudhary",
    caseId: "412323",
    emailId: "nandita.choudhary@gmail.com",
    slaDueDate: "20 Jun 2026",
    completionDate: "21 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 4,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "2h 40m",
    viewLog: true,
  },
  {
    sno: 28,
    applicantName: "Vishal Srivastava",
    caseId: "412324",
    emailId: "vishal.srivastava@gmail.com",
    slaDueDate: "21 Jun 2026",
    completionDate: "22 Jun 2026",
    downloadReport: true,
    colour: "Red",
    totalChecks: 5,
    completed: 3,
    stopChecks: 2,
    insuffExpire: 0,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "6h 20m",
    viewLog: true,
  },
  {
    sno: 29,
    applicantName: "Shreya Ghosh",
    caseId: "412325",
    emailId: "shreya.ghosh@gmail.com",
    slaDueDate: "22 Jun 2026",
    completionDate: "23 Jun 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 4,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "1h 50m",
    viewLog: false,
  },
  {
    sno: 30,
    applicantName: "Harish Chandra",
    caseId: "412326",
    emailId: "harish.chandra@gmail.com",
    slaDueDate: "23 Jun 2026",
    completionDate: "24 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 5,
    completed: 5,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "3h 35m",
    viewLog: true,
  },
  {
    sno: 31,
    applicantName: "Pallavi Jain",
    caseId: "412327",
    emailId: "pallavi.jain@gmail.com",
    slaDueDate: "24 Jun 2026",
    completionDate: "25 Jun 2026",
    downloadReport: false,
    colour: "Orange",
    totalChecks: 3,
    completed: 2,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "1h 05m",
    viewLog: true,
  },
  {
    sno: 32,
    applicantName: "Deepak Patel",
    caseId: "412328",
    emailId: "deepak.patel@gmail.com",
    slaDueDate: "25 Jun 2026",
    completionDate: "26 Jun 2026",
    downloadReport: true,
    colour: "Red",
    totalChecks: 6,
    completed: 2,
    stopChecks: 3,
    insuffExpire: 1,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "7h 00m",
    viewLog: true,
  },
  {
    sno: 33,
    applicantName: "Lakshmi Subramaniam",
    caseId: "412329",
    emailId: "lakshmi.subramaniam@gmail.com",
    slaDueDate: "26 Jun 2026",
    completionDate: "27 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 4,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "2h 10m",
    viewLog: true,
  },
  {
    sno: 34,
    applicantName: "Rohan Dubey",
    caseId: "412330",
    emailId: "rohan.dubey@gmail.com",
    slaDueDate: "27 Jun 2026",
    completionDate: "28 Jun 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 5,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "On Hold",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "4h 10m",
    viewLog: false,
  },
  {
    sno: 35,
    applicantName: "Sunita Ramesh",
    caseId: "412331",
    emailId: "sunita.ramesh@gmail.com",
    slaDueDate: "28 Jun 2026",
    completionDate: "29 Jun 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 3,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "1h 30m",
    viewLog: true,
  },
  {
    sno: 36,
    applicantName: "Abhinav Chauhan",
    caseId: "412332",
    emailId: "abhinav.chauhan@gmail.com",
    slaDueDate: "29 Jun 2026",
    completionDate: "30 Jun 2026",
    downloadReport: false,
    colour: "Red",
    totalChecks: 4,
    completed: 1,
    stopChecks: 2,
    insuffExpire: 1,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "5h 50m",
    viewLog: true,
  },
  {
    sno: 37,
    applicantName: "Rekha Varghese",
    caseId: "412333",
    emailId: "rekha.varghese@gmail.com",
    slaDueDate: "30 Jun 2026",
    completionDate: "01 Jul 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 5,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 2,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "2h 35m",
    viewLog: true,
  },
  {
    sno: 38,
    applicantName: "Pranav Shukla",
    caseId: "412334",
    emailId: "pranav.shukla@gmail.com",
    slaDueDate: "01 Jul 2026",
    completionDate: "02 Jul 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 6,
    completed: 6,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "4h 50m",
    viewLog: true,
  },
  {
    sno: 39,
    applicantName: "Sonali Hegde",
    caseId: "412335",
    emailId: "sonali.hegde@gmail.com",
    slaDueDate: "02 Jul 2026",
    completionDate: "03 Jul 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 3,
    completed: 2,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "Pending",
    reportAction: "Select Action",
    status: "Not Started",
    processingTime: "0h 40m",
    viewLog: false,
  },
  {
    sno: 40,
    applicantName: "Vivek Anand",
    caseId: "412336",
    emailId: "vivek.anand@gmail.com",
    slaDueDate: "03 Jul 2026",
    completionDate: "04 Jul 2026",
    downloadReport: false,
    colour: "Red",
    totalChecks: 5,
    completed: 2,
    stopChecks: 2,
    insuffExpire: 1,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "6h 40m",
    viewLog: true,
  },
  {
    sno: 41,
    applicantName: "Madhuri Naik",
    caseId: "412337",
    emailId: "madhuri.naik@gmail.com",
    slaDueDate: "04 Jul 2026",
    completionDate: "05 Jul 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 4,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "2h 55m",
    viewLog: true,
  },
  {
    sno: 42,
    applicantName: "Alok Banerjee",
    caseId: "412338",
    emailId: "alok.banerjee@gmail.com",
    slaDueDate: "05 Jul 2026",
    completionDate: "06 Jul 2026",
    downloadReport: true,
    colour: "Orange",
    totalChecks: 5,
    completed: 4,
    stopChecks: 0,
    insuffExpire: 1,
    hiringStatus: "On Hold",
    reportAction: "Select Action",
    status: "In Progress",
    processingTime: "3h 50m",
    viewLog: true,
  },
  {
    sno: 43,
    applicantName: "Geeta Krishnan",
    caseId: "412339",
    emailId: "geeta.krishnan@gmail.com",
    slaDueDate: "06 Jul 2026",
    completionDate: "07 Jul 2026",
    downloadReport: true,
    colour: "Green",
    totalChecks: 3,
    completed: 3,
    stopChecks: 0,
    insuffExpire: 0,
    hiringStatus: "Hired",
    reportAction: "Select Action",
    status: "Completed",
    processingTime: "1h 15m",
    viewLog: true,
  },
  {
    sno: 44,
    applicantName: "Sachin Wagh",
    caseId: "412340",
    emailId: "sachin.wagh@gmail.com",
    slaDueDate: "07 Jul 2026",
    completionDate: "08 Jul 2026",
    downloadReport: false,
    colour: "Red",
    totalChecks: 6,
    completed: 3,
    stopChecks: 2,
    insuffExpire: 1,
    hiringStatus: "Rejected",
    reportAction: "Select Action",
    status: "Stopped",
    processingTime: "7h 30m",
    viewLog: true,
  },
];

// ------------------------------------
export const dummyData_recheckReport = [
  {
    sno: 1,
    caseId: "10056",
    applicantName: "John Doe",
    emailId: "johndoe@gmail.com",
    dateFrom: "01-05-2026",
    dateTo: "15-05-2026",
    client: "Infosys",
    program: "Employee Verification",
    geo: "India",
    sbu: "HR Ops",
    userList: "Govinda Bika",
    ageing: "3 Days",
    reportType: "Address Check",
    recheckDate: "18-05-2026",
    status: "Recheck",
  },
  {
    sno: 2,
    caseId: "10057",
    applicantName: "Priya Sharma",
    emailId: "priya.sharma@yahoo.com",
    dateFrom: "02-05-2026",
    dateTo: "16-05-2026",
    client: "TCS",
    program: "Background Check",
    geo: "India",
    sbu: "Finance",
    userList: "Rahul Verma",
    ageing: "5 Days",
    reportType: "Education Check",
    recheckDate: "19-05-2026",
    status: "Recheck",
  },
  {
    sno: 3,
    caseId: "10058",
    applicantName: "Michael Brown",
    emailId: "michael.brown@outlook.com",
    dateFrom: "03-05-2026",
    dateTo: "17-05-2026",
    client: "Accenture",
    program: "Employment Screening",
    geo: "USA",
    sbu: "IT Services",
    userList: "Sneha Patel",
    ageing: "2 Days",
    reportType: "Criminal Check",
    recheckDate: "20-05-2026",
    status: "Recheck",
  },
  {
    sno: 4,
    caseId: "10059",
    applicantName: "Anjali Mehta",
    emailId: "anjali.mehta@gmail.com",
    dateFrom: "04-05-2026",
    dateTo: "18-05-2026",
    client: "Wipro",
    program: "Vendor Verification",
    geo: "UAE",
    sbu: "Compliance",
    userList: "Amit Kumar",
    ageing: "7 Days",
    reportType: "ID Verification",
    recheckDate: "21-05-2026",
    status: "Recheck",
  },
  {
    sno: 5,
    caseId: "10060",
    applicantName: "Ravi Nair",
    emailId: "ravi.nair@gmail.com",
    dateFrom: "05-05-2026",
    dateTo: "19-05-2026",
    client: "HCL Technologies",
    program: "Employee Verification",
    geo: "India",
    sbu: "HR Ops",
    userList: "Pooja Iyer",
    ageing: "4 Days",
    reportType: "Address Check",
    recheckDate: "22-05-2026",
    status: "Recheck",
  },
  {
    sno: 6,
    caseId: "10061",
    applicantName: "Sarah Johnson",
    emailId: "sarah.johnson@outlook.com",
    dateFrom: "06-05-2026",
    dateTo: "20-05-2026",
    client: "IBM",
    program: "Background Check",
    geo: "UK",
    sbu: "Legal",
    userList: "Nikhil Desai",
    ageing: "6 Days",
    reportType: "Criminal Check",
    recheckDate: "23-05-2026",
    status: "Recheck",
  },
  {
    sno: 7,
    caseId: "10062",
    applicantName: "Karan Malhotra",
    emailId: "karan.malhotra@gmail.com",
    dateFrom: "07-05-2026",
    dateTo: "21-05-2026",
    client: "Tech Mahindra Limited",
    program: "Employment Screening",
    geo: "India",
    sbu: "Finance",
    userList: "Divya Menon",
    ageing: "1 Day",
    reportType: "Education Check",
    recheckDate: "24-05-2026",
    status: "Recheck",
  },
  {
    sno: 8,
    caseId: "10063",
    applicantName: "Fatima Al-Hassan",
    emailId: "fatima.hassan@yahoo.com",
    dateFrom: "08-05-2026",
    dateTo: "22-05-2026",
    client: "Deloitte",
    program: "Vendor Verification",
    geo: "UAE",
    sbu: "Compliance",
    userList: "Suresh Pillai",
    ageing: "9 Days",
    reportType: "ID Verification",
    recheckDate: "25-05-2026",
    status: "Recheck",
  },
  {
    sno: 9,
    caseId: "10064",
    applicantName: "Neha Joshi",
    emailId: "neha.joshi@gmail.com",
    dateFrom: "09-05-2026",
    dateTo: "23-05-2026",
    client: "Capgemini",
    program: "Employee Verification",
    geo: "India",
    sbu: "IT Services",
    userList: "Arjun Reddy",
    ageing: "3 Days",
    reportType: "Reference Check",
    recheckDate: "26-05-2026",
    status: "Recheck",
  },
  {
    sno: 10,
    caseId: "10065",
    applicantName: "David Lee",
    emailId: "david.lee@outlook.com",
    dateFrom: "10-05-2026",
    dateTo: "24-05-2026",
    client: "EY",
    program: "Background Check",
    geo: "Singapore",
    sbu: "Risk & Advisory",
    userList: "Kavitha Rao",
    ageing: "8 Days",
    reportType: "Criminal Check",
    recheckDate: "27-05-2026",
    status: "Recheck",
  },
  {
    sno: 11,
    caseId: "10066",
    applicantName: "Meera Krishnaswamy",
    emailId: "meera.krishna@gmail.com",
    dateFrom: "11-05-2026",
    dateTo: "25-05-2026",
    client: "KPMG",
    program: "Employment Screening",
    geo: "India",
    sbu: "HR Ops",
    userList: "Vishal Saxena",
    ageing: "2 Days",
    reportType: "Address Check",
    recheckDate: "28-05-2026",
    status: "Recheck",
  },
  {
    sno: 12,
    caseId: "10067",
    applicantName: "Omar Shaikh",
    emailId: "omar.shaikh@yahoo.com",
    dateFrom: "12-05-2026",
    dateTo: "26-05-2026",
    client: "PwC",
    program: "Vendor Verification",
    geo: "UAE",
    sbu: "Finance",
    userList: "Tanvi Bhatt",
    ageing: "10 Days",
    reportType: "Education Check",
    recheckDate: "29-05-2026",
    status: "Recheck",
  },
  {
    sno: 13,
    caseId: "10068",
    applicantName: "Anita Kulkarni",
    emailId: "anita.kulkarni@gmail.com",
    dateFrom: "13-05-2026",
    dateTo: "27-05-2026",
    client: "Cognizant",
    program: "Employee Verification",
    geo: "India",
    sbu: "Compliance",
    userList: "Manish Tiwari",
    ageing: "5 Days",
    reportType: "ID Verification",
    recheckDate: "30-05-2026",
    status: "Recheck",
  },
  {
    sno: 14,
    caseId: "10069",
    applicantName: "James Carter",
    emailId: "james.carter@outlook.com",
    dateFrom: "14-05-2026",
    dateTo: "28-05-2026",
    client: "Oracle",
    program: "Background Check",
    geo: "USA",
    sbu: "IT Services",
    userList: "Shreya Ghosh",
    ageing: "4 Days",
    reportType: "Reference Check",
    recheckDate: "31-05-2026",
    status: "Recheck",
  },
  {
    sno: 15,
    caseId: "10070",
    applicantName: "Sunita Rajan",
    emailId: "sunita.rajan@gmail.com",
    dateFrom: "15-05-2026",
    dateTo: "29-05-2026",
    client: "SAP",
    program: "Employment Screening",
    geo: "India",
    sbu: "HR Ops",
    userList: "Deepak Verma",
    ageing: "6 Days",
    reportType: "Criminal Check",
    recheckDate: "01-06-2026",
    status: "Recheck",
  },
  {
    sno: 16,
    caseId: "10071",
    applicantName: "Li Wei",
    emailId: "li.wei@yahoo.com",
    dateFrom: "16-05-2026",
    dateTo: "30-05-2026",
    client: "Microsoft",
    program: "Vendor Verification",
    geo: "Singapore",
    sbu: "Legal",
    userList: "Pradeep Nair",
    ageing: "7 Days",
    reportType: "Address Check",
    recheckDate: "02-06-2026",
    status: "Recheck",
  },
];

// ------------------------------------
export const dummyData_stoppedCases = [
  {
    sno: 1,
    applicantName: "Krishna Chauhan",
    caseId: 374540,
    emailId: "krishna.chauhan@gmail.com",
    totalChecks: 5,
    stoppedChecks: 5,
    status: "Stopped",
    action: "Resume",
    processingTime: "2h 15m",
    viewLog: true,
  },
  {
    sno: 2,
    applicantName: "Anchal Vig",
    caseId: 374479,
    emailId: "anchal.vig@gmail.com",
    totalChecks: 5,
    stoppedChecks: 5,
    status: "Stopped",
    action: "Resume",
    processingTime: "1h 48m",
    viewLog: true,
  },
  {
    sno: 3,
    applicantName: "Rohit Sharma",
    caseId: 374481,
    emailId: "rohit.sharma@gmail.com",
    totalChecks: 4,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "3h 10m",
    viewLog: true,
  },
  {
    sno: 4,
    applicantName: "Priya Mehta",
    caseId: 374482,
    emailId: "priya.mehta@gmail.com",
    totalChecks: 6,
    stoppedChecks: 6,
    status: "Stopped",
    action: "Resume",
    processingTime: "4h 02m",
    viewLog: true,
  },
  {
    sno: 5,
    applicantName: "Arjun Nair",
    caseId: 374483,
    emailId: "arjun.nair@gmail.com",
    totalChecks: 3,
    stoppedChecks: 2,
    status: "Stopped",
    action: "Resume",
    processingTime: "0h 55m",
    viewLog: true,
  },
  {
    sno: 6,
    applicantName: "Sneha Kulkarni",
    caseId: 374484,
    emailId: "sneha.kulkarni@gmail.com",
    totalChecks: 5,
    stoppedChecks: 4,
    status: "Stopped",
    action: "Resume",
    processingTime: "2h 40m",
    viewLog: true,
  },
  {
    sno: 7,
    applicantName: "Vikram Desai",
    caseId: 374485,
    emailId: "vikram.desai@gmail.com",
    totalChecks: 6,
    stoppedChecks: 5,
    status: "Stopped",
    action: "Resume",
    processingTime: "5h 20m",
    viewLog: true,
  },
  {
    sno: 8,
    applicantName: "Pooja Iyer",
    caseId: 374486,
    emailId: "pooja.iyer@gmail.com",
    totalChecks: 4,
    stoppedChecks: 4,
    status: "Stopped",
    action: "Resume",
    processingTime: "1h 30m",
    viewLog: true,
  },
  {
    sno: 9,
    applicantName: "Nikhil Gupta",
    caseId: 374487,
    emailId: "nikhil.gupta@gmail.com",
    totalChecks: 3,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "0h 42m",
    viewLog: true,
  },
  {
    sno: 10,
    applicantName: "Divya Reddy",
    caseId: 374488,
    emailId: "divya.reddy@gmail.com",
    totalChecks: 5,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "3h 55m",
    viewLog: true,
  },
  {
    sno: 11,
    applicantName: "Manish Tiwari",
    caseId: 374489,
    emailId: "manish.tiwari@gmail.com",
    totalChecks: 6,
    stoppedChecks: 6,
    status: "Stopped",
    action: "Resume",
    processingTime: "6h 10m",
    viewLog: true,
  },
  {
    sno: 12,
    applicantName: "Kavitha Menon",
    caseId: 374490,
    emailId: "kavitha.menon@gmail.com",
    totalChecks: 4,
    stoppedChecks: 2,
    status: "Stopped",
    action: "Resume",
    processingTime: "1h 18m",
    viewLog: true,
  },
  {
    sno: 13,
    applicantName: "Rajan Pillai",
    caseId: 374491,
    emailId: "rajan.pillai@gmail.com",
    totalChecks: 5,
    stoppedChecks: 5,
    status: "Stopped",
    action: "Resume",
    processingTime: "4h 35m",
    viewLog: true,
  },
  {
    sno: 14,
    applicantName: "Swati Bhatt",
    caseId: 374492,
    emailId: "swati.bhatt@gmail.com",
    totalChecks: 3,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "1h 05m",
    viewLog: true,
  },
  {
    sno: 15,
    applicantName: "Gaurav Saxena",
    caseId: 374493,
    emailId: "gaurav.saxena@gmail.com",
    totalChecks: 6,
    stoppedChecks: 4,
    status: "Stopped",
    action: "Resume",
    processingTime: "5h 50m",
    viewLog: true,
  },
  {
    sno: 16,
    applicantName: "Lakshmi Varma",
    caseId: 374494,
    emailId: "lakshmi.varma@gmail.com",
    totalChecks: 4,
    stoppedChecks: 4,
    status: "Stopped",
    action: "Resume",
    processingTime: "2h 22m",
    viewLog: true,
  },
  {
    sno: 17,
    applicantName: "Deepak Rao",
    caseId: 374495,
    emailId: "deepak.rao@gmail.com",
    totalChecks: 5,
    stoppedChecks: 4,
    status: "Stopped",
    action: "Resume",
    processingTime: "3h 45m",
    viewLog: true,
  },
  {
    sno: 18,
    applicantName: "Tanvi Joshi",
    caseId: 374496,
    emailId: "tanvi.joshi@gmail.com",
    totalChecks: 3,
    stoppedChecks: 2,
    status: "Stopped",
    action: "Resume",
    processingTime: "0h 38m",
    viewLog: true,
  },
  {
    sno: 19,
    applicantName: "Suresh Chandra",
    caseId: 374497,
    emailId: "suresh.chandra@gmail.com",
    totalChecks: 6,
    stoppedChecks: 6,
    status: "Stopped",
    action: "Resume",
    processingTime: "7h 00m",
    viewLog: true,
  },
  {
    sno: 20,
    applicantName: "Ananya Bose",
    caseId: 374498,
    emailId: "ananya.bose@gmail.com",
    totalChecks: 4,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "1h 58m",
    viewLog: true,
  },
  {
    sno: 21,
    applicantName: "Harish Verma",
    caseId: 374499,
    emailId: "harish.verma@gmail.com",
    totalChecks: 5,
    stoppedChecks: 5,
    status: "Stopped",
    action: "Resume",
    processingTime: "4h 12m",
    viewLog: true,
  },
  {
    sno: 22,
    applicantName: "Rekha Pandey",
    caseId: 374500,
    emailId: "rekha.pandey@gmail.com",
    totalChecks: 3,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "0h 50m",
    viewLog: true,
  },
  {
    sno: 23,
    applicantName: "Aditya Mishra",
    caseId: 374501,
    emailId: "aditya.mishra@gmail.com",
    totalChecks: 6,
    stoppedChecks: 5,
    status: "Stopped",
    action: "Resume",
    processingTime: "6h 28m",
    viewLog: true,
  },
  {
    sno: 24,
    applicantName: "Pallavi Singh",
    caseId: 374502,
    emailId: "pallavi.singh@gmail.com",
    totalChecks: 4,
    stoppedChecks: 4,
    status: "Stopped",
    action: "Resume",
    processingTime: "2h 05m",
    viewLog: true,
  },
  {
    sno: 25,
    applicantName: "Vishal Choudhary",
    caseId: 374503,
    emailId: "vishal.choudhary@gmail.com",
    totalChecks: 5,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "3h 30m",
    viewLog: true,
  },
  {
    sno: 26,
    applicantName: "Nandita Hegde",
    caseId: 374504,
    emailId: "nandita.hegde@gmail.com",
    totalChecks: 3,
    stoppedChecks: 2,
    status: "Stopped",
    action: "Resume",
    processingTime: "1h 12m",
    viewLog: true,
  },
  {
    sno: 27,
    applicantName: "Pranav Wagh",
    caseId: 374505,
    emailId: "pranav.wagh@gmail.com",
    totalChecks: 6,
    stoppedChecks: 6,
    status: "Stopped",
    action: "Resume",
    processingTime: "5h 40m",
    viewLog: true,
  },
  {
    sno: 28,
    applicantName: "Geeta Krishnan",
    caseId: 374506,
    emailId: "geeta.krishnan@gmail.com",
    totalChecks: 4,
    stoppedChecks: 4,
    status: "Stopped",
    action: "Resume",
    processingTime: "2h 52m",
    viewLog: true,
  },
  {
    sno: 29,
    applicantName: "Sachin Banerjee",
    caseId: 374507,
    emailId: "sachin.banerjee@gmail.com",
    totalChecks: 5,
    stoppedChecks: 4,
    status: "Stopped",
    action: "Resume",
    processingTime: "4h 48m",
    viewLog: true,
  },
  {
    sno: 30,
    applicantName: "Madhuri Naik",
    caseId: 374508,
    emailId: "madhuri.naik@gmail.com",
    totalChecks: 3,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "0h 28m",
    viewLog: true,
  },
  {
    sno: 31,
    applicantName: "Alok Srivastava",
    caseId: 374509,
    emailId: "alok.srivastava@gmail.com",
    totalChecks: 6,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "7h 15m",
    viewLog: true,
  },
  {
    sno: 32,
    applicantName: "Sonali Patil",
    caseId: 374510,
    emailId: "sonali.patil@gmail.com",
    totalChecks: 4,
    stoppedChecks: 3,
    status: "Stopped",
    action: "Resume",
    processingTime: "1h 44m",
    viewLog: true,
  },
];

// ------------------------------------

// ========== Timeline Data ============
// export const timelineData_invite = [
//   {
//     id: 1,
//     title: "Invite Sent Date",
//     date: "08-04-2026",
//     time: "12:07 AM",
//     children: [
//       {
//         id: 11,
//         title: "Pending Login",
//         date: "08-04-2026",
//         time: "12:07 AM",
//       },
//       {
//         id: 12,
//         title: "Invite expiry reminder",
//         date: "10-04-2026",
//         time: "06:00 AM",
//       },
//       {
//         id: 13,
//         title: "Invite expiry reminder",
//         date: "12-04-2026",
//         time: "06:00 AM",
//       },
//       {
//         id: 14,
//         title: "Invite expiry reminder",
//         date: "14-04-2026",
//         time: "06:00 AM",
//       },
//       {
//         id: 15,
//         title: "Invite expiry reminder",
//         date: "15-04-2026",
//         time: "06:00 AM",
//       },
//       {
//         id: 16,
//         title: "Case Modified",
//         date: "17-04-2026",
//         time: "03:08 PM",
//       },
//       {
//         id: 17,
//         title: "Pending Login",
//         date: "18-04-2026",
//         time: "11:00 AM",
//       },
//     ],
//   },

//   // Second Main Timeline
//   {
//     id: 2,
//     title: "Application Submitted",
//     date: "20-04-2026",
//     time: "09:30 AM",
//     children: [
//       {
//         id: 21,
//         title: "Documents Uploaded",
//         date: "20-04-2026",
//         time: "10:15 AM",
//       },
//       {
//         id: 22,
//         title: "Verification Started",
//         date: "21-04-2026",
//         time: "02:45 PM",
//       },
//     ],
//   },
// ];

export const timelineData_invite = [
  {
    event_id: "evt-001",
    actor_name: "John Doe",
    actor_type: "USER",
    event_type: "CASE_CREATED",
    entity_id: "case-1001",
    entity_name: "Customer Complaint - Order #ORD-10234",
    case_id: "case-1001",
    occurred_at: "2026-08-06T09:15:00Z",
  },
  {
    event_id: "evt-002",
    actor_name: "John Doe",
    actor_type: "USER",
    event_type: "CASE_STATUS_CHANGED",
    entity_id: "case-1001",
    entity_name: "Customer Complaint - Order #ORD-10234",
    case_id: "case-1001",
    diff: {
      from_status: "OPEN",
      to_status: "IN_PROGRESS",
      action_reason: "Case assigned to the support team for investigation.",
    },
    occurred_at: "2026-08-06T09:30:00Z",
  },
  {
    event_id: "evt-003",
    actor_name: "Sarah Wilson",
    actor_type: "AGENT",
    event_type: "CASE_ASSIGNED",
    entity_id: "case-1001",
    entity_name: "Customer Complaint - Order #ORD-10234",
    case_id: "case-1001",
    occurred_at: "2026-08-06T09:42:00Z",
  },
  {
    event_id: "evt-004",
    actor_name: "Sarah Wilson",
    actor_type: "AGENT",
    event_type: "CUSTOMER_CONTACTED",
    entity_id: "customer-501",
    entity_name: "Michael Anderson",
    case_id: "case-1001",
    occurred_at: "2026-08-06T10:05:00Z",
  },
  {
    event_id: "evt-005",
    actor_name: "Sarah Wilson",
    actor_type: "AGENT",
    event_type: "CASE_STATUS_CHANGED",
    entity_id: "case-1001",
    entity_name: "Customer Complaint - Order #ORD-10234",
    case_id: "case-1001",
    diff: {
      from_status: "IN_PROGRESS",
      to_status: "PENDING",
      action_reason: "Waiting for the customer to provide additional order details.",
    },
    occurred_at: "2026-08-06T10:30:00Z",
  },
  {
    event_id: "evt-006",
    actor_name: "Michael Anderson",
    actor_type: "CUSTOMER",
    event_type: "DOCUMENT_UPLOADED",
    entity_id: "document-778",
    entity_name: "Order Receipt.pdf",
    case_id: "case-1001",
    occurred_at: "2026-08-06T11:10:00Z",
  },
  {
    event_id: "evt-007",
    actor_name: "Sarah Wilson",
    actor_type: "AGENT",
    event_type: "CASE_STATUS_CHANGED",
    entity_id: "case-1001",
    entity_name: "Customer Complaint - Order #ORD-10234",
    case_id: "case-1001",
    diff: {
      from_status: "PENDING",
      to_status: "IN_PROGRESS",
      action_reason: "Required documents were received from the customer.",
    },
    occurred_at: "2026-08-06T11:25:00Z",
  },
  {
    event_id: "evt-008",
    actor_name: "System",
    actor_type: "SYSTEM",
    event_type: "CASE_UPDATED",
    entity_id: "case-1001",
    entity_name: "Customer Complaint - Order #ORD-10234",
    case_id: "case-1001",
    diff: {
      priority: {
        from: "MEDIUM",
        to: "HIGH",
      },
    },
    occurred_at: "2026-08-06T12:00:00Z",
  },
  {
    event_id: "evt-009",
    actor_name: "Sarah Wilson",
    actor_type: "AGENT",
    event_type: "CASE_STATUS_CHANGED",
    entity_id: "case-1001",
    entity_name: "Customer Complaint - Order #ORD-10234",
    case_id: "case-1001",
    diff: {
      from_status: "IN_PROGRESS",
      to_status: "RESOLVED",
      action_reason: "Refund has been processed successfully.",
    },
    occurred_at: "2026-08-06T13:15:00Z",
  },
  {
    event_id: "evt-010",
    actor_name: "System",
    actor_type: "SYSTEM",
    event_type: "CASE_CLOSED",
    entity_id: "case-1001",
    entity_name: "Customer Complaint - Order #ORD-10234",
    case_id: "case-1001",
    occurred_at: "2026-08-06T13:30:00Z",
  },
];

export const timelineData_insuffCase = [
  {
    id: 1,
    title: "Applicant Invited",
    date: "16-03-2026",
    time: "11:15 PM",
    children: [
      {
        id: 11,
        title: "Pending Login",
        date: "16-03-2026",
        time: "11:15 PM",
      },
      {
        id: 12,
        title: "Logged In",
        date: "17-03-2026",
        time: "07:25 AM",
      },
      {
        id: 13,
        title: "Check Filled -- Form Submitted",
        date: "17-03-2026",
        time: "07:41 AM",
      },
      {
        id: 14,
        title: "Work in progress (Initiation-TLQC)",
        date: "17-03-2026",
        time: "07:53 AM",
      },
      {
        id: 15,
        title: "Work in progress (Initiation-QC)",
        date: "17-03-2026",
        time: "12:50 PM",
      },
      {
        id: 16,
        title: "Work in progress (Validation)",
        date: "17-03-2026",
        time: "01:44 PM",
      },
      {
        id: 17,
        title: "L1 Insufficiency Raised",
        date: "18-03-2026",
        time: "02:48 PM",
      },
      {
        id: 18,
        title: "Insuff expiry reminder sent",
        date: "19-03-2026",
        time: "06:06:46 AM",
      },
    ],
  },
];

export const timelineData_caseDetail = [
  {
    id: 1,
    title: "Invite Sent Date",
    date: "28-04-2026",
    time: "05:37 PM",
    children: [
      {
        id: 11,
        title: "Pending Login",
        date: "28-04-2026",
        time: "05:37 PM",
      },
      {
        id: 12,
        title: "Logged In",
        date: "28-04-2026",
        time: "11:42 PM",
      },
      {
        id: 13,
        title: "Work in progress",
        date: "29-04-2026",
        time: "12:21 PM",
      },
    ],
  },
];
// ========== /Timeline Data ============

// ========== Master Vishnu =============
export const dummyData_masterProgram = [
  {
    key: "1",
    sno: 1,
    clientName: "Tech Mahindra Limited",
    programName: "Thane",
    status: true,
  },
  {
    key: "2",
    sno: 2,
    clientName: "Tech Mahindra Limited",
    programName: "Kolkata - Smartwork",
    status: false,
  },
  {
    key: "3",
    sno: 3,
    clientName: "Tech Mahindra Limited",
    programName: "Kolkata - GWS",
    status: true,
  },
  {
    key: "4",
    sno: 4,
    clientName: "Tech Mahindra Limited",
    programName: "Indore - Sapphire",
    status: true,
  },
  {
    key: "5",
    sno: 5,
    clientName: "Tech Mahindra Limited",
    programName: "Jaipur - LIC",
    status: true,
  },
  {
    key: "6",
    sno: 6,
    clientName: "Tech Mahindra Limited",
    programName: "World Remit",
    status: true,
  },
  {
    key: "7",
    sno: 7,
    clientName: "Tech Mahindra Limited",
    programName: "Yes Bank",
    status: false,
  },
  {
    key: "8",
    sno: 8,
    clientName: "Tech Mahindra Limited",
    programName: "TAFE",
    status: false,
  },
  {
    key: "9",
    sno: 9,
    clientName: "Tech Mahindra Limited",
    programName: "DHFL",
    status: false,
  },
  {
    key: "10",
    sno: 10,
    clientName: "Tech Mahindra Limited",
    programName: "Ultratech",
    status: false,
  },
  {
    key: "11",
    sno: 11,
    clientName: "Tech Mahindra Limited",
    programName: "Nurture Farm",
    status: false,
  },
  {
    key: "12",
    sno: 12,
    clientName: "Tech Mahindra Limited",
    programName: "ICICI",
    status: false,
  },
  {
    key: "13",
    sno: 13,
    clientName: "Tech Mahindra Limited",
    programName: "DBS Bank",
    status: false,
  },
  {
    key: "14",
    sno: 14,
    clientName: "Tech Mahindra Limited",
    programName: "Vroom",
    status: false,
  },
  {
    key: "15",
    sno: 15,
    clientName: "Tech Mahindra Limited",
    programName: "CH Robinson",
    status: false,
  },
  {
    key: "16",
    sno: 16,
    clientName: "Tech Mahindra Limited",
    programName: "DJO",
    status: false,
  },
  {
    key: "17",
    sno: 17,
    clientName: "Tech Mahindra Limited",
    programName: "HDFC Bank",
    status: true,
  },
  {
    key: "18",
    sno: 18,
    clientName: "Tech Mahindra Limited",
    programName: "Axis Bank",
    status: false,
  },
  {
    key: "19",
    sno: 19,
    clientName: "Tech Mahindra Limited",
    programName: "Kotak Mahindra Bank",
    status: true,
  },
  {
    key: "20",
    sno: 20,
    clientName: "Tech Mahindra Limited",
    programName: "Tata Motors",
    status: false,
  },
  {
    key: "21",
    sno: 21,
    clientName: "Tech Mahindra Limited",
    programName: "Infosys BPM",
    status: true,
  },
  {
    key: "22",
    sno: 22,
    clientName: "Tech Mahindra Limited",
    programName: "Wipro Technologies",
    status: false,
  },
  {
    key: "23",
    sno: 23,
    clientName: "Tech Mahindra Limited",
    programName: "Reliance Jio",
    status: true,
  },
  {
    key: "24",
    sno: 24,
    clientName: "Tech Mahindra Limited",
    programName: "TCS Digital",
    status: false,
  },
];
// ----------------------------

export const dummyData_masterDept = [
  {
    key: "1",
    sno: 1,
    clientName: "Tech Mahindra Limited",
    programName: "Mohali - A-40",
    sbuName: "RCC AMR",
    departLocation: "Mohali",
    status: true,
  },
  {
    key: "2",
    sno: 2,
    clientName: "Tech Mahindra Limited",
    programName: "Indore - Sapphire",
    sbuName: "Asus",
    departLocation: "Indore",
    status: true,
  },
  {
    key: "3",
    sno: 3,
    clientName: "Tech Mahindra Limited",
    programName: "Mohali - A-40",
    sbuName: "Caption Call",
    departLocation: "Mohali",
    status: true,
  },
  {
    key: "4",
    sno: 4,
    clientName: "Tech Mahindra Limited",
    programName: "Jaipur - MNS",
    sbuName: "Wizzair",
    departLocation: "Jaipur",
    status: false,
  },
  {
    key: "5",
    sno: 5,
    clientName: "Tech Mahindra Limited",
    programName: "Jaipur - MNS",
    sbuName: "Sony",
    departLocation: "Jaipur",
    status: true,
  },
  {
    key: "6",
    sno: 6,
    clientName: "Tech Mahindra Limited",
    programName: "Jaipur - MNS",
    sbuName: "HDB",
    departLocation: "Jaipur",
    status: true,
  },
  {
    key: "7",
    sno: 7,
    clientName: "Tech Mahindra Limited",
    programName: "Jaipur - MNS",
    sbuName: "HMD",
    departLocation: "Jaipur",
    status: false,
  },
  {
    key: "8",
    sno: 8,
    clientName: "Tech Mahindra Limited",
    programName: "Jaipur - MNS",
    sbuName: "LinkedIn",
    departLocation: "Jaipur",
    status: true,
  },
  {
    key: "9",
    sno: 9,
    clientName: "Tech Mahindra Limited",
    programName: "Jaipur - MNS",
    sbuName: "GEN",
    departLocation: "Jaipur",
    status: true,
  },
  {
    key: "10",
    sno: 10,
    clientName: "Tech Mahindra Limited",
    programName: "Pune - Hinjewadi",
    sbuName: "Dell",
    departLocation: "Pune",
    status: false,
  },
  {
    key: "11",
    sno: 11,
    clientName: "Tech Mahindra Limited",
    programName: "Noida - Sector 62",
    sbuName: "Microsoft",
    departLocation: "Noida",
    status: true,
  },
  {
    key: "12",
    sno: 12,
    clientName: "Tech Mahindra Limited",
    programName: "Hyderabad - Hitech City",
    sbuName: "Google",
    departLocation: "Hyderabad",
    status: false,
  },
  {
    key: "13",
    sno: 13,
    clientName: "Tech Mahindra Limited",
    programName: "Bangalore - Whitefield",
    sbuName: "Amazon",
    departLocation: "Bangalore",
    status: true,
  },
  {
    key: "14",
    sno: 14,
    clientName: "Tech Mahindra Limited",
    programName: "Chennai - OMR",
    sbuName: "Accenture",
    departLocation: "Chennai",
    status: false,
  },
  {
    key: "15",
    sno: 15,
    clientName: "Tech Mahindra Limited",
    programName: "Mumbai - Airoli",
    sbuName: "JP Morgan",
    departLocation: "Mumbai",
    status: true,
  },
  {
    key: "16",
    sno: 16,
    clientName: "Tech Mahindra Limited",
    programName: "Gurugram - Cyber City",
    sbuName: "American Express",
    departLocation: "Gurugram",
    status: true,
  },
  {
    key: "17",
    sno: 17,
    clientName: "Tech Mahindra Limited",
    programName: "Kolkata - Salt Lake",
    sbuName: "HSBC",
    departLocation: "Kolkata",
    status: false,
  },
  {
    key: "18",
    sno: 18,
    clientName: "Tech Mahindra Limited",
    programName: "Ahmedabad - SG Highway",
    sbuName: "Oracle",
    departLocation: "Ahmedabad",
    status: true,
  },
  {
    key: "19",
    sno: 19,
    clientName: "Tech Mahindra Limited",
    programName: "Jaipur - Malviya Nagar",
    sbuName: "Infosys",
    departLocation: "Jaipur",
    status: false,
  },
  {
    key: "20",
    sno: 20,
    clientName: "Tech Mahindra Limited",
    programName: "Nagpur - MIHAN",
    sbuName: "TCS",
    departLocation: "Nagpur",
    status: true,
  },
  {
    key: "21",
    sno: 21,
    clientName: "Tech Mahindra Limited",
    programName: "Lucknow - Gomti Nagar",
    sbuName: "Wipro",
    departLocation: "Lucknow",
    status: false,
  },
  {
    key: "22",
    sno: 22,
    clientName: "Tech Mahindra Limited",
    programName: "Coimbatore - Avinashi Road",
    sbuName: "Cognizant",
    departLocation: "Coimbatore",
    status: true,
  },
  {
    key: "23",
    sno: 23,
    clientName: "Tech Mahindra Limited",
    programName: "Bhubaneswar - Infocity",
    sbuName: "Capgemini",
    departLocation: "Bhubaneswar",
    status: false,
  },
  {
    key: "24",
    sno: 24,
    clientName: "Tech Mahindra Limited",
    programName: "Vadodara - Alkapuri",
    sbuName: "HCL",
    departLocation: "Vadodara",
    status: true,
  },
  {
    key: "25",
    sno: 25,
    clientName: "Tech Mahindra Limited",
    programName: "Mysore - Hebbal",
    sbuName: "IBM",
    departLocation: "Mysore",
    status: false,
  },
  {
    key: "26",
    sno: 26,
    clientName: "Tech Mahindra Limited",
    programName: "Visakhapatnam - MVP Colony",
    sbuName: "Reliance",
    departLocation: "Visakhapatnam",
    status: true,
  },
  {
    key: "27",
    sno: 27,
    clientName: "Tech Mahindra Limited",
    programName: "Chandigarh - IT Park",
    sbuName: "Adobe",
    departLocation: "Chandigarh",
    status: true,
  },
];

// -----------------------------------
export const dummyData_Packages = [
  {
    key: "1",
    sno: 1,
    programName: "Mohali - A-40",
    sbuName: "RCC AMR",
    departLocation: "Mohali",
    packageName: "UBER-JAI-FULLPA",
    customPackageName: "RCC AMR FULL PA",
    checks:
      "UBER-JAI-FULLPA - IPAN, AADHAAR NUMBER, Permanent Address, Last Employment, All Education",
    status: true,
  },
  {
    key: "2",
    sno: 2,
    programName: "Indore - Sapphire",
    sbuName: "Asus",
    departLocation: "Indore",
    packageName: "UBER-JAI-FULLPA",
    customPackageName: "Asus FULL PA",
    checks:
      "UBER-JAI-FULLPA - IPAN, AADHAAR NUMBER, Permanent Address, Last Employment, All Education",
    status: true,
  },
  {
    key: "3",
    sno: 3,
    programName: "Mohali - Bestech",
    sbuName: "AC AMR",
    departLocation: "Mohali",
    packageName: "UBER-JAI-FULLPA",
    customPackageName: "AC-AMR FULL PA",
    checks:
      "UBER-JAI-FULLPA - IPAN, AADHAAR NUMBER, Permanent Address, Last Employment, All Education",
    status: true,
  },
  {
    key: "4",
    sno: 4,
    programName: "Mohali - A-40",
    sbuName: "AC AMR",
    departLocation: "Mohali",
    packageName: "UBER-JAI-FULLPA",
    customPackageName: "AC-AMR FULL PA",
    checks:
      "UBER-JAI-FULLPA - IPAN, AADHAAR NUMBER, Permanent Address, Last Employment, All Education",
    status: true,
  },
  {
    key: "5",
    sno: 5,
    programName: "Mohali - A-40",
    sbuName: "AC AMR",
    departLocation: "Mohali",
    packageName: "UBER-JAI-FULLPA",
    customPackageName: "AC-AMR FULL PA",
    checks:
      "UBER-JAI-FULLPA - IPAN, AADHAAR NUMBER, Permanent Address, Last Employment, All Education",
    status: true,
  },
  {
    key: "6",
    sno: 6,
    programName: "Mohali - A-40",
    sbuName: "AC AMR",
    departLocation: "Mohali",
    packageName: "UBER-JAI-FULLPA",
    customPackageName: "AC-AMR FULL PA",
    checks:
      "UBER-JAI-FULLPA - IPAN, AADHAAR NUMBER, Permanent Address, Last Employment, All Education",
    status: true,
  },
  {
    key: "7",
    sno: 7,
    programName: "Pune - Hinjewadi",
    sbuName: "Dell",
    departLocation: "Pune",
    packageName: "DELL-STD-PA",
    customPackageName: "Dell Standard PA",
    checks:
      "DELL-STD-PA - PAN, Aadhaar Number, Current Address, Last Employment, Highest Education",
    status: false,
  },
  {
    key: "8",
    sno: 8,
    programName: "Noida - Sector 62",
    sbuName: "Microsoft",
    departLocation: "Noida",
    packageName: "MSFT-FULL-PA",
    customPackageName: "Microsoft Full PA",
    checks:
      "MSFT-FULL-PA - PAN, Aadhaar Number, Address Verification, Employment Check, Education Check",
    status: true,
  },
  {
    key: "9",
    sno: 9,
    programName: "Hyderabad - Hitech City",
    sbuName: "Google",
    departLocation: "Hyderabad",
    packageName: "GOOGLE-PLUS-PA",
    customPackageName: "Google Plus PA",
    checks:
      "GOOGLE-PLUS-PA - PAN, Aadhaar, Criminal Check, Address Verification, Employment History",
    status: true,
  },
  {
    key: "10",
    sno: 10,
    programName: "Bangalore - Whitefield",
    sbuName: "Amazon",
    departLocation: "Bangalore",
    packageName: "AMZN-FULL-PA",
    customPackageName: "Amazon Full PA",
    checks:
      "AMZN-FULL-PA - PAN, Aadhaar, Address, Employment, Education, Criminal Check",
    status: false,
  },
  {
    key: "11",
    sno: 11,
    programName: "Chennai - OMR",
    sbuName: "Accenture",
    departLocation: "Chennai",
    packageName: "ACC-STD-PA",
    customPackageName: "Accenture Standard PA",
    checks: "ACC-STD-PA - PAN, Aadhaar, Current Address, Last Employment",
    status: true,
  },
  {
    key: "12",
    sno: 12,
    programName: "Mumbai - Airoli",
    sbuName: "JP Morgan",
    departLocation: "Mumbai",
    packageName: "JPM-FULL-PA",
    customPackageName: "JP Morgan Full PA",
    checks:
      "JPM-FULL-PA - PAN, Aadhaar, Address, Employment, Education, Credit Check",
    status: true,
  },
  {
    key: "13",
    sno: 13,
    programName: "Gurugram - Cyber City",
    sbuName: "American Express",
    departLocation: "Gurugram",
    packageName: "AMEX-PREMIUM",
    customPackageName: "AMEX Premium Package",
    checks:
      "AMEX-PREMIUM - PAN, Aadhaar, Address, Employment, Education, Criminal Check",
    status: false,
  },
  {
    key: "14",
    sno: 14,
    programName: "Kolkata - Salt Lake",
    sbuName: "HSBC",
    departLocation: "Kolkata",
    packageName: "HSBC-BASIC",
    customPackageName: "HSBC Basic PA",
    checks: "HSBC-BASIC - PAN, Aadhaar, Employment Verification",
    status: true,
  },
  {
    key: "15",
    sno: 15,
    programName: "Ahmedabad - SG Highway",
    sbuName: "Oracle",
    departLocation: "Ahmedabad",
    packageName: "ORCL-FULL-PA",
    customPackageName: "Oracle Full PA",
    checks: "ORCL-FULL-PA - PAN, Aadhaar, Address, Employment, Education",
    status: true,
  },
  {
    key: "16",
    sno: 16,
    programName: "Jaipur - Malviya Nagar",
    sbuName: "Infosys",
    departLocation: "Jaipur",
    packageName: "INFY-STD-PA",
    customPackageName: "Infosys Standard PA",
    checks:
      "INFY-STD-PA - PAN, Aadhaar, Address Verification, Employment Check",
    status: false,
  },
  {
    key: "17",
    sno: 17,
    programName: "Nagpur - MIHAN",
    sbuName: "TCS",
    departLocation: "Nagpur",
    packageName: "TCS-FULL-PA",
    customPackageName: "TCS Full PA",
    checks:
      "TCS-FULL-PA - PAN, Aadhaar, Address, Employment, Education, Criminal Check",
    status: true,
  },
  {
    key: "18",
    sno: 18,
    programName: "Lucknow - Gomti Nagar",
    sbuName: "Wipro",
    departLocation: "Lucknow",
    packageName: "WIPRO-BASIC",
    customPackageName: "Wipro Basic PA",
    checks: "WIPRO-BASIC - PAN, Aadhaar, Address Verification",
    status: false,
  },
  {
    key: "19",
    sno: 19,
    programName: "Coimbatore - Avinashi Road",
    sbuName: "Cognizant",
    departLocation: "Coimbatore",
    packageName: "COGNI-FULL-PA",
    customPackageName: "Cognizant Full PA",
    checks: "COGNI-FULL-PA - PAN, Aadhaar, Address, Employment, Education",
    status: true,
  },
  {
    key: "20",
    sno: 20,
    programName: "Bhubaneswar - Infocity",
    sbuName: "Capgemini",
    departLocation: "Bhubaneswar",
    packageName: "CAPG-PLUS",
    customPackageName: "Capgemini Plus PA",
    checks: "CAPG-PLUS - PAN, Aadhaar, Employment, Education, Address",
    status: true,
  },
  {
    key: "21",
    sno: 21,
    programName: "Vadodara - Alkapuri",
    sbuName: "HCL",
    departLocation: "Vadodara",
    packageName: "HCL-FULL-PA",
    customPackageName: "HCL Full PA",
    checks: "HCL-FULL-PA - PAN, Aadhaar, Address, Employment, Education",
    status: false,
  },
  {
    key: "22",
    sno: 22,
    programName: "Mysore - Hebbal",
    sbuName: "IBM",
    departLocation: "Mysore",
    packageName: "IBM-PREMIUM",
    customPackageName: "IBM Premium PA",
    checks: "IBM-PREMIUM - PAN, Aadhaar, Criminal Check, Address, Employment",
    status: true,
  },
  {
    key: "23",
    sno: 23,
    programName: "Visakhapatnam - MVP Colony",
    sbuName: "Reliance",
    departLocation: "Visakhapatnam",
    packageName: "REL-FULL-PA",
    customPackageName: "Reliance Full PA",
    checks: "REL-FULL-PA - PAN, Aadhaar, Address, Employment, Education",
    status: true,
  },
];
// --------------------------------
export const dummyData_userSetup = [
  {
    key: "1",
    sno: 1,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Anuj Macker",
    username: "anuj.macker@techmahindra.com",
    email: "anuj.macker@techmahindra.com",
  },
  {
    key: "2",
    sno: 2,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Gaurav Kumar Kaushal",
    username: "gaurav.kaushal@techmahindra.com",
    email: "gaurav.kaushal@techmahindra.com",
  },
  {
    key: "3",
    sno: 3,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Pravin Raut",
    username: "pravin.raut@teleperformancedibs.com",
    email: "pravin.raut@teleperformancedibs.com",
  },
  {
    key: "4",
    sno: 4,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Pinto Gupta",
    username: "pinto.gupta@teleperformancedibs.com",
    email: "pinto.gupta@teleperformancedibs.com",
  },
  {
    key: "5",
    sno: 5,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Manoj Suvarna",
    username: "manoj.suvarna@teleperformancedibs.com",
    email: "manoj.suvarna@teleperformancedibs.com",
  },
  {
    key: "6",
    sno: 6,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Rahul Sharma",
    username: "rahul.sharma@techmahindra.com",
    email: "rahul.sharma@techmahindra.com",
  },
  {
    key: "7",
    sno: 7,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Neha Verma",
    username: "neha.verma@techmahindra.com",
    email: "neha.verma@techmahindra.com",
  },
  {
    key: "8",
    sno: 8,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Amit Singh",
    username: "amit.singh@techmahindra.com",
    email: "amit.singh@techmahindra.com",
  },
  {
    key: "9",
    sno: 9,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Priya Nair",
    username: "priya.nair@techmahindra.com",
    email: "priya.nair@techmahindra.com",
  },
  {
    key: "10",
    sno: 10,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Vikram Joshi",
    username: "vikram.joshi@techmahindra.com",
    email: "vikram.joshi@techmahindra.com",
  },
  {
    key: "11",
    sno: 11,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Sneha Patel",
    username: "sneha.patel@techmahindra.com",
    email: "sneha.patel@techmahindra.com",
  },
  {
    key: "12",
    sno: 12,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Karan Malhotra",
    username: "karan.malhotra@techmahindra.com",
    email: "karan.malhotra@techmahindra.com",
  },
  {
    key: "13",
    sno: 13,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Pooja Mehta",
    username: "pooja.mehta@techmahindra.com",
    email: "pooja.mehta@techmahindra.com",
  },
  {
    key: "14",
    sno: 14,
    clientName: "Tech Mahindra Limited",
    vendorName: "--",
    name: "Arjun Kapoor",
    username: "arjun.kapoor@techmahindra.com",
    email: "arjun.kapoor@techmahindra.com",
  },
];

// ========== /Master Vishnu =============

export const criminalData = [
  {
    key: "1",
    name: "Criminal/Court Record Status",
    category: "Criminal check via E-Court",
    description: "Record Found Against Candidate",
    tagStatus: "GREEN",
    status: true,
    updatedDate: "02 May 2025",
    log: "Default",
  },
  {
    key: "2",
    name: "Respondent - Criminal - Convicted",
    category: "Criminal check via E-Court",
    description: "Criminal record found against the candidate and convicted.",
    tagStatus: "RED",
    status: true,
    updatedDate: "02 May 2025",
    log: "Default",
  },
  {
    key: "3",
    name: "Respondent - Criminal - Not guilty",
    category: "Criminal check via E-Court",
    description: "Record found against the candidate but not found guilty.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "02 May 2025",
    log: "Default",
  },
  {
    key: "4",
    name: "Respondent - Civil - Convicted",
    category: "Criminal check via E-Court",
    description: "Civil record found against the applicant and convicted.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "02 May 2025",
    log: "Default",
  },
  {
    key: "5",
    name: "Petitioner - Criminal",
    category: "Criminal check via E-Court",
    description: "Candidate has filed a criminal case against someone.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "02 May 2025",
    log: "Default",
  },
  {
    key: "6",
    name: "Petitioner - Civil",
    category: "Criminal check via E-Court",
    description:
      "Civil record found where candidate has filed a civil case against someone.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "02 May 2025",
    log: "Default",
  },
  {
    key: "7",
    name: "Petitioner - Criminal - Bail",
    category: "Criminal check via E-Court",
    description: "Candidate has filed a bail application.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "02 May 2025",
    log: "Default",
  },
];

export const educationData = [
  {
    key: "1",
    name: "Year Of Passing Mismatch",
    category: "Year of passing stated is incorrect",
    description:
      "Year of passing of the candidate is not matched as per provided info from candidate (year of passing is 2010, verified is 2011)",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "2",
    name: "College Name Mismatch",
    category: "Different College",
    description:
      "Candidate has claimed that they had done their BE from IIT Delhi, however at the time of verification found that they have done B.E from Delhi Engineering College.",
    tagStatus: "RED",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "3",
    name: "Course Type",
    category: "Course Type",
    description: "Candidate stated regular course but has done correspondence.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "4",
    name: "Forged Document",
    category: "Fake Document",
    description: "Candidate has tampered with documents/marksheet/degree.",
    tagStatus: "RED",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "5",
    name: "Regulatory Affiliation",
    category: "Education",
    description: "University/College is not recognized with regulatory body.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "6",
    name: "Fake College/Institute",
    category: "Genuine Check",
    description: "Institute name found in Aupertz suspect list.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "7",
    name: "Applicant Name Mismatch",
    category: "Education",
    description:
      "Applicant name not matched - claimed vs verified data on document.",
    tagStatus: "RED",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
];

export const addressData = [
  {
    key: "addr_1",
    name: "Candidate Address Not Confirmed",
    category: "Address (Visit)",
    description:
      "During visit Home Owner/Landlord/Neighbor confirmed that no person by the candidate name resided.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "addr_2",
    name: "Candidate Address Not Confirmed",
    category: "Address (Telephonic)",
    description:
      "During call candidate stated another address than mentioned on form.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "addr_3",
    name: "Candidate Address Not Confirmed",
    category: "Address (Digital)",
    description: "Lat/Long coordinates do not match to address provided.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
];

export const panData = [
  {
    key: "pan_1",
    name: "Candidate Name Match",
    category: "PAN - Name",
    description:
      "Discrepancy is found in candidate name- name provided by candidate vs verified.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "pan_2",
    name: "Father Name Match",
    category: "PAN - DOC Validation",
    description:
      "Discrepancy found in candidate's father name (name provided by candidate vs mentioned on PAN Card).",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "pan_3",
    name: "Date Of Birth Mismatch",
    category: "PAN - Date of Birth",
    description:
      "Discrepancy found in candidate date of birth- date of birth provided by candidate vs verified.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
];

export const globalDatabaseData = [
  {
    key: "gdb_1",
    name: "Negative Record Found Status",
    category: "Global Search",
    description:
      "Applicant name features in Global negative list (Adverse remarks found).",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
];

export const aadhaarData = [
  {
    key: "aadh_1",
    name: "Record Status",
    category: "Aadhaar Records Status",
    description: "Aadhaar details not matched.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
];

export const internationalEducationData = [
  {
    key: "intl_edu_1",
    name: "Qualification Level Mismatch",
    category: "Qualification Not Matching",
    description:
      "Qualification level of the candidate is not matching. Stated Bachelor of Technology but has done Bachelor of Arts.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_2",
    name: "Year Of Passing Mismatch",
    category: "Year of passing stated is incorrect",
    description:
      "Year of passing of the candidate is not matched as per provided info from candidate, year of passing is 2010, verified is 2010.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_3",
    name: "Course Type",
    category: "Course Type",
    description: "Candidate stated regular course but has done correspondence.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_4",
    name: "Forged Document",
    category: "Fake Document",
    description: "Candidate has tampered with documents/marksheet/degree.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_5",
    name: "Regulatory Affiliation",
    category: "Education",
    description: "University/College is not recognized with regulatory body.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_6",
    name: "Non-Existence Of Institution",
    category: "non-existence of institution (Third party)",
    description:
      "Institution was operational when candidate has completed his degree. However because of their internal circumstance now institution has been closed / Denied to provide the verification of third party companies.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_7",
    name: "Institution Not Responding",
    category: "Institute not responding",
    description:
      "College/Institution may not respond back to us because of following issues: 1) No dedicated verification department 2) Verifier inbox is full / technical issue 3) High work load at institutions end 4) Climate issue. Note: Once the verification is received we will auto update the report.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_8",
    name: "Fake College/Institute",
    category: "Genuine Check",
    description: "Institute name found in Aupertz suspect list.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_9",
    name: "Applicant Name Mismatch",
    category: "Education",
    description:
      "Applicant name not matched - claimed vs verified data on document.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_10",
    name: "Course Name Mismatch",
    category: "Course Name Mismatch",
    description:
      "Course Name stated by candidate is not matched. Candidate stated Computer Science and verified is Information.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_edu_11",
    name: "Result Status",
    category: "Result Status",
    description: "Final result of the candidate verified as Fail/Backlog.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
];

export const internationalEmploymentData = [
  {
    key: "intl_emp_1",
    name: "Joining Date Greater Than 30 Days",
    category: "Date of Joining",
    description:
      "Candidate stated his/her employment with ABC Ltd from January 01, 2012 to June 20, 2013, however HR/Authorised person verified that candidate was employed for the period of February 10, 2012 to Apr 15, 2013.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_emp_2",
    name: "Relieving Date Greater Than 30 Days",
    category: "Date of relieving",
    description:
      "Candidate stated his/her employment with ABC Ltd from January 01, 2012 to June 20, 2013, however HR/Authorised person verified that candidate was employed for the period of January 01, 2012 to Apr 15, 2013.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_emp_3",
    name: "Relieving Date Greater Than 30 Days",
    category: "Date of relieving",
    description:
      "HR/Authorised person verified that candidate was employed for the period of January 01, 2012 to Apr 15, 2013.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_emp_4",
    name: "Applicant Designation Mismatched",
    category: "Mismatch in designation",
    description:
      "Candidate stated his/her designation as an Executive, however HR/Authorised person verified that candidate was working as an Associate.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_emp_5",
    name: "Is Candidate Eligible To Rehire (Termination/Absconding)",
    category: "Rehire",
    description:
      "Candidate is not eligible to rehire due to termination/absconding.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_emp_6",
    name: "Candidate Documents Not Genuine",
    category: "Forged/Tempered",
    description:
      "Documents/Relieving letter/Experience and Service certificates confirmed by HR/Authorised person as forged or fake in verification report.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "intl_emp_7",
    name: "Permanent/Contractual",
    category: "Nature of Employment",
    description:
      "Candidate has claimed his employment as permanent, however at the time of verification it was found that candidate was working as a part time employee of the company.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
];

export const criminalLawFirmData = [
  {
    key: "clf_1",
    name: "No Record Found Status",
    category: "Criminal Check Via Law Firm",
    description: "Record Found Against Candidate.",
    tagStatus: "GREEN",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "clf_2",
    name: "Respondent - Criminal - Convicted",
    category: "Criminal Check Via Law Firm",
    description: "Criminal record found against the candidate and convicted.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "clf_3",
    name: "Respondent - Criminal - Not guilty",
    category: "Criminal Check Via Law Firm",
    description: "Record found against the candidate but not found guilty.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "clf_4",
    name: "Respondent - Civil - Convicted",
    category: "Criminal Check Via Law Firm",
    description: "Civil record found against the applicant and convicted.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "clf_5",
    name: "Petitioner - Criminal",
    category: "Criminal Check Via Law Firm",
    description: "Candidate has filed a criminal case against someone.",
    tagStatus: "GREEN",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "clf_6",
    name: "Petitioner - Civil",
    category: "Criminal Check Via Law Firm",
    description:
      "Civil record found where candidate has filed a civil case against someone.",
    tagStatus: "GREEN",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "clf_7",
    name: "Petitioner - Criminal - Bail",
    category: "Criminal Check Via Law Firm",
    description: "Candidate has filed a bail application.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
  {
    key: "clf_8",
    name: "Respondent - Criminal - Ongoing",
    category: "Criminal Check Via Law Firm",
    description: "Court record found in criminal matter and case is ongoing.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
];

export const employmentData = [
  {
    key: "emp_1",
    name: "Joining Date Greater Than 30 Days",
    category: "Date of Joining",
    description:
      "Candidate stated his/her employment with ABC Ltd from January 01, 2012 to June 20, 2013, however HR/Authorised person verified that candidate was employed for the period of February 10, 2012 to Apr 15, 2013.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "emp_2",
    name: "Relieving Date Greater Than 30 Days",
    category: "Date of relieving",
    description:
      "Candidate stated his/her employment with ABC Ltd from January 01, 2012 to June 20, 2013, however HR/Authorised person verified that candidate was employed for the period of January 01, 2012 to Apr 15, 2013.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "emp_3",
    name: "Relieving Date Greater Than 30 Days",
    category: "Date of relieving",
    description:
      "HR/Authorised person verified that candidate was employed for the period of January 01, 2012 to Apr 15, 2013.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "emp_4",
    name: "Applicant Designation Mismatched",
    category: "Mismatch in designation",
    description:
      "Candidate stated his/her designation as an Executive, however HR/Authorised person verified that candidate was working as an Associate.",
    tagStatus: "YELLOW",
    status: true,
    updatedDate: "20 Mar 2025",
    log: "Default",
  },
  {
    key: "emp_5",
    name: "Is Candidate Eligible To Rehire (Termination/Absconding)",
    category: "Rehire",
    description:
      "Candidate is not eligible to rehire due to termination/absconding.",
    tagStatus: "RED",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "emp_6",
    name: "Candidate Documents Genuiness",
    category: "Forged/Tempered",
    description:
      "Documents/Relieving letter/Experience and Service certificates confirmed by HR/Authorised person as forged or fake in verification report.",
    tagStatus: "RED",
    status: true,
    updatedDate: "01 May 2025",
    log: "Default",
  },
  {
    key: "emp_7",
    name: "Permanent/Contractual",
    category: "Nature of Employment",
    description:
      "Candidate has claimed his employment as permanent, however at the time of verification it was found that candidate was working as a part time employee of the company.",
    tagStatus: "RED",
    status: true,
    updatedDate: "-",
    log: "Default",
  },
];

// ========== //  Rolodex Data  // =========
// ------------ College Data --------------
export const collegeOptions = [
  {
    id: 1,
    label: "St. Xavier's College, Mumbai",
    status: "genuine",
    type: "college",
  },
  {
    id: 2,
    label: "Greenfield College of Commerce",
    status: "suspected fake",
    type: "college",
  },
  {
    id: 3,
    label: "Royal College of Arts and Science",
    status: "genuine",
    type: "college",
  },
  {
    id: 4,
    label: "Horizon Degree College",
    status: "suspected fake",
    type: "college",
  },
  {
    id: 5,
    label: "City College of Management",
    status: "genuine",
    type: "college",
  },
  {
    id: 6,
    label: "Elite College of Engineering",
    status: "genuine",
    type: "college",
  },
  {
    id: 7,
    label: "National Commerce College",
    status: "suspected fake",
    type: "college",
  },
  {
    id: 8,
    label: "Pinnacle College of Technology",
    status: "genuine",
    type: "college",
  },
  {
    id: 9,
    label: "Oxford College of Business Studies",
    status: "suspected fake",
    type: "college",
  },
  {
    id: 10,
    label: "Heritage College of Education",
    status: "genuine",
    type: "college",
  },
];

export const collegeDetailsMap = {
  1: {
    registrationNo: "MU-COL-1869-001",
    dateOfRegistration: "12-06-1869",
    affiliatedUniversity: "University of Mumbai",
    collegeStatus: "Genuine",
    averageTime: "5 days",
    type: "Arts & Science",
    previousAffiliationStatus: "Active",
    affiliationBody: "NAAC",
    affiliationTo: "30-06-2027",
    affiliatedTo: "2027",
    affiliationStatus: "Active",
    affiliationFrom: "01-07-2022",
    disposition: "-",
    address: {
      line1: "5, Mahapalika Marg, Dhobi Talao",
      country: "India",
      state: "Maharashtra",
      city: "Mumbai",
    },
  },
  2: {
    registrationNo: "DL-COL-2003-047",
    dateOfRegistration: "15-03-2003",
    affiliatedUniversity: "Guru Gobind Singh Indraprastha University",
    collegeStatus: "Suspected Fake",
    averageTime: "8 days",
    type: "Commerce",
    previousAffiliationStatus: "-",
    affiliationBody: "UGC",
    affiliationTo: "31-03-2022",
    affiliatedTo: "2022",
    affiliationStatus: "Expired",
    affiliationFrom: "01-04-2017",
    disposition: "-",
    address: {
      line1: "Plot No. 12, Sector 9, Dwarka",
      country: "India",
      state: "Delhi",
      city: "New Delhi",
    },
  },
  3: {
    registrationNo: "KA-COL-1995-112",
    dateOfRegistration: "20-07-1995",
    affiliatedUniversity: "Bangalore University",
    collegeStatus: "Genuine",
    averageTime: "4 days",
    type: "Arts & Science",
    previousAffiliationStatus: "Active",
    affiliationBody: "NAAC",
    affiliationTo: "30-06-2026",
    affiliatedTo: "2026",
    affiliationStatus: "Active",
    affiliationFrom: "01-07-2021",
    disposition: "-",
    address: {
      line1: "No. 45, Residency Road, Shivajinagar",
      country: "India",
      state: "Karnataka",
      city: "Bengaluru",
    },
  },
  4: {
    registrationNo: "RJ-COL-2008-233",
    dateOfRegistration: "10-01-2008",
    affiliatedUniversity: "University of Rajasthan",
    collegeStatus: "Suspected Fake",
    averageTime: "10 days",
    type: "General",
    previousAffiliationStatus: "-",
    affiliationBody: "UGC",
    affiliationTo: "31-03-2021",
    affiliatedTo: "2021",
    affiliationStatus: "Expired",
    affiliationFrom: "01-04-2016",
    disposition: "-",
    address: {
      line1: "B-14, Malviya Nagar Industrial Area",
      country: "India",
      state: "Rajasthan",
      city: "Jaipur",
    },
  },
  5: {
    registrationNo: "TN-COL-2000-089",
    dateOfRegistration: "05-09-2000",
    affiliatedUniversity: "University of Madras",
    collegeStatus: "Genuine",
    averageTime: "6 days",
    type: "Management",
    previousAffiliationStatus: "Active",
    affiliationBody: "AICTE",
    affiliationTo: "30-09-2026",
    affiliatedTo: "2026",
    affiliationStatus: "Active",
    affiliationFrom: "01-10-2021",
    disposition: "-",
    address: {
      line1: "No. 78, Anna Salai, Teynampet",
      country: "India",
      state: "Tamil Nadu",
      city: "Chennai",
    },
  },
  6: {
    registrationNo: "MH-COL-1998-321",
    dateOfRegistration: "22-08-1998",
    affiliatedUniversity: "Savitribai Phule Pune University",
    collegeStatus: "Genuine",
    averageTime: "5 days",
    type: "Engineering",
    previousAffiliationStatus: "Active",
    affiliationBody: "AICTE",
    affiliationTo: "31-05-2027",
    affiliatedTo: "2027",
    affiliationStatus: "Active",
    affiliationFrom: "01-06-2022",
    disposition: "-",
    address: {
      line1: "Survey No. 58, Pune-Nashik Highway, Sector 4",
      country: "India",
      state: "Maharashtra",
      city: "Pune",
    },
  },
  7: {
    registrationNo: "UP-COL-2010-178",
    dateOfRegistration: "18-04-2010",
    affiliatedUniversity: "Chhatrapati Shahu Ji Maharaj University",
    collegeStatus: "Suspected Fake",
    averageTime: "12 days",
    type: "Commerce",
    previousAffiliationStatus: "-",
    affiliationBody: "UGC",
    affiliationTo: "31-03-2020",
    affiliatedTo: "2020",
    affiliationStatus: "Expired",
    affiliationFrom: "01-04-2015",
    disposition: "-",
    address: {
      line1: "Plot 22, Civil Lines, Near Collectorate",
      country: "India",
      state: "Uttar Pradesh",
      city: "Kanpur",
    },
  },
  8: {
    registrationNo: "GJ-COL-2002-054",
    dateOfRegistration: "14-11-2002",
    affiliatedUniversity: "Gujarat Technological University",
    collegeStatus: "Genuine",
    averageTime: "4 days",
    type: "Technology",
    previousAffiliationStatus: "Active",
    affiliationBody: "AICTE",
    affiliationTo: "31-08-2027",
    affiliatedTo: "2027",
    affiliationStatus: "Active",
    affiliationFrom: "01-09-2022",
    disposition: "-",
    address: {
      line1: "Block A, GIDC Estate, Chandkheda",
      country: "India",
      state: "Gujarat",
      city: "Ahmedabad",
    },
  },
  9: {
    registrationNo: "WB-COL-2006-267",
    dateOfRegistration: "30-06-2006",
    affiliatedUniversity: "University of Calcutta",
    collegeStatus: "Suspected Fake",
    averageTime: "9 days",
    type: "Business Studies",
    previousAffiliationStatus: "-",
    affiliationBody: "UGC",
    affiliationTo: "30-06-2021",
    affiliatedTo: "2021",
    affiliationStatus: "Expired",
    affiliationFrom: "01-07-2016",
    disposition: "-",
    address: {
      line1: "14/2, Camac Street, Park Street Area",
      country: "India",
      state: "West Bengal",
      city: "Kolkata",
    },
  },
  10: {
    registrationNo: "KL-COL-1993-038",
    dateOfRegistration: "03-03-1993",
    affiliatedUniversity: "University of Kerala",
    collegeStatus: "Genuine",
    averageTime: "5 days",
    type: "Education",
    previousAffiliationStatus: "Active",
    affiliationBody: "NAAC",
    affiliationTo: "31-03-2027",
    affiliatedTo: "2027",
    affiliationStatus: "Active",
    affiliationFrom: "01-04-2022",
    disposition: "-",
    address: {
      line1: "TC 25/1490, Statue Road, Vellayambalam",
      country: "India",
      state: "Kerala",
      city: "Thiruvananthapuram",
    },
  },
};

// ------------ College Data --------------

// ========== // end Rolodex Data  // =========

// ========== // View Order Data  // =========
export const dummydata_viewOrders = [
  {
    key: "1",
    orderId: "ORD-1001",
    createdOn: "01-07-2025",
    valid: 45,
    invalid: 5,
    packageAmount: 1000,
    packageDesc: "Basic Verification Package",
    packageId: "PKG-BASIC",
    totalAmount: 50000,
  },
  {
    key: "2",
    orderId: "ORD-1002",
    createdOn: "03-07-2025",
    valid: 80,
    invalid: 10,
    packageAmount: 1500,
    packageDesc: "Standard Verification Package",
    packageId: "PKG-STD",
    totalAmount: 135000,
  },
  {
    key: "3",
    orderId: "ORD-1003",
    createdOn: "05-07-2025",
    valid: 120,
    invalid: 15,
    packageAmount: 2000,
    packageDesc: "Premium Verification Package",
    packageId: "PKG-PRM",
    totalAmount: 270000,
  },
  {
    key: "4",
    orderId: "ORD-1004",
    createdOn: "08-07-2025",
    valid: 60,
    invalid: 8,
    packageAmount: 1200,
    packageDesc: "College Verification Package",
    packageId: "PKG-COL",
    totalAmount: 81600,
  },
  {
    key: "5",
    orderId: "ORD-1005",
    createdOn: "10-07-2025",
    valid: 95,
    invalid: 12,
    packageAmount: 1800,
    packageDesc: "University Verification Package",
    packageId: "PKG-UNI",
    totalAmount: 192600,
  },
];
// ========== // end View Order Data  // =========

// ========== // LOB Data  // =========
export const dummydata_lobData = [
  {
    s_no: 1,
    department_code: "ACC001",
    department_name: "Finance",
    program_name: "Accounts Payable",
    department_status: "Active",
  },
  {
    s_no: 2,
    department_code: "ACC002",
    department_name: "Human Resources",
    program_name: "Employee Onboarding",
    department_status: "Active",
  },
  {
    s_no: 3,
    department_code: "ACC003",
    department_name: "Information Technology",
    program_name: "Infrastructure Support",
    department_status: "Active",
  },
  {
    s_no: 4,
    department_code: "ACC004",
    department_name: "Operations",
    program_name: "Process Management",
    department_status: "Inactive",
  },
  {
    s_no: 5,
    department_code: "ACC005",
    department_name: "Sales",
    program_name: "Sales Enablement",
    department_status: "Active",
  },
  {
    s_no: 6,
    department_code: "ACC006",
    department_name: "Marketing",
    program_name: "Digital Marketing",
    department_status: "Active",
  },
  {
    s_no: 7,
    department_code: "ACC007",
    department_name: "Legal",
    program_name: "Contract Management",
    department_status: "Inactive",
  },
  {
    s_no: 8,
    department_code: "ACC008",
    department_name: "Procurement",
    program_name: "Vendor Management",
    department_status: "Active",
  },
  {
    s_no: 9,
    department_code: "ACC009",
    department_name: "Customer Support",
    program_name: "Customer Success",
    department_status: "Active",
  },
  {
    s_no: 10,
    department_code: "ACC010",
    department_name: "Research & Development",
    program_name: "Innovation Lab",
    department_status: "Active",
  },
  {
    s_no: 11,
    department_code: "ACC011",
    department_name: "Quality Assurance",
    program_name: "Quality Audits",
    department_status: "Inactive",
  },
  {
    s_no: 12,
    department_code: "ACC012",
    department_name: "Administration",
    program_name: "Facility Management",
    department_status: "Active",
  },
  {
    s_no: 13,
    department_code: "ACC013",
    department_name: "Compliance",
    program_name: "Regulatory Compliance",
    department_status: "Active",
  },
  {
    s_no: 14,
    department_code: "ACC014",
    department_name: "Business Development",
    program_name: "Strategic Partnerships",
    department_status: "Active",
  },
  {
    s_no: 15,
    department_code: "ACC015",
    department_name: "Risk Management",
    program_name: "Enterprise Risk",
    department_status: "Inactive",
  },
  {
    s_no: 16,
    department_code: "ACC016",
    department_name: "Training",
    program_name: "Learning & Development",
    department_status: "Active",
  },
];
// ========== // end LOB Data  // =========

// ========== // User Data  // =========
export const dummydata_users = [
  {
    sno: 1,
    user_name: "Aarav Sharma",
    contact: "9876543210",
    email: "aarav.sharma@example.com",
    user_type: "Manager",
    status: "Active",
  },
  {
    sno: 2,
    user_name: "Priya Verma",
    contact: "9812345678",
    email: "priya.verma@example.com",
    user_type: "Verifier",
    status: "Inactive",
  },
  {
    sno: 3,
    user_name: "Rohan Mehta",
    contact: "9988776655",
    email: "rohan.mehta@example.com",
    user_type: "Verifier",
    status: "Active",
  },
  {
    sno: 4,
    user_name: "Sneha Kapoor",
    contact: "9765432109",
    email: "sneha.kapoor@example.com",
    user_type: "Manager",
    status: "Active",
  },
  {
    sno: 5,
    user_name: "Aditya Singh",
    contact: "9123456789",
    email: "aditya.singh@example.com",
    user_type: "Verifier",
    status: "Inactive",
  },
  {
    sno: 6,
    user_name: "Neha Joshi",
    contact: "9345678901",
    email: "neha.joshi@example.com",
    user_type: "Manager",
    status: "Inactive",
  },
  {
    sno: 7,
    user_name: "Karan Malhotra",
    contact: "9898123456",
    email: "karan.malhotra@example.com",
    user_type: "Verifier",
    status: "Active",
  },
  {
    sno: 8,
    user_name: "Ananya Gupta",
    contact: "9001122334",
    email: "ananya.gupta@example.com",
    user_type: "Manager",
    status: "Inactive",
  },
  {
    sno: 9,
    user_name: "Vikram Rao",
    contact: "9887766554",
    email: "vikram.rao@example.com",
    user_type: "Verifier",
    status: "Active",
  },
  {
    sno: 10,
    user_name: "Meera Nair",
    contact: "9654321098",
    email: "meera.nair@example.com",
    user_type: "Manager",
    status: "Active",
  },
  {
    sno: 11,
    user_name: "Rahul Choudhary",
    contact: "9871234560",
    email: "rahul.choudhary@example.com",
    user_type: "Verifier",
    status: "Inactive",
  },
  {
    sno: 12,
    user_name: "Isha Bansal",
    contact: "9911223344",
    email: "isha.bansal@example.com",
    user_type: "Manager",
    status: "Active",
  },
  {
    sno: 13,
    user_name: "Yash Patel",
    contact: "9789012345",
    email: "yash.patel@example.com",
    user_type: "Verifier",
    status: "Inactive",
  },
  {
    sno: 14,
    user_name: "Pooja Desai",
    contact: "9822334455",
    email: "pooja.desai@example.com",
    user_type: "Manager",
    status: "Inactive",
  },
  {
    sno: 15,
    user_name: "Arjun Khanna",
    contact: "9966554433",
    email: "arjun.khanna@example.com",
    user_type: "Verifier",
    status: "Active",
  },
  {
    sno: 16,
    user_name: "Nidhi Saxena",
    contact: "9090901234",
    email: "nidhi.saxena@example.com",
    user_type: "Manager",
    status: "Inactive",
  },
  {
    sno: 17,
    user_name: "Harsh Agarwal",
    contact: "9867543210",
    email: "harsh.agarwal@example.com",
    user_type: "Manager",
    status: "Active",
  },
  {
    sno: 18,
    user_name: "Simran Kaur",
    contact: "9753186420",
    email: "simran.kaur@example.com",
    user_type: "Verifier",
    status: "Active",
  },
];
// ========== // end User Data  // =========

// ========== // verifier Data  // =========
export const dummydata_verifiers = [
  {
    sno: 1,
    user_name: "Aarav Sharma",
    contact: "9876543210",
    email: "aarav.sharma@example.com",
    user_type: "Verifier",
    manager_name: "Rohit Malhotra",
    status: "Active",
  },
  {
    sno: 2,
    user_name: "Priya Verma",
    contact: "9812345678",
    email: "priya.verma@example.com",
    user_type: "Verifier",
    manager_name: "Neha Kapoor",
    status: "Inactive",
  },
  {
    sno: 3,
    user_name: "Rohan Mehta",
    contact: "9988776655",
    email: "rohan.mehta@example.com",
    user_type: "Verifier",
    manager_name: "Ankit Sharma",
    status: "Active",
  },
  {
    sno: 4,
    user_name: "Sneha Kapoor",
    contact: "9765432109",
    email: "sneha.kapoor@example.com",
    user_type: "Verifier",
    manager_name: "Pooja Singh",
    status: "Active",
  },
  {
    sno: 5,
    user_name: "Aditya Singh",
    contact: "9123456789",
    email: "aditya.singh@example.com",
    user_type: "Verifier",
    manager_name: "Vikas Mehra",
    status: "Inactive",
  },
  {
    sno: 6,
    user_name: "Neha Joshi",
    contact: "9345678901",
    email: "neha.joshi@example.com",
    user_type: "Verifier",
    manager_name: "Rohit Malhotra",
    status: "Inactive",
  },
  {
    sno: 7,
    user_name: "Karan Malhotra",
    contact: "9898123456",
    email: "karan.malhotra@example.com",
    user_type: "Verifier",
    manager_name: "Ankit Sharma",
    status: "Active",
  },
  {
    sno: 8,
    user_name: "Ananya Gupta",
    contact: "9001122334",
    email: "ananya.gupta@example.com",
    user_type: "Verifier",
    manager_name: "Neha Kapoor",
    status: "Inactive",
  },
  {
    sno: 9,
    user_name: "Vikram Rao",
    contact: "9887766554",
    email: "vikram.rao@example.com",
    user_type: "Verifier",
    manager_name: "Pooja Singh",
    status: "Active",
  },
  {
    sno: 10,
    user_name: "Meera Nair",
    contact: "9654321098",
    email: "meera.nair@example.com",
    user_type: "Verifier",
    manager_name: "Vikas Mehra",
    status: "Active",
  },
  {
    sno: 11,
    user_name: "Rahul Choudhary",
    contact: "9871234560",
    email: "rahul.choudhary@example.com",
    user_type: "Verifier",
    manager_name: "Rohit Malhotra",
    status: "Inactive",
  },
  {
    sno: 12,
    user_name: "Isha Bansal",
    contact: "9911223344",
    email: "isha.bansal@example.com",
    user_type: "Verifier",
    manager_name: "Neha Kapoor",
    status: "Active",
  },
  {
    sno: 13,
    user_name: "Yash Patel",
    contact: "9789012345",
    email: "yash.patel@example.com",
    user_type: "Verifier",
    manager_name: "Ankit Sharma",
    status: "Inactive",
  },
];
// ========== // end verifier Data  // =========

// ==========  manager Data  // =========
export const dummydata_managers = [
  {
    sno: 1,
    manager_name: "Rohit Malhotra",
    email: "rohit.malhotra@example.com",
    contact: "9876543210",
    programs: ["B.Tech", "MBA", "MCA"],
  },
  {
    sno: 2,
    manager_name: "Neha Kapoor",
    email: "neha.kapoor@example.com",
    contact: "9812345678",
    programs: ["BBA", "B.Com"],
  },
  {
    sno: 3,
    manager_name: "Ankit Sharma",
    email: "ankit.sharma@example.com",
    contact: "9988776655",
    programs: ["B.Tech", "M.Tech", "Diploma"],
  },
  {
    sno: 4,
    manager_name: "Pooja Singh",
    email: "pooja.singh@example.com",
    contact: "9765432109",
    programs: ["MBA", "M.Com"],
  },
  {
    sno: 5,
    manager_name: "Vikas Mehra",
    email: "vikas.mehra@example.com",
    contact: "9123456789",
    programs: ["B.Sc", "M.Sc", "BCA"],
  },
  {
    sno: 6,
    manager_name: "Sonia Verma",
    email: "sonia.verma@example.com",
    contact: "9345678901",
    programs: ["BCA", "MCA"],
  },
  {
    sno: 7,
    manager_name: "Rahul Choudhary",
    email: "rahul.choudhary@example.com",
    contact: "9898123456",
    programs: ["B.Tech", "BBA"],
  },
  {
    sno: 8,
    manager_name: "Meera Nair",
    email: "meera.nair@example.com",
    contact: "9001122334",
    programs: ["MBA", "PGDM", "B.Com"],
  },
  {
    sno: 9,
    manager_name: "Karan Gupta",
    email: "karan.gupta@example.com",
    contact: "9887766554",
    programs: ["B.Pharm", "M.Pharm"],
  },
  {
    sno: 10,
    manager_name: "Isha Bansal",
    email: "isha.bansal@example.com",
    contact: "9654321098",
    programs: ["B.Tech", "BCA", "MCA"],
  },
  {
    sno: 11,
    manager_name: "Arjun Khanna",
    email: "arjun.khanna@example.com",
    contact: "9871234560",
    programs: ["B.Sc", "MBA"],
  },
  {
    sno: 12,
    manager_name: "Nidhi Saxena",
    email: "nidhi.saxena@example.com",
    contact: "9911223344",
    programs: ["MCA", "M.Tech"],
  },
  {
    sno: 13,
    manager_name: "Harsh Agarwal",
    email: "harsh.agarwal@example.com",
    contact: "9789012345",
    programs: ["BBA", "MBA", "B.Com"],
  },
  {
    sno: 14,
    manager_name: "Simran Kaur",
    email: "simran.kaur@example.com",
    contact: "9822334455",
    programs: ["B.Tech", "BCA"],
  },
  {
    sno: 15,
    manager_name: "Aditi Desai",
    email: "aditi.desai@example.com",
    contact: "9966554433",
    programs: ["M.Sc", "B.Sc", "B.Ed"],
  },
  {
    sno: 16,
    manager_name: "Vivek Patel",
    email: "vivek.patel@example.com",
    contact: "9090901234",
    programs: ["Diploma", "B.Tech", "MBA"],
  },
];
// ========== // end manager Data  // =========

// ========== // verifier Data  // =========
export const dummydata_verifier = [
  {
    sno: 1,
    case_id: "357238",
    case_spoc: "Shubham Pal",
    employee_id: "CAND-1054000",
    case_received_date: "22-04-2026",
    submission_date: "22-04-2026",
  },
  {
    sno: 2,
    case_id: "357239",
    case_spoc: "Priya Singh",
    employee_id: "CAND-1054001",
    case_received_date: "23-04-2026",
    submission_date: "24-04-2026",
  },
  {
    sno: 3,
    case_id: "357240",
    case_spoc: "Rajesh Kumar",
    employee_id: "CAND-1054002",
    case_received_date: "21-04-2026",
    submission_date: "25-04-2026",
  },
  {
    sno: 4,
    case_id: "357241",
    case_spoc: "Anjali Verma",
    employee_id: "CAND-1054003",
    case_received_date: "20-04-2026",
    submission_date: "23-04-2026",
  },
  {
    sno: 5,
    case_id: "357242",
    case_spoc: "Vikram Patel",
    employee_id: "CAND-1054004",
    case_received_date: "19-04-2026",
    submission_date: "22-04-2026",
  },
  {
    sno: 6,
    case_id: "357243",
    case_spoc: "Neha Sharma",
    employee_id: "CAND-1054005",
    case_received_date: "24-04-2026",
    submission_date: "26-04-2026",
  },
  {
    sno: 7,
    case_id: "357244",
    case_spoc: "Arjun Gupta",
    employee_id: "CAND-1054006",
    case_received_date: "18-04-2026",
    submission_date: "21-04-2026",
  },
  {
    sno: 8,
    case_id: "357245",
    case_spoc: "Deepika Nair",
    employee_id: "CAND-1054007",
    case_received_date: "25-04-2026",
    submission_date: "25-04-2026",
  },
];
// ========== // end verifier Data  // =========

// ========= admin manager programs ===========
export const dummy_managerPrograms = [
  {
    organization: "TechNova Foundation",
    project: "Digital Literacy Initiative",
    location: "New York, USA",
    program: "Coding for Youth",
    department: "Education",
  },
  {
    organization: "Green Earth NGO",
    project: "Climate Action Campaign",
    location: "Nairobi, Kenya",
    program: "Tree Plantation Drive",
    department: "Environment",
  },
  {
    organization: "HealthFirst Trust",
    project: "Community Wellness",
    location: "Mumbai, India",
    program: "Free Health Screening",
    department: "Healthcare",
  },
  {
    organization: "Future Skills Academy",
    project: "Workforce Development",
    location: "Toronto, Canada",
    program: "AI & Data Science Bootcamp",
    department: "Training",
  },
  {
    organization: "Hope Foundation",
    project: "Women Empowerment",
    location: "Dhaka, Bangladesh",
    program: "Entrepreneurship Training",
    department: "Community Development",
  },
  {
    organization: "AgriGrow Initiative",
    project: "Sustainable Farming",
    location: "Lagos, Nigeria",
    program: "Organic Farming Workshop",
    department: "Agriculture",
  },
  {
    organization: "EduBridge Society",
    project: "School Improvement",
    location: "Kathmandu, Nepal",
    program: "Teacher Capacity Building",
    department: "Education",
  },
  {
    organization: "SafeFuture Alliance",
    project: "Disaster Preparedness",
    location: "Manila, Philippines",
    program: "Emergency Response Training",
    department: "Disaster Management",
  },
  {
    organization: "Youth Connect",
    project: "Career Readiness",
    location: "Sydney, Australia",
    program: "Internship Preparation",
    department: "Human Resources",
  },
  {
    organization: "Water for All",
    project: "Clean Water Access",
    location: "Addis Ababa, Ethiopia",
    program: "Water Sanitation Awareness",
    department: "Public Health",
  },
];

export const dummy_managerFilteredProgram = [
  {
    organization: "TechNova Foundation",
    project: "Digital Literacy Initiative",
    location: "New York, USA",
    program: "Coding for Youth",
    department: "Education",
  },
  {
    organization: "TechNova Foundation",
    project: "Digital Literacy Initiative",
    location: "New York, USA",
    program: "Web Development Basics",
    department: "Education",
  },
  {
    organization: "TechNova Foundation",
    project: "Digital Literacy Initiative",
    location: "New York, USA",
    program: "Cybersecurity Awareness",
    department: "Education",
  },
  {
    organization: "TechNova Foundation",
    project: "Digital Literacy Initiative",
    location: "New York, USA",
    program: "Data Analytics Fundamentals",
    department: "Education",
  },
  {
    organization: "TechNova Foundation",
    project: "Digital Literacy Initiative",
    location: "New York, USA",
    program: "Mobile App Development",
    department: "Education",
  },
];
// ========= // end admin manager programs ===========
